export const STUDY_TYPES = [
  {
    value: "Interventional",
    label: "Interventional",
    translations: {
      jp: "介入研究",
    },
    registries: {
      eupas: "Clinical trial",
    },
  },
  {
    value: "Observational",
    label: "Observational",
    translations: {
      jp: "観察研究",
    },
    registries: {
      eupas: "Non-interventional study",
    },
  },
  {
    value: "Expanded Access",
    label: "Expanded Access",
    translations: {
      jp: "その他",
    },
    registries: {
      jrct: "Other",
      eupas: "Not applicable",
    },
  },
]

export const COUNTRIES = [
  {
    value: "Unselected",
    label: "Unselected",
  },
  {
    value: "Afghanistan",
    label: "Afghanistan",
  },
  {
    value: "Albania",
    label: "Albania",
  },
  {
    value: "Algeria",
    label: "Algeria",
  },
  {
    value: "Andorra",
    label: "Andorra",
  },
  {
    value: "Angola",
    label: "Angola",
  },
  {
    value: "Antigua and Barbuda",
    label: "Antigua and Barbuda",
  },
  {
    value: "Argentina",
    label: "Argentina",
  },
  {
    value: "Armenia",
    label: "Armenia",
  },
  {
    value: "Australia",
    label: "Australia",
  },
  {
    value: "Austria",
    label: "Austria",
  },
  {
    value: "Azerbaijan",
    label: "Azerbaijan",
  },
  {
    value: "The Bahamas",
    label: "The Bahamas",
  },
  {
    value: "Bahrain",
    label: "Bahrain",
  },
  {
    value: "Bangladesh",
    label: "Bangladesh",
  },
  {
    value: "Barbados",
    label: "Barbados",
  },
  {
    value: "Belarus",
    label: "Belarus",
  },
  {
    value: "Belgium",
    label: "Belgium",
  },
  {
    value: "Belize",
    label: "Belize",
  },
  {
    value: "Benin",
    label: "Benin",
  },
  {
    value: "Bhutan",
    label: "Bhutan",
  },
  {
    value: "Bolivia",
    label: "Bolivia",
  },
  {
    value: "Bosnia and Herzegovina",
    label: "Bosnia and Herzegovina",
  },
  {
    value: "Botswana",
    label: "Botswana",
  },
  {
    value: "Brazil",
    label: "Brazil",
  },
  {
    value: "Brunei",
    label: "Brunei",
  },
  {
    value: "Bulgaria",
    label: "Bulgaria",
  },
  {
    value: "Burkina Faso",
    label: "Burkina Faso",
  },
  {
    value: "Burundi",
    label: "Burundi",
  },
  {
    value: "Cambodia",
    label: "Cambodia",
  },
  {
    value: "Cameroon",
    label: "Cameroon",
  },
  {
    value: "Canada",
    label: "Canada",
  },
  {
    value: "Cape Verde",
    label: "Cape Verde",
  },
  {
    value: "Central African Republic",
    label: "Central African Republic",
  },
  {
    value: "Chad",
    label: "Chad",
  },
  {
    value: "Czechia",
    label: "Czechia",
  },
  {
    value: "Chile",
    label: "Chile",
  },
  {
    value: "China",
    label: "China",
  },
  {
    value: "Colombia",
    label: "Colombia",
  },
  {
    value: "Comoros",
    label: "Comoros",
  },
  {
    value: "Congo, Republic of the",
    label: "Congo, Republic of the",
  },
  {
    value: "Congo, Democratic Republic of the",
    label: "Congo, Democratic Republic of the",
  },
  {
    value: "Costa Rica",
    label: "Costa Rica",
  },
  {
    value: "Cote d'Ivoire",
    label: "Cote d'Ivoire",
  },
  {
    value: "Croatia",
    label: "Croatia",
  },
  {
    value: "Cuba",
    label: "Cuba",
  },
  {
    value: "Cyprus",
    label: "Cyprus",
  },
  {
    value: "Czech Republic",
    label: "Czech Republic",
  },
  {
    value: "Denmark",
    label: "Denmark",
  },
  {
    value: "Djibouti",
    label: "Djibouti",
  },
  {
    value: "Dominica",
    label: "Dominica",
  },
  {
    value: "Dominican Republic",
    label: "Dominican Republic",
  },
  {
    value: "East Timor (Timor-Leste)",
    label: "East Timor (Timor-Leste)",
  },
  {
    value: "Ecuador",
    label: "Ecuador",
  },
  {
    value: "Egypt",
    label: "Egypt",
  },
  {
    value: "El Salvador",
    label: "El Salvador",
  },
  {
    value: "Equatorial Guinea",
    label: "Equatorial Guinea",
  },
  {
    value: "Eritrea",
    label: "Eritrea",
  },
  {
    value: "Estonia",
    label: "Estonia",
  },
  {
    value: "Ethiopia",
    label: "Ethiopia",
  },
  {
    value: "Fiji",
    label: "Fiji",
  },
  {
    value: "Finland",
    label: "Finland",
  },
  {
    value: "France",
    label: "France",
  },
  {
    value: "Gabon",
    label: "Gabon",
  },
  {
    value: "The Gambia",
    label: "The Gambia",
  },
  {
    value: "Georgia",
    label: "Georgia",
  },
  {
    value: "Germany",
    label: "Germany",
  },
  {
    value: "Ghana",
    label: "Ghana",
  },
  {
    value: "Greece",
    label: "Greece",
  },
  {
    value: "Grenada",
    label: "Grenada",
  },
  {
    value: "Guatemala",
    label: "Guatemala",
  },
  {
    value: "Guinea",
    label: "Guinea",
  },
  {
    value: "Guinea-Bissau",
    label: "Guinea-Bissau",
  },
  {
    value: "Guyana",
    label: "Guyana",
  },
  {
    value: "Haiti",
    label: "Haiti",
  },
  {
    value: "Honduras",
    label: "Honduras",
  },
  {
    value: "Hong Kong",
    label: "Hong Kong",
  },
  {
    value: "Hungary",
    label: "Hungary",
  },
  {
    value: "Iceland",
    label: "Iceland",
  },
  {
    value: "India",
    label: "India",
  },
  {
    value: "Indonesia",
    label: "Indonesia",
  },
  {
    value: "Iran",
    label: "Iran",
  },
  {
    value: "Iraq",
    label: "Iraq",
  },
  {
    value: "Ireland",
    label: "Ireland",
  },
  {
    value: "Israel",
    label: "Israel",
  },
  {
    value: "Italy",
    label: "Italy",
  },
  {
    value: "Jamaica",
    label: "Jamaica",
  },
  {
    value: "Japan",
    label: "Japan",
  },
  {
    value: "Jordan",
    label: "Jordan",
  },
  {
    value: "Kazakhstan",
    label: "Kazakhstan",
  },
  {
    value: "Kenya",
    label: "Kenya",
  },
  {
    value: "Kiribati",
    label: "Kiribati",
  },
  {
    value: "Korea, North",
    label: "Korea, North",
    registries: {
      eupas: "Korea, Democratic People's Republic of",
      eudra: "Korea, Democratic People's Republic of",
      eudract: "Korea, Democratic People's Republic of",
    },
  },
  {
    value: "Korea, Republic of",
    label: "Korea, Republic of",
  },
  {
    value: "Korea, South",
    label: "Korea, South",
    registries: {
      eupas: "Korea, Republic of",
      eudra: "Korea, Republic of",
      eudract: "Korea, Republic of",
    },
    hideInRegistries: ["eupas", "eudra", "ctis"],
  },
  {
    value: "Kosovo",
    label: "Kosovo",
  },
  {
    value: "Kuwait",
    label: "Kuwait",
  },
  {
    value: "Kyrgyzstan",
    label: "Kyrgyzstan",
  },
  {
    value: "Laos",
    label: "Laos",
  },
  {
    value: "Latvia",
    label: "Latvia",
  },
  {
    value: "Lebanon",
    label: "Lebanon",
  },
  {
    value: "Lesotho",
    label: "Lesotho",
  },
  {
    value: "Liberia",
    label: "Liberia",
  },
  {
    value: "Libya",
    label: "Libya",
  },
  {
    value: "Liechtenstein",
    label: "Liechtenstein",
  },
  {
    value: "Lithuania",
    label: "Lithuania",
  },
  {
    value: "Luxembourg",
    label: "Luxembourg",
  },
  {
    value: "Macedonia",
    label: "Macedonia",
  },
  {
    value: "Madagascar",
    label: "Madagascar",
  },
  {
    value: "Malawi",
    label: "Malawi",
  },
  {
    value: "Malaysia",
    label: "Malaysia",
  },
  {
    value: "Maldives",
    label: "Maldives",
  },
  {
    value: "Mali",
    label: "Mali",
  },
  {
    value: "Malta",
    label: "Malta",
  },
  {
    value: "Marshall Islands",
    label: "Marshall Islands",
  },
  {
    value: "Mauritania",
    label: "Mauritania",
  },
  {
    value: "Mauritius",
    label: "Mauritius",
  },
  {
    value: "Mexico",
    label: "Mexico",
  },
  {
    value: "Micronesia, Federated States of",
    label: "Micronesia, Federated States of",
  },
  {
    value: "Moldova",
    label: "Moldova",
  },
  {
    value: "Monaco",
    label: "Monaco",
  },
  {
    value: "Mongolia",
    label: "Mongolia",
  },
  {
    value: "Montenegro",
    label: "Montenegro",
  },
  {
    value: "Morocco",
    label: "Morocco",
  },
  {
    value: "Mozambique",
    label: "Mozambique",
  },
  {
    value: "Myanmar (Burma)",
    label: "Myanmar (Burma)",
  },
  {
    value: "Namibia",
    label: "Namibia",
  },
  {
    value: "Nauru",
    label: "Nauru",
  },
  {
    value: "Nepal",
    label: "Nepal",
  },
  {
    value: "Netherlands",
    label: "Netherlands",
  },
  {
    value: "New Zealand",
    label: "New Zealand",
  },
  {
    value: "Nicaragua",
    label: "Nicaragua",
  },
  {
    value: "Niger",
    label: "Niger",
  },
  {
    value: "Nigeria",
    label: "Nigeria",
  },
  {
    value: "Norway",
    label: "Norway",
  },
  {
    value: "Oman",
    label: "Oman",
  },
  {
    value: "Pakistan",
    label: "Pakistan",
  },
  {
    value: "Palau",
    label: "Palau",
  },
  {
    value: "Panama",
    label: "Panama",
  },
  {
    value: "Papua New Guinea",
    label: "Papua New Guinea",
  },
  {
    value: "Paraguay",
    label: "Paraguay",
  },
  {
    value: "Peru",
    label: "Peru",
  },
  {
    value: "Philippines",
    label: "Philippines",
  },
  {
    value: "Poland",
    label: "Poland",
  },
  {
    value: "Portugal",
    label: "Portugal",
  },
  {
    value: "Puerto Rico",
    label: "Puerto Rico",
  },
  {
    value: "Qatar",
    label: "Qatar",
  },
  {
    value: "Romania",
    label: "Romania",
  },
  {
    value: "Russia",
    label: "Russia",
  },
  {
    value: "Russian Federation",
    label: "Russian Federation",
  },
  {
    value: "Rwanda",
    label: "Rwanda",
  },
  {
    value: "Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
  },
  {
    value: "Saint Lucia",
    label: "Saint Lucia",
  },
  {
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  {
    value: "Samoa",
    label: "Samoa",
  },
  {
    value: "San Marino",
    label: "San Marino",
  },
  {
    value: "Sao Tome and Principe",
    label: "Sao Tome and Principe",
  },
  {
    value: "Saudi Arabia",
    label: "Saudi Arabia",
  },
  {
    value: "Senegal",
    label: "Senegal",
  },
  {
    value: "Serbia",
    label: "Serbia",
  },
  {
    value: "Seychelles",
    label: "Seychelles",
  },
  {
    value: "Sierra Leone",
    label: "Sierra Leone",
  },
  {
    value: "Singapore",
    label: "Singapore",
  },
  {
    value: "Slovakia",
    label: "Slovakia",
  },
  {
    value: "Slovenia",
    label: "Slovenia",
  },
  {
    value: "Solomon Islands",
    label: "Solomon Islands",
  },
  {
    value: "Somalia",
    label: "Somalia",
  },
  {
    value: "South Africa",
    label: "South Africa",
  },
  {
    value: "South Sudan",
    label: "South Sudan",
  },
  {
    value: "Spain",
    label: "Spain",
  },
  {
    value: "Sri Lanka",
    label: "Sri Lanka",
  },
  {
    value: "Sudan",
    label: "Sudan",
  },
  {
    value: "Suriname",
    label: "Suriname",
  },
  {
    value: "Swaziland",
    label: "Swaziland",
  },
  {
    value: "Sweden",
    label: "Sweden",
  },
  {
    value: "Switzerland",
    label: "Switzerland",
  },
  {
    value: "Syria",
    label: "Syria",
  },
  {
    value: "Taiwan",
    label: "Taiwan",
  },
  {
    value: "Tajikistan",
    label: "Tajikistan",
  },
  {
    value: "Tanzania",
    label: "Tanzania",
  },
  {
    value: "Thailand",
    label: "Thailand",
  },
  {
    value: "Togo",
    label: "Togo",
  },
  {
    value: "Tonga",
    label: "Tonga",
  },
  {
    value: "Trinidad and Tobago",
    label: "Trinidad and Tobago",
  },
  {
    value: "Tunisia",
    label: "Tunisia",
  },
  {
    value: "Turkey",
    label: "Turkey",
  },
  {
    value: "Turkmenistan",
    label: "Turkmenistan",
  },
  {
    value: "Tuvalu",
    label: "Tuvalu",
  },
  {
    value: "Uganda",
    label: "Uganda",
  },
  {
    value: "Ukraine",
    label: "Ukraine",
  },
  {
    value: "United Arab Emirates",
    label: "United Arab Emirates",
  },
  {
    value: "United Kingdom",
    label: "United Kingdom",
  },
  {
    value: "United States",
    label: "United States",
  },
  {
    value: "Uruguay",
    label: "Uruguay",
  },
  {
    value: "Uzbekistan",
    label: "Uzbekistan",
  },
  {
    value: "Vanuatu",
    label: "Vanuatu",
  },
  {
    value: "Vatican City (Holy See)",
    label: "Vatican City (Holy See)",
  },
  {
    value: "Venezuela",
    label: "Venezuela",
  },
  {
    value: "Vietnam",
    label: "Vietnam",
  },
  {
    value: "Yemen",
    label: "Yemen",
  },
  {
    value: "Zambia",
    label: "Zambia",
  },
  {
    value: "Zimbabwe",
    label: "Zimbabwe",
  },
]

export const SECONDARY_ID_TYPES = [
  {
    value: "US NIH Grant/Contract Award Number",
    label: "US NIH Grant/Contract Award Number",
    hideInRegistries: ["ctis"],
  },
  {
    value: "Other Grant/Funding Number",
    label: "Other Grant/Funding Number",
    hideInRegistries: ["ctis"],
  },
  {
    value: "Registry Identifier",
    label: "Registry Identifier",
    hideInRegistries: ["ctis"],
  },
  {
    value: "EU Trial (CTIS) Number",
    label: "EU Trial (CTIS) Number",
    hideInRegistries: ["ctis"],
  },
  {
    value: "EudraCT Number",
    label: "EudraCT Number",
    hideInRegistries: ["ctis"],
  },
  {
    value: "WHO Universal Trial Number (UTN)",
    label: "WHO Universal Trial Number (UTN)",
    hideInRegistries: ["ctg"],
  },
  {
    value: "ClinicalTrials.gov identifier (NCT number)",
    label: "ClinicalTrials.gov identifier (NCT number)",
    hideInRegistries: ["ctg"],
  },
  {
    value: "ISRCTN number",
    label: "ISRCTN number",
    hideInRegistries: ["ctg"],
  },
  {
    value: "Other Identifier",
    label: "Other Identifier",
    hideInRegistries: ["ctis"],
  },
  {
    value: "CTMS ID",
    label: "CTMS ID",
    type: "study-details",
  },
  {
    value: "Alias ID",
    label: "Alias ID",
    type: "study-details",
  },
]

// TODO: review STUDY_PHASES below
export const phaseShortcutMap = {
  "Early Phase 1 (or Phase 0)": "0",
  "Phase 1": "1",
  "Phase 1/Phase 2": "1/2",
  "Phase 2": "2",
  "Phase 2/Phase 3": "2/3",
  "Phase 3": "3",
  "Phase 4": "4",
}

export const EUPAS_COUNTRY_REGULATOR = [
  {
    value: "EMA",
    label: "EMA",
  },
  {
    value: "United States",
    label: "United States",
  },
  {
    value: "Canada",
    label: "Canada",
  },
  {
    value: "Australia",
    label: "Australia",
  },
  {
    value: "Japan",
    label: "Japan",
  },
  {
    value: "Austria",
    label: "Austria",
  },
  {
    value: "Belgium",
    label: "Belgium",
  },
  {
    value: "Bulgaria",
    label: "Bulgaria",
  },
  {
    value: "Croatia",
    label: "Croatia",
  },
  {
    value: "Cyprus",
    label: "Cyprus",
  },
  {
    value: "Czechia",
    label: "Czechia",
  },
  {
    value: "Denmark",
    label: "Denmark",
  },
  {
    value: "Estonia",
    label: "Estonia",
  },
  {
    value: "Finland",
    label: "Finland",
  },
  {
    value: "France",
    label: "France",
  },
  {
    value: "Germany",
    label: "Germany",
  },
  {
    value: "Greece",
    label: "Greece",
  },
  {
    value: "Hungary",
    label: "Hungary",
  },
  {
    value: "Iceland",
    label: "Iceland",
  },
  {
    value: "Ireland",
    label: "Ireland",
  },
  {
    value: "Italy",
    label: "Italy",
  },
  {
    value: "Latvia",
    label: "Latvia",
  },
  {
    value: "Liechtenstein",
    label: "Liechtenstein",
  },
  {
    value: "Lithuania",
    label: "Lithuania",
  },
  {
    value: "Luxembourg",
    label: "Luxembourg",
  },
  {
    value: "Malta",
    label: "Malta",
  },
  {
    value: "Netherlands",
    label: "Netherlands",
  },
  {
    value: "Norway",
    label: "Norway",
  },
  {
    value: "Poland",
    label: "Poland",
  },
  {
    value: "Portugal",
    label: "Portugal",
  },
  {
    value: "Romania",
    label: "Romania",
  },
  {
    value: "Slovakia",
    label: "Slovakia",
  },
  {
    value: "Slovania",
    label: "Slovania",
  },
  {
    value: "Spain",
    label: "Spain",
  },
  {
    value: "Sweden",
    label: "Sweden",
  },
  {
    value: "Switzerland",
    label: "Switzerland",
  },
  {
    value: "United Kingdom (Northern Ireland)",
    label: "United Kingdom (Northern Ireland)",
  },
]

export const ROUTES_OF_ADMINISTRATION = [
  {
    value: "Auricular use",
    label: "Auricular use",
  },
  {
    value: "Buccal use",
    label: "Buccal use",
  },
  {
    value: "Coarse spray",
    label: "Coarse spray",
  },
  {
    value: "Concentrate for solution for infusion",
    label: "Concentrate for solution for infusion",
  },
  {
    value: "Conjunctival use",
    label: "Conjunctival use",
  },
  {
    value: "Cutaneous use",
    label: "Cutaneous use",
  },
  {
    value: "Dental use",
    label: "Dental use",
  },
  {
    value: "Endocervical use",
    label: "Endocervical use",
  },
  {
    value: "Endosinusial use",
    label: "Endosinusial use",
  },
  {
    value: "Endotracheopulmonary use ",
    label: "Endotracheopulmonary use ",
  },
  {
    value: "Enteral use",
    label: "Enteral use",
  },
  {
    value: "Epicutaneous use",
    label: "Epicutaneous use",
  },
  {
    value: "Epidural use",
    label: "Epidural use",
  },
  {
    value: "Epilesional use",
    label: "Epilesional use",
  },
  {
    value: "Extenal use",
    label: "Extenal use",
  },
  {
    value: "Extraamniotic use",
    label: "Extraamniotic use",
  },
  {
    value: "Extracorporeal use",
    label: "Extracorporeal use",
  },
  {
    value: "Gastric use",
    label: "Gastric use",
  },
  {
    value: "Gastroenteral use",
    label: "Gastroenteral use",
  },
  {
    value: "Gingival use",
    label: "Gingival use",
  },
  {
    value: "Haemodialysis",
    label: "Haemodialysis",
  },
  {
    value: "Implantation",
    label: "Implantation",
  },
  {
    value: "In vitro use",
    label: "In vitro use",
  },
  {
    value: "Infiltration",
    label: "Infiltration",
  },
  {
    value: "Infusion",
    label: "Infusion",
  },
  {
    value: "Inhalation use",
    label: "Inhalation use",
  },
  {
    value: "Injection",
    label: "Injection",
  },
  {
    value: "Intestinal use",
    label: "Intestinal use",
  },
  {
    value: "Intraabdominal use",
    label: "Intraabdominal use",
  },
  {
    value: "Intraamniotic use",
    label: "Intraamniotic use",
  },
  {
    value: "Intraarterial use",
    label: "Intraarterial use",
  },
  {
    value: "Intraarticular use",
    label: "Intraarticular use",
  },
  {
    value: "Intrabursal use",
    label: "Intrabursal use",
  },
  {
    value: "Intracameral use",
    label: "Intracameral use",
  },
  {
    value: "Intracardiac use",
    label: "Intracardiac use",
  },
  {
    value: "Intracartilaginous use",
    label: "Intracartilaginous use",
  },
  {
    value: "Intracavernous use",
    label: "Intracavernous use",
  },
  {
    value: "Intracerebral use",
    label: "Intracerebral use",
  },
  {
    value: "Intracerebroventricular use",
    label: "Intracerebroventricular use",
  },
  {
    value: "Intracervical use",
    label: "Intracervical use",
  },
  {
    value: "Intracholangiopancreatic use",
    label: "Intracholangiopancreatic use",
  },
  {
    value: "Intracisternal use",
    label: "Intracisternal use",
  },
  {
    value: "Intracorneal use",
    label: "Intracorneal use",
  },
  {
    value: "Intracoronary use",
    label: "Intracoronary use",
  },
  {
    value: "Intradermal use",
    label: "Intradermal use",
  },
  {
    value: "Intradiscal use",
    label: "Intradiscal use",
  },
  {
    value: "Intraduodenal use",
    label: "Intraduodenal use",
  },
  {
    value: "Intradural use",
    label: "Intradural use",
  },
  {
    value: "Intraepidermal use",
    label: "Intraepidermal use",
  },
  {
    value: "Intragastric use",
    label: "Intragastric use",
  },
  {
    value: "Intraglandular use",
    label: "Intraglandular use",
  },
  {
    value: "Intrahepatic use",
    label: "Intrahepatic use",
  },
  {
    value: "Intraileal use",
    label: "Intraileal use",
  },
  {
    value: "Intralesional use",
    label: "Intralesional use",
  },
  {
    value: "Intralymphatic use",
    label: "Intralymphatic use",
  },
  {
    value: "Intrameningeal use",
    label: "Intrameningeal use",
  },
  {
    value: "Intramuscular and intravenous use",
    label: "Intramuscular and intravenous use",
  },
  {
    value: "Intramuscular use",
    label: "Intramuscular use",
  },
  {
    value: "Intraocular use",
    label: "Intraocular use",
  },
  {
    value: "Intraosseous use",
    label: "Intraosseous use",
  },
  {
    value: "Intrapericardial use",
    label: "Intrapericardial use",
  },
  {
    value: "Intraperitoneal use",
    label: "Intraperitoneal use",
  },
  {
    value: "Intrapleural use",
    label: "Intrapleural use",
  },
  {
    value: "Intraportal use",
    label: "Intraportal use",
  },
  {
    value: "Intraprostatic use",
    label: "Intraprostatic use",
  },
  {
    value: "Intraputaminal use",
    label: "Intraputaminal use",
  },
  {
    value: "Intrasternal use",
    label: "Intrasternal use",
  },
  {
    value: "Intrathecal use",
    label: "Intrathecal use",
  },
  {
    value: "Intratracheal use",
    label: "Intratracheal use",
  },
  {
    value: "Intratumoral use",
    label: "Intratumoral use",
  },
  {
    value: "Intratympanic use",
    label: "Intratympanic use",
  },
  {
    value: "Intrauterine use",
    label: "Intrauterine use",
  },
  {
    value: "Intravascular use",
    label: "Intravascular use",
  },
  {
    value: "Intravenous bolus use",
    label: "Intravenous bolus use",
  },
  {
    value: "Intravenous drip use",
    label: "Intravenous drip use",
  },
  {
    value: "Intravenous use",
    label: "Intravenous use",
  },
  {
    value: "Intraventricular use",
    label: "Intraventricular use",
  },
  {
    value: "Intravesical use",
    label: "Intravesical use",
  },
  {
    value: "Intravitreal use",
    label: "Intravitreal use",
  },
  {
    value: "Iontophoresis",
    label: "Iontophoresis",
  },
  {
    value: "Irrigation",
    label: "Irrigation",
  },
  {
    value: "Laryngopharyngeal use",
    label: "Laryngopharyngeal use",
  },
  {
    value: "Local use",
    label: "Local use",
  },
  {
    value: "Nasal use",
    label: "Nasal use",
  },
  {
    value: "Nasogastric use",
    label: "Nasogastric use",
  },
  {
    value: "Not mentioned",
    label: "Not mentioned",
  },
  {
    value: "Ocular use",
    label: "Ocular use",
  },
  {
    value: "Ophthalmic use",
    label: "Ophthalmic use",
  },
  {
    value: "Oral use",
    label: "Oral use",
  },
  {
    value: "Oromucosal use",
    label: "Oromucosal use",
  },
  {
    value: "Oropharyngeal use",
    label: "Oropharyngeal use",
  },
  {
    value: "Other use",
    label: "Other use",
  },
  {
    value: "Parenteral use",
    label: "Parenteral use",
  },
  {
    value: "Percutaneous use",
    label: "Percutaneous use",
  },
  {
    value: "Periaticular use",
    label: "Periaticular use",
  },
  {
    value: "Perineural use",
    label: "Perineural use",
  },
  {
    value: "Periodontol use",
    label: "Periodontol use",
  },
  {
    value: "Periosseous use",
    label: "Periosseous use",
  },
  {
    value: "Peritumoral use",
    label: "Peritumoral use",
  },
  {
    value: "Posterior juxtascleral use",
    label: "Posterior juxtascleral use",
  },
  {
    value: "Preservative solution",
    label: "Preservative solution",
  },
  {
    value: "Rectal use",
    label: "Rectal use",
  },
  {
    value: "Respiratory use",
    label: "Respiratory use",
  },
  {
    value: "Retrobulbar use",
    label: "Retrobulbar use",
  },
  {
    value: "Route of administration not applicable",
    label: "Route of administration not applicable",
  },
  {
    value: "Skin scarification",
    label: "Skin scarification",
  },
  {
    value: "Soft tissue use",
    label: "Soft tissue use",
  },
  {
    value: "Solution for infusion",
    label: "Solution for infusion",
  },
  {
    value: "Solution for injection",
    label: "Solution for injection",
  },
  {
    value: "Subconjunctival use",
    label: "Subconjunctival use",
  },
  {
    value: "Subcutaneous use",
    label: "Subcutaneous use",
  },
  {
    value: "Subdermal use",
    label: "Subdermal use",
  },
  {
    value: "Subgingival use",
    label: "Subgingival use",
  },
  {
    value: "Sublingual use",
    label: "Sublingual use",
  },
  {
    value: "Submucosal use",
    label: "Submucosal use",
  },
  {
    value: "Subretinal use",
    label: "Subretinal use",
  },
  {
    value: "Topical",
    label: "Topical",
  },
  {
    value: "Topical use",
    label: "Topical use",
  },
  {
    value: "Transdermal use",
    label: "Transdermal use",
  },
  {
    value: "Transmammary",
    label: "Transmammary",
  },
  {
    value: "Transmucosal use",
    label: "Transmucosal use",
  },
  {
    value: "Transplacental",
    label: "Transplacental",
  },
  {
    value: "Transplacental use",
    label: "Transplacental use",
  },
  {
    value: "Unknown use",
    label: "Unknown use",
  },
  {
    value: "Urethral use",
    label: "Urethral use",
  },
  {
    value: "Vaginal use",
    label: "Vaginal use",
  },
]

export const CONTACT_TITLES = [
  {
    value: "Unselected",
    label: "Unselected",
  },
  {
    value: "Dr",
    label: "Dr",
  },
  {
    value: "Mr",
    label: "Mr",
  },
  {
    value: "Ms",
    label: "Ms",
  },
  {
    value: "Miss",
    label: "Miss",
  },
  {
    value: "Mrs",
    label: "Mrs",
  },
  {
    value: "Professor",
    label: "Professor",
  },
]

export const STUDY_SCOPES = [
  { value: "Risk assessment", label: "Assessment of risk minimisation measure implementation or effectiveness" },
  { value: "Disease epidemiology", label: "Disease epidemiology" },
  { value: "Drug utilisation study", label: "Drug utilisation" },
  { value: "Effectiveness evaluation", label: "Effectiveness study (incl. comparative)" },
  { value: "Feasibility analysis", label: "Feasibility analysis" },
  { value: "Healthcare resource utilisation", label: "Healthcare resource utilisation" },
  {
    value: "Hypothesis generation (including signal detection)",
    label: "Hypothesis generation (including signal detection)",
  },
  { value: "Method development or testing", label: "Method development or testing" },
  { value: "Patient reported outcomes", label: "Patient reported outcomes" },
  { value: "Safety study (incl. comparative)", label: "Safety study (incl. comparative)" },
  { value: "Scoping review (including literature review)", label: "Scoping review (including literature review)" },
  {
    value: "Validation of study variables (exposure outcome covariate)",
    label: "Validation of study variables (exposure outcome covariate)",
  },
  { value: "Other", label: "Other" },
]

export const AGE_GROUPS = [
  { value: 1, label: "All" },
  { value: 2, label: "In utero" },
  { value: 3, label: "Pediatric population (< 18 years)" },
  { value: 4, label: "Neonate" },
  { value: 5, label: "Preterm newborn infants (0 - 27 days)" },
  { value: 6, label: "Term newborn infants (0 - 27 days)" },
  { value: 7, label: "Infants and toddlers (28 days - 23 months)" },
  { value: 8, label: "Children (2 to < 12 years)" },
  { value: 9, label: "Prepubertal children (2 years to onset of puberty)" },
  { value: 10, label: "Adolescents (12 to < 18 years)" },
  { value: 11, label: "Pubertal and postpubertal adolescents (onset of puberty to < 18 years)" },
  { value: 12, label: "Adult and elderly population (>18 years)" },
  { value: 13, label: "Adults (18 to < 65 years)" },
  { value: 14, label: "Adults (18 to < 46 years)" },
  { value: 15, label: "Adults (46 to < 65 years)" },
  { value: 16, label: "Elderly (>= 65 years)" },
  { value: 17, label: "Adults (65 to < 75 years)" },
  { value: 18, label: "Adults (75 to < 85 years)" },
  { value: 19, label: "Adults (85 years and over)" },
  { value: 20, label: "Egg" },
  { value: 21, label: "Embryonated egg" },
  { value: 22, label: "Young animal/Newborn" },
  { value: 23, label: "Young animal" },
  { value: 24, label: "Adult animal" },
]

export const SPECIAL_INTERESTS_OF_POPULATION = [
  { value: 1, label: "Frail population" },
  { value: 2, label: "Hepatic impaired" },
  { value: 3, label: "Immunocompromised" },
  { value: 4, label: "Nursing women" },
  { value: 5, label: "Other" },
  { value: 6, label: "Pregnant women" },
  { value: 7, label: "Renal impaired" },
  { value: 8, label: "Women of childbearing potential not using contraception" },
  { value: 9, label: "Women of childbearing potential using contraception" },
]

export const STUDY_DESIGNS = [
  {
    value: "Sentinel sites",
    label: "Sentinel sites",
  },
  {
    value: "Intensive monitoring schemes",
    label: "Intensive monitoring schemes",
  },
  {
    value: "Prescription event monitoring",
    label: "Prescription event monitoring",
  },
  {
    value: "Cross-sectional study",
    label: "Cross-sectional study",
  },
  {
    value: "Cohort study",
    label: "Cohort study",
  },
  {
    value: "Case-control study",
    label: "Case-control study",
  },
  {
    value: "Case series",
    label: "Case series",
  },
  {
    value: "Case-crossover",
    label: "Case-crossover",
  },
  {
    value: "Self controlled case-series",
    label: "Self controlled case-series",
  },
  {
    value: "Drug utilisation study",
    label: "Drug utilisation study",
  },
  {
    value: "Pharmacokinetic study",
    label: "Pharmacokinetic study",
  },
  {
    value: "Pharmacodynamic study",
    label: "Pharmacodynamic study",
  },
  {
    value: "Drug interaction study",
    label: "Drug interaction study",
  },
  {
    value: "Randomised controlled trial",
    label: "Randomised controlled trial",
  },
  {
    value: "Non-randomised clinical trial",
    label: "Non-randomised clinical trial",
  },
  {
    value: "Other",
    label: "Other",
  },
]

export const EUPAS_DATA_SOURCES = [
  {
    value: "Prospective patient-based data collection",
    label: "Prospective patient-based data collection",
  },
  {
    value: "Disease/case registry",
    label: "Disease/case registry",
  },
  {
    value: "Prescription event monitoring",
    label: "Prescription event monitoring",
  },
  {
    value: "Administrative database, e.g. claims database",
    label: "Administrative database, e.g. claims database",
  },
  {
    value: "Routine primary care electronic patient registry",
    label: "Routine primary care electronic patient registry",
  },
  {
    value: "Exposure registry",
    label: "Exposure registry",
  },
  {
    value: "Pharmacy dispensing records",
    label: "Pharmacy dispensing records",
  },
  {
    value: "Case-control surveillance database",
    label: "Case-control surveillance database",
  },
  {
    value: "Spontaneous reporting",
    label: "Spontaneous reporting",
  },
  {
    value: "Other",
    label: "Other",
  },
]

export const EUPAS_CENTERS = [
  {
    value: "AEMPS",
    label: "AEMPS",
  },
  {
    value: "AIBILI",
    label: "AIBILI",
  },
  {
    value: "AMSP",
    label: "AMSP",
  },
  {
    value: "ANFOMED GmbH",
    label: "ANFOMED GmbH",
  },
  {
    value: "ARS",
    label: "ARS",
  },
  {
    value: "ASSR Emilia-Romagna",
    label: "ASSR Emilia-Romagna",
  },
  {
    value: "AU-ADA",
    label: "AU-ADA",
  },
  {
    value: "AXONAL-BIOSTATEM",
    label: "AXONAL-BIOSTATEM",
  },
  {
    value: "Aarhus University Dept. of Clinical Epidemiology",
    label: "Aarhus University Dept. of Clinical Epidemiology",
  },
  {
    value: "Adelphi Real World",
    label: "Adelphi Real World",
  },
  {
    value: "Aetion",
    label: "Aetion",
  },
  {
    value: "Affective Disorders Research Group",
    label: "Affective Disorders Research Group",
  },
  {
    value: "ApHER",
    label: "ApHER",
  },
  {
    value: "BIPS GmbH",
    label: "BIPS GmbH",
  },
  {
    value: "Biologic Studies Group",
    label: "Biologic Studies Group",
  },
  {
    value: "Bordeaux PharmacoEpi",
    label: "Bordeaux PharmacoEpi",
  },
  {
    value: "Brighton Collaboration",
    label: "Brighton Collaboration",
  },
  {
    value: "CEDOC/FCM-UNL",
    label: "CEDOC/FCM-UNL",
  },
  {
    value: "CEFAR",
    label: "CEFAR",
  },
  {
    value: "CEIFE",
    label: "CEIFE",
  },
  {
    value: "CEMKA",
    label: "CEMKA",
  },
  {
    value: "CESME",
    label: "CESME",
  },
  {
    value: "CESP",
    label: "CESP",
  },
  {
    value: "CHI, University of Manchester",
    label: "CHI, University of Manchester",
  },
  {
    value: "CHIP",
    label: "CHIP",
  },
  {
    value: "CHRC",
    label: "CHRC",
  },
  {
    value: "CIRFF-Unina",
    label: "CIRFF-Unina",
  },
  {
    value: "CMNS",
    label: "CMNS",
  },
  {
    value: "CPRD",
    label: "CPRD",
  },
  {
    value: "CRFV Sardegna",
    label: "CRFV Sardegna",
  },
  {
    value: "CRF_Campania",
    label: "CRF_Campania",
  },
  {
    value: "CRO",
    label: "CRO",
  },
  {
    value: "CRPV Lyon",
    label: "CRPV Lyon",
  },
  {
    value: "CRPV-Bx",
    label: "CRPV-Bx",
  },
  {
    value: "CSD MR France",
    label: "CSD MR France",
  },
  {
    value: "CSD MR UK",
    label: "CSD MR UK",
  },
  {
    value: "Cancer Epidemiology Unit, University of Oxford",
    label: "Cancer Epidemiology Unit, University of Oxford",
  },
  {
    value: "Capionis",
    label: "Capionis",
  },
  {
    value: "Center for Research in Medical Pharmacology",
    label: "Center for Research in Medical Pharmacology",
  },
  {
    value: "Centre for Pharmacoepidemiology (CPE)",
    label: "Centre for Pharmacoepidemiology (CPE)",
  },
  {
    value: "Centre of Clinical Pharmacology for Drug Evaluat",
    label: "Centre of Clinical Pharmacology for Drug Evaluat",
  },
  {
    value: "Centre of Biostatistics-UL",
    label: "Centre of Biostatistics-UL",
  },
  {
    value: "Certara",
    label: "Certara",
  },
  {
    value: "Chiltern",
    label: "Chiltern",
  },
  {
    value: "ClinPharm, UnimiSacco",
    label: "ClinPharm, UnimiSacco",
  },
  {
    value: "Clinical Pharmacology Department, HULP, UAM",
    label: "Clinical Pharmacology Department, HULP, UAM",
  },
  {
    value: "Clinical Pharmacology Service HUPHM",
    label: "Clinical Pharmacology Service HUPHM",
  },
  {
    value: "Clinical Pharmacology Service, HUB/IDIBELL",
    label: "Clinical Pharmacology Service, HUB/IDIBELL",
  },
  {
    value: "Clinical Pharmacology at Karolinska",
    label: "Clinical Pharmacology at Karolinska",
  },
  {
    value: "Clinical Trials Unit",
    label: "Clinical Trials Unit",
  },
  {
    value: "CreativePhS",
    label: "CreativePhS",
  },
  {
    value: "DAPI",
    label: "DAPI",
  },
  {
    value: "DGRM-Infarmed",
    label: "DGRM-Infarmed",
  },
  {
    value: "DIMDI",
    label: "DIMDI",
  },
  {
    value: "DIRC",
    label: "DIRC",
  },
  {
    value: "DRFZ",
    label: "DRFZ",
  },
  {
    value: "DSRU",
    label: "DSRU",
  },
  {
    value: "Department for Pediatric Neurology",
    label: "Department for Pediatric Neurology",
  },
  {
    value: "Department of Epidemiology Lazio Region, Italy",
    label: "Department of Epidemiology Lazio Region, Italy",
  },
  {
    value: "Department of Public Health Sciences",
    label: "Department of Public Health Sciences",
  },
  {
    value: "Dept. of Epi. Research",
    label: "Dept. of Epi. Research",
  },
  {
    value: "Dpt Pharmacoepedemiology",
    label: "Dpt Pharmacoepedemiology",
  },
  {
    value: "Drugs and Pregnancy",
    label: "Drugs and Pregnancy",
  },
  {
    value: "EORTC",
    label: "EORTC",
  },
  {
    value: "EPID Research",
    label: "EPID Research",
  },
  {
    value: "EPIDEMIOLOGY- DSMB - UDINE UNIVERSITY",
    label: "EPIDEMIOLOGY- DSMB - UDINE UNIVERSITY",
  },
  {
    value: "Embryotox Berlin",
    label: "Embryotox Berlin",
  },
  {
    value: "Epi-Consultant",
    label: "Epi-Consultant",
  },
  {
    value: "EpiChron",
    label: "EpiChron",
  },
  {
    value: "EpiConcept",
    label: "EpiConcept",
  },
  {
    value: "Eurotrials",
    label: "Eurotrials",
  },
  {
    value: "Evidera",
    label: "Evidera",
  },
  {
    value: "FICF",
    label: "FICF",
  },
  {
    value: "FPS",
    label: "FPS",
  },
  {
    value: "FV&JK Consulting",
    label: "FV&JK Consulting",
  },
  {
    value: "Fimea",
    label: "Fimea",
  },
  {
    value: "Finnish Cancer registry",
    label: "Finnish Cancer registry",
  },
  {
    value: "Florence PV and PE Research Unit",
    label: "Florence PV and PE Research Unit",
  },
  {
    value: "Friberg Research AB",
    label: "Friberg Research AB",
  },
  {
    value: "GB PHARMA SERVICES & CONSULTING",
    label: "GB PHARMA SERVICES & CONSULTING",
  },
  {
    value: "GECEM",
    label: "GECEM",
  },
  {
    value: "GISED",
    label: "GISED",
  },
  {
    value: "Gerho",
    label: "Gerho",
  },
  {
    value: "Gillian Hall",
    label: "Gillian Hall",
  },
  {
    value: "Grupo Asturiano de Farmacoepidemiología",
    label: "Grupo Asturiano de Farmacoepidemiología",
  },
  {
    value: "HIPPOCRATES I.C.I.",
    label: "HIPPOCRATES I.C.I.",
  },
  {
    value: "HIRU",
    label: "HIRU",
  },
  {
    value: "Haematology Oncology Leipzig",
    label: "Haematology Oncology Leipzig",
  },
  {
    value: "Hannover Medical School HTTG",
    label: "Hannover Medical School HTTG",
  },
  {
    value: "Health Data Sciences",
    label: "Health Data Sciences",
  },
  {
    value: "Health Search-SIMG",
    label: "Health Search-SIMG",
  },
  {
    value: "Hippocrates Research",
    label: "Hippocrates Research",
  },
  {
    value: "Hospital Clinic Barcelona",
    label: "Hospital Clinic Barcelona",
  },
  {
    value: "IADB.NL",
    label: "IADB.NL",
  },
  {
    value: "IDIAPJGol",
    label: "IDIAPJGol",
  },
  {
    value: "IMIBE",
    label: "IMIBE",
  },
  {
    value: "IMS Health",
    label: "IMS Health",
  },
  {
    value: "IMSIE Cologne",
    label: "IMSIE Cologne",
  },
  {
    value: "INSPIRE srl",
    label: "INSPIRE srl",
  },
  {
    value: "IPCRG",
    label: "IPCRG",
  },
  {
    value: "IPRI",
    label: "IPRI",
  },
  {
    value: "IQVIA",
    label: "IQVIA",
  },
  {
    value: "IQVIA European Data Science Hub",
    label: "IQVIA European Data Science Hub",
  },
  {
    value: "IQVIA NL",
    label: "IQVIA NL",
  },
  {
    value: "IRFMN",
    label: "IRFMN",
  },
  {
    value: "ISP Navarra",
    label: "ISP Navarra",
  },
  {
    value: "Julius Clinical Research",
    label: "Julius Clinical Research",
  },
  {
    value: "KBC Zagreb",
    label: "KBC Zagreb",
  },
  {
    value: "Kantar Health Clinical & Real World Research",
    label: "Kantar Health Clinical & Real World Research",
  },
  {
    value: "Kappa Santé",
    label: "Kappa Santé",
  },
  {
    value: "Kubadili",
    label: "Kubadili",
  },
  {
    value: "LA-SER Research",
    label: "LA-SER Research",
  },
  {
    value: "LSHTM",
    label: "LSHTM",
  },
  {
    value: "Laboratory of Hygiene and Environmental Protection",
    label: "Laboratory of Hygiene and Environmental Protection",
  },
  {
    value: "MAPI-ICON",
    label: "MAPI-ICON",
  },
  {
    value: "MEMO",
    label: "MEMO",
  },
  {
    value: "MFIR-Ulster",
    label: "MFIR-Ulster",
  },
  {
    value: "MUMC+",
    label: "MUMC+",
  },
  {
    value: "MedEngine",
    label: "MedEngine",
  },
  {
    value: "MediNeos",
    label: "MediNeos",
  },
  {
    value: "Medpace",
    label: "Medpace",
  },
  {
    value: "NIPH",
    label: "NIPH",
  },
  {
    value: "NPEU",
    label: "NPEU",
  },
  {
    value: "Netherlands Pharmacovigilance Centre Lareb",
    label: "Netherlands Pharmacovigilance Centre Lareb",
  },
  {
    value: "Numerus - Statistics and Pharmacoepidemiology",
    label: "Numerus - Statistics and Pharmacoepidemiology",
  },
  {
    value: "OPRI Pte Ltd",
    label: "OPRI Pte Ltd",
  },
  {
    value: "OXON",
    label: "OXON",
  },
  {
    value: "Optum",
    label: "Optum",
  },
  {
    value: "Outcome",
    label: "Outcome",
  },
  {
    value: "P95",
    label: "P95",
  },
  {
    value: "PAREXEL",
    label: "PAREXEL",
  },
  {
    value: "PE2",
    label: "PE2",
  },
  {
    value: "PELyon",
    label: "PELyon",
  },
  {
    value: "PHARMO Institute",
    label: "PHARMO Institute",
  },
  {
    value: "PHE",
    label: "PHE",
  },
  {
    value: "PRA Real World Solutions",
    label: "PRA Real World Solutions",
  },
  {
    value: "PRC",
    label: "PRC",
  },
  {
    value: "PVZ FAKOS",
    label: "PVZ FAKOS",
  },
  {
    value: "PWA",
    label: "PWA",
  },
  {
    value: "Paris Pharmacoepidemiology Centre",
    label: "Paris Pharmacoepidemiology Centre",
  },
  {
    value: "Patients Direct",
    label: "Patients Direct",
  },
  {
    value: "Patras Center for Pharmacoepidemiological studies",
    label: "Patras Center for Pharmacoepidemiological studies",
  },
  {
    value: "PhV Regional Centre of Lombardy, Italy",
    label: "PhV Regional Centre of Lombardy, Italy",
  },
  {
    value: "PharmaSafe",
    label: "PharmaSafe",
  },
  {
    value: "Pharmacoepidemiology INSERM 1027",
    label: "Pharmacoepidemiology INSERM 1027",
  },
  {
    value: "Pharmacoepidemiology Research Group",
    label: "Pharmacoepidemiology Research Group",
  },
  {
    value: "Pharmacoepidemiology Unit - ISS",
    label: "Pharmacoepidemiology Unit - ISS",
  },
  {
    value: "Pharmacol UNIVR",
    label: "Pharmacol UNIVR",
  },
  {
    value: "Pharmacovigilance Unit of Neurofarba Department",
    label: "Pharmacovigilance Unit of Neurofarba Department",
  },
  {
    value: "Pharmatelligence",
    label: "Pharmatelligence",
  },
  {
    value: "Phase4CPH",
    label: "Phase4CPH",
  },
  {
    value: "Phisquare Institute",
    label: "Phisquare Institute",
  },
  {
    value: "Phv Department -HALMED",
    label: "Phv Department -HALMED",
  },
  {
    value: "PrimeVigilance/Ergomed",
    label: "PrimeVigilance/Ergomed",
  },
  {
    value: "Psychepi Sweden",
    label: "Psychepi Sweden",
  },
  {
    value: "Quantify",
    label: "Quantify",
  },
  {
    value: "Quintiles Late Phase",
    label: "Quintiles Late Phase",
  },
  {
    value: "Quintiles RWLPR",
    label: "Quintiles RWLPR",
  },
  {
    value: "RCSI EMeRGe group",
    label: "RCSI EMeRGe group",
  },
  {
    value: "RTI-HS",
    label: "RTI-HS",
  },
  {
    value: "ReS",
    label: "ReS",
  },
  {
    value: "Rotterdam Study",
    label: "Rotterdam Study",
  },
  {
    value: "SER",
    label: "SER",
  },
  {
    value: "SLC e.V. - The Human Motion Institute",
    label: "SLC e.V. - The Human Motion Institute",
  },
  {
    value: "Sence",
    label: "Sence",
  },
  {
    value: "Spanish DILI Registry",
    label: "Spanish DILI Registry",
  },
  {
    value: "Synapse Medicine",
    label: "Synapse Medicine",
  },
  {
    value: "Syneos Health",
    label: "Syneos Health",
  },
  {
    value: "TIS Helsinki",
    label: "TIS Helsinki",
  },
  {
    value: "The University of Edinburgh",
    label: "The University of Edinburgh",
  },
  {
    value: "The Wolfson Centre for Personalised Medicine",
    label: "The Wolfson Centre for Personalised Medicine",
  },
  {
    value: "UADRM",
    label: "UADRM",
  },
  {
    value: "UBC",
    label: "UBC",
  },
  {
    value: "UCL School of Pharmacy",
    label: "UCL School of Pharmacy",
  },
  {
    value: "UFALBA",
    label: "UFALBA",
  },
  {
    value: "UFLVT",
    label: "UFLVT",
  },
  {
    value: "UFPorto",
    label: "UFPorto",
  },
  {
    value: "UFS",
    label: "UFS",
  },
  {
    value: "UMCU",
    label: "UMCU",
  },
  {
    value: "UNIBO",
    label: "UNIBO",
  },
  {
    value: "UNIMIB",
    label: "UNIMIB",
  },
  {
    value: "UOI",
    label: "UOI",
  },
  {
    value: "UPCET",
    label: "UPCET",
  },
  {
    value: "UPO",
    label: "UPO",
  },
  {
    value: "Unit of Clinical Psychopharmacology - Verona",
    label: "Unit of Clinical Psychopharmacology - Verona",
  },
  {
    value: "University of Bath",
    label: "University of Bath",
  },
  {
    value: "University of Helsinki, Public Health",
    label: "University of Helsinki, Public Health",
  },
  {
    value: "University of Messina",
    label: "University of Messina",
  },
  {
    value: "University of Southern Denmark Pharmacoepi center",
    label: "University of Southern Denmark Pharmacoepi center",
  },
  {
    value: "Uppsala Monitoring Centre",
    label: "Uppsala Monitoring Centre",
  },
  {
    value: "Utrecht University Pharmacoepidemiology Center",
    label: "Utrecht University Pharmacoepidemiology Center",
  },
  {
    value: "VACCINE.GRID",
    label: "VACCINE.GRID",
  },
  {
    value: "VHIR",
    label: "VHIR",
  },
  {
    value: "Vaccine Safety Evaluation/THL",
    label: "Vaccine Safety Evaluation/THL",
  },
  {
    value: "WCT Evidence",
    label: "WCT Evidence",
  },
  {
    value: "WIT",
    label: "WIT",
  },
  {
    value: "Wolfson Unit, Newcastle",
    label: "Wolfson Unit, Newcastle",
  },
  {
    value: "YOLARX Consultants",
    label: "YOLARX Consultants",
  },
  {
    value: "Yellow card Centre Scotland",
    label: "Yellow card Centre Scotland",
  },
  {
    value: "ZEG Berlin",
    label: "ZEG Berlin",
  },
  {
    value: "iBiMED",
    label: "iBiMED",
  },
  {
    value: "inVentiv Health Clinical",
    label: "inVentiv Health Clinical",
  },
]

export const ENCEPP_REGISTERED_NETWORKS = [
  {
    value: "ACRPV",
    label: "ACRPV",
  },
  {
    value: "AMSP",
    label: "AMSP",
  },
  {
    value: "BIOBADASER",
    label: "BIOBADASER",
  },
  {
    value: "BIOREG",
    label: "BIOREG",
  },
  {
    value: "CARING",
    label: "CARING",
  },
  {
    value: "COVIDRIVE",
    label: "COVIDRIVE",
  },
  {
    value: "DRIVE",
    label: "DRIVE",
  },
  {
    value: "E-CORE",
    label: "E-CORE",
  },
  {
    value: "ENTIS",
    label: "ENTIS",
  },
  {
    value: "EUDRAGENE",
    label: "EUDRAGENE",
  },
  {
    value: "EULAR RODS",
    label: "EULAR RODS",
  },
  {
    value: "EULAR/INAS",
    label: "EULAR/INAS",
  },
  {
    value: "EUROCAT",
    label: "EUROCAT",
  },
  {
    value: "EVICR.net",
    label: "EVICR.net",
  },
  {
    value: "EuroDURG",
    label: "EuroDURG",
  },
  {
    value: "European Forum for Primary Care",
    label: "European Forum for Primary Care",
  },
  {
    value: "European TREAT Registry Taskforce",
    label: "European TREAT Registry Taskforce",
  },
  {
    value: "FP-MCRN",
    label: "FP-MCRN",
  },
  {
    value: "I-MOVE",
    label: "I-MOVE",
  },
  {
    value: "IPDN",
    label: "IPDN",
  },
  {
    value: "MEDICYS",
    label: "MEDICYS",
  },
  {
    value: "MSDA",
    label: "MSDA",
  },
  {
    value: "NEPI",
    label: "NEPI",
  },
  {
    value: "Optimum Patient Care(OPC)",
    label: "Optimum Patient Care(OPC)",
  },
  {
    value: "PGRx",
    label: "PGRx",
  },
  {
    value: "PRINTO",
    label: "PRINTO",
  },
  {
    value: "Psonet",
    label: "Psonet",
  },
  {
    value: "RegiSCAR",
    label: "RegiSCAR",
  },
  {
    value: "ResearchLink",
    label: "ResearchLink",
  },
  {
    value: "Respiratory Effectiveness Group (REG)",
    label: "Respiratory Effectiveness Group (REG)",
  },
  {
    value: "SIGMA",
    label: "SIGMA",
  },
  {
    value: "TEDDY",
    label: "TEDDY",
  },
  {
    value: "VAC4EU",
    label: "VAC4EU",
  },
  {
    value: "redlAPP",
    label: "redlAPP",
  },
]

export const ENCEPP_REGISTERED_DATA_SOURCES = [
  {
    value: "THIN",
    label: "THIN",
  },
  {
    value: "CPRD",
    label: "CPRD",
  },
  {
    value: "MIS",
    label: "MIS",
  },
  {
    value: "PHARM",
    label: "PHARM",
  },
  {
    value: "HIS",
    label: "HIS",
  },
  {
    value: "HEIS",
    label: "HEIS",
  },
  {
    value: "Danish Registries (access/analysis)",
    label: "Danish Registries (access/analysis)",
  },
  {
    value: "Health Search/CSD LPD",
    label: "Health Search/CSD LPD",
  },
  {
    value: "The Swedish prescribed drug register",
    label: "The Swedish prescribed drug register",
  },
  {
    value: "NorPD",
    label: "NorPD",
  },
  {
    value: "Calliope",
    label: "Calliope",
  },
  {
    value: "LPUH-Drug Registry",
    label: "LPUH-Drug Registry",
  },
  {
    value: "PPLS-LPUH",
    label: "PPLS-LPUH",
  },
  {
    value: "OPED",
    label: "OPED",
  },
  {
    value: "IADB",
    label: "IADB",
  },
  {
    value: "Emilia Romagna GPs drug prescription",
    label: "Emilia Romagna GPs drug prescription",
  },
  {
    value: "Hospital Discharge",
    label: "Hospital Discharge",
  },
  {
    value: "IPCI",
    label: "IPCI",
  },
  {
    value: "DAPI database",
    label: "DAPI database",
  },
  {
    value: "LifeLink EMR FR",
    label: "LifeLink EMR FR",
  },
  {
    value: "LifeLink Health Plan US",
    label: "LifeLink Health Plan US",
  },
  {
    value: "EUROCAT",
    label: "EUROCAT",
  },
  {
    value: "MediGuard.org",
    label: "MediGuard.org",
  },
  {
    value: "EudraVigilance",
    label: "EudraVigilance",
  },
  {
    value: "Caserta database",
    label: "Caserta database",
  },
  {
    value: "BioReg-Austria",
    label: "BioReg-Austria",
  },
  {
    value: "EFEMERIS",
    label: "EFEMERIS",
  },
  {
    value: "SIDIAP",
    label: "SIDIAP",
  },
  {
    value: "Drugs and Pregnancy Finland",
    label: "Drugs and Pregnancy Finland",
  },
  {
    value: "NCRI_PCRS database",
    label: "NCRI_PCRS database",
  },
  {
    value: "Prescription Claims Data - Canada",
    label: "Prescription Claims Data - Canada",
  },
  {
    value: "Longitudinal Prescription Data - Canada",
    label: "Longitudinal Prescription Data - Canada",
  },
  {
    value: "IMS MedMap® - Canada",
    label: "IMS MedMap® - Canada",
  },
  {
    value: "Longitudinal Prescription Data(LRx) -France",
    label: "Longitudinal Prescription Data(LRx) -France",
  },
  {
    value: "IMS - Hospital Treatment Insights - UK",
    label: "IMS - Hospital Treatment Insights - UK",
  },
  {
    value: "IMS LifeLink:Longitudinal Prescription Data-Spain",
    label: "IMS LifeLink:Longitudinal Prescription Data-Spain",
  },
  {
    value: "IMS LifeLink: Hospital Disease Database - Belgium",
    label: "IMS LifeLink: Hospital Disease Database - Belgium",
  },
  {
    value: "IMS LifeLink:Longitudinal Prescription Data - Bel",
    label: "IMS LifeLink:Longitudinal Prescription Data - Bel",
  },
  {
    value: "IMS LifeLink : Longitudinal Prescription Data - Ja",
    label: "IMS LifeLink : Longitudinal Prescription Data - Ja",
  },
  {
    value: "IMS LifeLink: Longitudinal Prescription Data - Aus",
    label: "IMS LifeLink: Longitudinal Prescription Data - Aus",
  },
  {
    value: "Electronic Medical Records Data (Ambulatory) - US",
    label: "Electronic Medical Records Data (Ambulatory) - US",
  },
  {
    value: "Longitudinal Prescription Data - US",
    label: "Longitudinal Prescription Data - US",
  },
  {
    value: "Hospital CDM-US",
    label: "Hospital CDM-US",
  },
  {
    value: "IMS LifeLink: PharMetrics Plus - US",
    label: "IMS LifeLink: PharMetrics Plus - US",
  },
  {
    value: "IMS LifeLink: Dx data - US",
    label: "IMS LifeLink: Dx data - US",
  },
  {
    value: "Longitudinal Prescription Data - Netherlands",
    label: "Longitudinal Prescription Data - Netherlands",
  },
  {
    value: "PHARMO Database Network",
    label: "PHARMO Database Network",
  },
  {
    value: "Gecem inventory",
    label: "Gecem inventory",
  },
  {
    value: "GePaRD",
    label: "GePaRD",
  },
  {
    value: "BIFAP",
    label: "BIFAP",
  },
  {
    value: "ARS",
    label: "ARS",
  },
  {
    value: "Optimum Patient Care Research Database (OPCRD)",
    label: "Optimum Patient Care Research Database (OPCRD)",
  },
  {
    value: "EUROmediCAT",
    label: "EUROmediCAT",
  },
  {
    value: "EMBARC",
    label: "EMBARC",
  },
  {
    value: "GalNet",
    label: "GalNet",
  },
  {
    value: "EUROMAC",
    label: "EUROMAC",
  },
  {
    value: "aHUS Registry",
    label: "aHUS Registry",
  },
  {
    value: "PROGNOSIS",
    label: "PROGNOSIS",
  },
  {
    value: "EBMT",
    label: "EBMT",
  },
  {
    value: "HAE",
    label: "HAE",
  },
  {
    value: "European Porphyria Registry (EPR)",
    label: "European Porphyria Registry (EPR)",
  },
  {
    value: "ESID Registry",
    label: "ESID Registry",
  },
  {
    value: "EUHASS - Blood disorders",
    label: "EUHASS - Blood disorders",
  },
  {
    value: "Real Life Data - Big-Pac",
    label: "Real Life Data - Big-Pac",
  },
  {
    value: "INPDR",
    label: "INPDR",
  },
  {
    value: "TREAT-NMD",
    label: "TREAT-NMD",
  },
  {
    value: "EUReMS - Multiple Sclerosis",
    label: "EUReMS - Multiple Sclerosis",
  },
  {
    value: "BSRBR - Rheumatic and Musculoskeletal conditions",
    label: "BSRBR - Rheumatic and Musculoskeletal conditions",
  },
  {
    value: "Pharmachild - Juvenile idiopathic arthritis (JIA)",
    label: "Pharmachild - Juvenile idiopathic arthritis (JIA)",
  },
  {
    value: "EDMUS - Multiple Sclerosis",
    label: "EDMUS - Multiple Sclerosis",
  },
  {
    value: "EHR - Blood disorder",
    label: "EHR - Blood disorder",
  },
  {
    value: "EPCOT - Blood disorders",
    label: "EPCOT - Blood disorders",
  },
  {
    value: "UK Renal Registry - Renal diseases",
    label: "UK Renal Registry - Renal diseases",
  },
  {
    value: "EU-CHS - Central Hypoventilation Syndromes",
    label: "EU-CHS - Central Hypoventilation Syndromes",
  },
  {
    value: "EUMDS - Myelodysplastic Syndrome",
    label: "EUMDS - Myelodysplastic Syndrome",
  },
  {
    value: "EUGINDAT-PIADATABASE - Primary inherited aminoacid",
    label: "EUGINDAT-PIADATABASE - Primary inherited aminoacid",
  },
  {
    value: "EUROPAC - Pancreatic diseases and cancer",
    label: "EUROPAC - Pancreatic diseases and cancer",
  },
  {
    value: "EUROTRAPS - Autoinflammatory diseases",
    label: "EUROTRAPS - Autoinflammatory diseases",
  },
  {
    value: "European registry of alveolar echinococcosis",
    label: "European registry of alveolar echinococcosis",
  },
  {
    value: "X-ALD - X-linked adrenoleukodystrophy",
    label: "X-ALD - X-linked adrenoleukodystrophy",
  },
  {
    value: "EHDN - REGISTRY",
    label: "EHDN - REGISTRY",
  },
  {
    value: "European Prader-Willi syndrome database",
    label: "European Prader-Willi syndrome database",
  },
  {
    value: "HDIN - Hepatitis D",
    label: "HDIN - Hepatitis D",
  },
  {
    value: "HUE-MAN Project - Alpha mannosidosis",
    label: "HUE-MAN Project - Alpha mannosidosis",
  },
  {
    value: "SCETIDE - Primary Immune deficiencies",
    label: "SCETIDE - Primary Immune deficiencies",
  },
  {
    value: "UK SMA Patient Registry",
    label: "UK SMA Patient Registry",
  },
  {
    value: "Pedianet",
    label: "Pedianet",
  },
  {
    value: "UK Duchenne and Becker",
    label: "UK Duchenne and Becker",
  },
  {
    value: "EurêClark registry-Systemic Capillary Leak Syndrom",
    label: "EurêClark registry-Systemic Capillary Leak Syndrom",
  },
  {
    value: "ECFSPR - Cystic Fibrosis",
    label: "ECFSPR - Cystic Fibrosis",
  },
  {
    value: "ESPN/ERA-EDTA - Children Renal Replacement Therapy",
    label: "ESPN/ERA-EDTA - Children Renal Replacement Therapy",
  },
  {
    value: "ECARUCA - Chromosomal aberrations",
    label: "ECARUCA - Chromosomal aberrations",
  },
  {
    value: "EUROFEVER",
    label: "EUROFEVER",
  },
  {
    value: "ECMN - Mastocytosis",
    label: "ECMN - Mastocytosis",
  },
  {
    value: "ChILD-EU - Children Interstitial lung diseases",
    label: "ChILD-EU - Children Interstitial lung diseases",
  },
  {
    value: "COST-GnRH gonadotropin-releasing hormone deficienc",
    label: "COST-GnRH gonadotropin-releasing hormone deficienc",
  },
  {
    value: "E-IMD",
    label: "E-IMD",
  },
  {
    value: "Euro WABB - rare genetic disorders",
    label: "Euro WABB - rare genetic disorders",
  },
  {
    value: "EURAP-Epilepsy and pregnancy",
    label: "EURAP-Epilepsy and pregnancy",
  },
  {
    value: "NFZ",
    label: "NFZ",
  },
  {
    value: "QResearch",
    label: "QResearch",
  },
  {
    value: "SAIL databank",
    label: "SAIL databank",
  },
  {
    value: "eDRIS",
    label: "eDRIS",
  },
  {
    value: "Icelandic National Registries",
    label: "Icelandic National Registries",
  },
  {
    value: "BIKER",
    label: "BIKER",
  },
  {
    value: "Reuma.pt - Rheumatic diseases Portuguese Registry",
    label: "Reuma.pt - Rheumatic diseases Portuguese Registry",
  },
  {
    value: "E-HOD",
    label: "E-HOD",
  },
  {
    value: "EUHANET - Haemophilia",
    label: "EUHANET - Haemophilia",
  },
  {
    value: "epidEMcat - Multiple sclerosis",
    label: "epidEMcat - Multiple sclerosis",
  },
  {
    value: "ROR Centro - Oncology",
    label: "ROR Centro - Oncology",
  },
  {
    value: "RORENO - Oncology",
    label: "RORENO - Oncology",
  },
  {
    value: "ROR Sul - Oncology",
    label: "ROR Sul - Oncology",
  },
  {
    value: "RBD Network - Blood disorders and rare diseases",
    label: "RBD Network - Blood disorders and rare diseases",
  },
  {
    value: "German MS-Register",
    label: "German MS-Register",
  },
  {
    value: "RD-Connect",
    label: "RD-Connect",
  },
  {
    value: "ICRS - Cartilage Damage",
    label: "ICRS - Cartilage Damage",
  },
  {
    value: "Sylvia Lawry Centre for MS Research Registry",
    label: "Sylvia Lawry Centre for MS Research Registry",
  },
  {
    value: "Norwegian wholesaler-based drug statistics",
    label: "Norwegian wholesaler-based drug statistics",
  },
  {
    value: "EpiChron Cohort",
    label: "EpiChron Cohort",
  },
  {
    value: "PedNet",
    label: "PedNet",
  },
  {
    value: "ISAR",
    label: "ISAR",
  },
  {
    value: "THAOS registry - Transthyretin Amyloidosis",
    label: "THAOS registry - Transthyretin Amyloidosis",
  },
  {
    value: "HemoNED - Haemophilia",
    label: "HemoNED - Haemophilia",
  },
  {
    value: "FranceCoag - Haemophilia",
    label: "FranceCoag - Haemophilia",
  },
  {
    value: "UKHCDO - Haemophilia",
    label: "UKHCDO - Haemophilia",
  },
  {
    value: "Hepather - Hepatitis B and C",
    label: "Hepather - Hepatitis B and C",
  },
  {
    value: "Fabry registry - Fabry disease",
    label: "Fabry registry - Fabry disease",
  },
  {
    value: "DHR",
    label: "DHR",
  },
  {
    value: "ENCALS - Amyotrophic lateral sclerosis",
    label: "ENCALS - Amyotrophic lateral sclerosis",
  },
  {
    value: "INBC - Blood disorders",
    label: "INBC - Blood disorders",
  },
  {
    value: "ALS Register - Amyotrophic Lateral Sclerosis",
    label: "ALS Register - Amyotrophic Lateral Sclerosis",
  },
  {
    value: "FTLD Register - Frontotemporal lobar degeneration",
    label: "FTLD Register - Frontotemporal lobar degeneration",
  },
  {
    value: "NCRI - Oncology",
    label: "NCRI - Oncology",
  },
  {
    value: "ERCUSYN (European Register on Cushing's Syndrome)",
    label: "ERCUSYN (European Register on Cushing's Syndrome)",
  },
  {
    value: "PARADIGHM registry - Chronic Hypoparathyroidism",
    label: "PARADIGHM registry - Chronic Hypoparathyroidism",
  },
  {
    value: "Enroll-HD",
    label: "Enroll-HD",
  },
  {
    value: "APEX COPD Registry",
    label: "APEX COPD Registry",
  },
  {
    value: "UK CF Registry",
    label: "UK CF Registry",
  },
  {
    value: "SMArtCARE",
    label: "SMArtCARE",
  },
  {
    value: "World Bleeding Disorders Registry",
    label: "World Bleeding Disorders Registry",
  },
  {
    value: "ASTOR - Alport Syndrome",
    label: "ASTOR - Alport Syndrome",
  },
  {
    value: "R-LIVER rare liver disease registry",
    label: "R-LIVER rare liver disease registry",
  },
  {
    value: "TREATgermany-AD (Atopic Dermatitis) Registry",
    label: "TREATgermany-AD (Atopic Dermatitis) Registry",
  },
  {
    value: "Norwegian Porphyria Registry",
    label: "Norwegian Porphyria Registry",
  },
  {
    value: "The WFH Gene Therapy Registry",
    label: "The WFH Gene Therapy Registry",
  },
  {
    value: "Global FKRP Registry - LGMDR9",
    label: "Global FKRP Registry - LGMDR9",
  },
  {
    value: "UK Myotonic Dystrophy Patient Registry",
    label: "UK Myotonic Dystrophy Patient Registry",
  },
  {
    value: "The UK FSHD Patient Registry",
    label: "The UK FSHD Patient Registry",
  },
  {
    value: "DKCC - Skin Cancer",
    label: "DKCC - Skin Cancer",
  },
  {
    value: "German CF Registry",
    label: "German CF Registry",
  },
  {
    value: "RABBIT",
    label: "RABBIT",
  },
  {
    value: "REHem-AR-SEHOP",
    label: "REHem-AR-SEHOP",
  },
  {
    value: "OPCRDA",
    label: "OPCRDA",
  },
  {
    value: "MTM & CNM Patient Registry",
    label: "MTM & CNM Patient Registry",
  },
  {
    value: "HES",
    label: "HES",
  },
  {
    value: "CureDRPLA Global Patient Registry - DRPLA",
    label: "CureDRPLA Global Patient Registry - DRPLA",
  },
  {
    value: "CONQUEST - COPD",
    label: "CONQUEST - COPD",
  },
  {
    value: "HBV Registry",
    label: "HBV Registry",
  },
]

export const CTIS_LANGUAGES = [
  {
    value: "Bulgarian",
    label: "Bulgarian",
  },
  {
    value: "Croatian",
    label: "Croatian",
  },
  {
    value: "Czech",
    label: "Czech",
  },
  {
    value: "Danish",
    label: "Danish",
  },
  {
    value: "Dutch",
    label: "Dutch",
  },
  {
    value: "Dutch (Belgium)",
    label: "Dutch (Belgium)",
  },
  {
    value: "Dutch (Netherlands)",
    label: "Dutch (Netherlands)",
  },
  {
    value: "Estonian",
    label: "Estonian",
  },
  {
    value: "Finnish",
    label: "Finnish",
  },
  {
    value: "French",
    label: "French",
  },
  {
    value: "French (Belgium)",
    label: "French (Belgium)",
  },
  {
    value: "French (France)",
    label: "French (France)",
  },
  {
    value: "French (Luxembourg)",
    label: "French (Luxembourg)",
  },
  {
    value: "German",
    label: "German",
  },
  {
    value: "German (Austria)",
    label: "German (Austria)",
  },
  {
    value: "German (Belgium)",
    label: "German (Belgium)",
  },
  {
    value: "German (Germany)",
    label: "German (Germany)",
  },
  {
    value: "German (Luxembourg)",
    label: "German (Luxembourg)",
  },
  {
    value: "Greek",
    label: "Greek",
  },
  {
    value: "Greek (Cyprus)",
    label: "Greek (Cyprus)",
  },
  {
    value: "Greek (Greece)",
    label: "Greek (Greece)",
  },
  {
    value: "Hungarian",
    label: "Hungarian",
  },
  {
    value: "Icelandic",
    label: "Icelandic",
  },
  {
    value: "Irish",
    label: "Irish",
  },
  {
    value: "Italian",
    label: "Italian",
  },
  {
    value: "Latvian",
    label: "Latvian",
  },
  {
    value: "Lithuanian",
    label: "Lithuanian",
  },
  {
    value: "Maltese",
    label: "Maltese",
  },
  {
    value: "Norwegian",
    label: "Norwegian",
  },
  {
    value: "Other",
    label: "Other",
  },
  {
    value: "Polish",
    label: "Polish",
  },
  {
    value: "Portuguese",
    label: "Portuguese",
  },
  {
    value: "Romanian",
    label: "Romanian",
  },
  {
    value: "Slovak",
    label: "Slovak",
  },
  {
    value: "Slovenian",
    label: "Slovenian",
  },
  {
    value: "Spanish",
    label: "Spanish",
  },
  {
    value: "Swedish",
    label: "Swedish",
  },
  {
    value: "Swedish (Finland)",
    label: "Swedish (Finland)",
  },
  {
    value: "Swedish (Sweden)",
    label: "Swedish (Sweden)",
  },
]

export const NON_EEA_COUNTRIES = [
  {
    value: "Afghanistan",
    label: "Afghanistan",
  },
  {
    value: "Albanian",
    label: "Albanian",
  },
  {
    value: "Algeria",
    label: "Algeria",
  },
  {
    value: "American Samoa",
    label: "American Samoa",
  },
  {
    value: "Andorra",
    label: "Andorra",
  },
  {
    value: "Angola",
    label: "Angola",
  },
  {
    value: "Anguilla",
    label: "Anguilla",
  },
  {
    value: "Antartica",
    label: "Antartica",
  },
  {
    value: "Antigua and Barbuda",
    label: "Antigua and Barbuda",
  },
  {
    value: "Argentina",
    label: "Argentina",
  },
  {
    value: "Armenia",
    label: "Armenia",
  },
  {
    value: "Aruba",
    label: "Aruba",
  },
  {
    value: "Australia",
    label: "Australia",
  },
  {
    value: "Azerbaijan",
    label: "Azerbaijan",
  },
  {
    value: "Bahamas",
    label: "Bahamas",
  },
  {
    value: "Bahrain",
    label: "Bahrain",
  },
  {
    value: "Bangladesh",
    label: "Bangladesh",
  },
  {
    value: "Barbados",
    label: "Barbados",
  },
  {
    value: "Belarus",
    label: "Belarus",
  },
  {
    value: "Belize",
    label: "Belize",
  },
  {
    value: "Benin",
    label: "Benin",
  },
  {
    value: "Bermuda",
    label: "Bermuda",
  },
  {
    value: "Bhutan",
    label: "Bhutan",
  },
  {
    value: "Bolivia, Plurinational State of",
    label: "Bolivia, Plurinational State of",
  },
  {
    value: "Bosnia and Herzegovina",
    label: "Bosnia and Herzegovina",
  },
  {
    value: "Botswana",
    label: "Botswana",
  },
  {
    value: "Bouvet Island",
    label: "Bouvet Island",
  },
  {
    value: "Brazil",
    label: "Brazil",
  },
  {
    value: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  {
    value: "Brunei Darussalam",
    label: "Brunei Darussalam",
  },
  {
    value: "Burkina Faso",
    label: "Burkina Faso",
  },
  {
    value: "Burundi",
    label: "Burundi",
  },
  {
    value: "Cambodia",
    label: "Cambodia",
  },
  {
    value: "Cameroon",
    label: "Cameroon",
  },
  {
    value: "Canada",
    label: "Canada",
  },
  {
    value: "Cape Verde",
    label: "Cape Verde",
  },
  {
    value: "Cayman Islands",
    label: "Cayman Islands",
  },
  {
    value: "Central African Republic",
    label: "Central African Republic",
  },
  {
    value: "Chad",
    label: "Chad",
  },
  {
    value: "Chile",
    label: "Chile",
  },
  {
    value: "China",
    label: "China",
  },
  {
    value: "Christmas Island",
    label: "Christmas Island",
  },
  {
    value: "Cocos (Kneeling) Islands",
    label: "Cocos (Kneeling) Islands",
  },
  {
    value: "Colombia",
    label: "Colombia",
  },
  {
    value: "Comoros",
    label: "Comoros",
  },
  {
    value: "Congo",
    label: "Congo",
  },
  {
    value: "Congo, The Democratic Republic of the",
    label: "Congo, The Democratic Republic of the",
  },
  {
    value: "Cook Islands",
    label: "Cook Islands",
  },
  {
    value: "Costa Rica",
    label: "Costa Rica",
  },
  {
    value: "Cuba",
    label: "Cuba",
  },
  {
    value: "Côte d'Ivoire",
    label: "Côte d'Ivoire",
  },
  {
    value: "Djibouti",
    label: "Djibouti",
  },
  {
    value: "Dominica",
    label: "Dominica",
  },
  {
    value: "Dominican Republic",
    label: "Dominican Republic",
  },
  {
    value: "Ecuador",
    label: "Ecuador",
  },
  {
    value: "Egypt",
    label: "Egypt",
  },
  {
    value: "El Salvador",
    label: "El Salvador",
  },
  {
    value: "Eqatorial Guinea",
    label: "Eqatorial Guinea",
  },
  {
    value: "Eritrea",
    label: "Eritrea",
  },
  {
    value: "Eswatini",
    label: "Eswatini",
  },
  {
    value: "Ethiopia",
    label: "Ethiopia",
  },
  {
    value: "Faeroe Islands",
    label: "Faeroe Islands",
  },
  {
    value: "Falkland Islands (Malvinas)",
    label: "Falkland Islands (Malvinas)",
  },
  {
    value: "Fiji",
    label: "Fiji",
  },
  {
    value: "French Guiana",
    label: "French Guiana",
  },
  {
    value: "French Polynesia",
    label: "French Polynesia",
  },
  {
    value: "French Southern Territories",
    label: "French Southern Territories",
  },
  {
    value: "Gabon",
    label: "Gabon",
  },
  {
    value: "Gambia",
    label: "Gambia",
  },
  {
    value: "Georgia",
    label: "Georgia",
  },
  {
    value: "Ghana",
    label: "Ghana",
  },
  {
    value: "Gibraltar",
    label: "Gibraltar",
  },
  {
    value: "Greenland",
    label: "Greenland",
  },
  {
    value: "Grenada",
    label: "Grenada",
  },
  {
    value: "Guadeloupe",
    label: "Guadeloupe",
  },
  {
    value: "Guam",
    label: "Guam",
  },
  {
    value: "Guatemala",
    label: "Guatemala",
  },
  {
    value: "Guernsey",
    label: "Guernsey",
  },
  {
    value: "Guinea",
    label: "Guinea",
  },
  {
    value: "Guinea-Bissau",
    label: "Guinea-Bissau",
  },
  {
    value: "Guyana",
    label: "Guyana",
  },
  {
    value: "Haiti",
    label: "Haiti",
  },
  {
    value: "Heard Island and McDonald Islands",
    label: "Heard Island and McDonald Islands",
  },
  {
    value: "Holy See (Vatican City State)",
    label: "Holy See (Vatican City State)",
  },
  {
    value: "Honduras",
    label: "Honduras",
  },
  {
    value: "Hong Kong",
    label: "Hong Kong",
  },
  {
    value: "India",
    label: "India",
  },
  {
    value: "Indonesia",
    label: "Indonesia",
  },
  {
    value: "Iran, Islamic Republic of",
    label: "Iran, Islamic Republic of",
  },
  {
    value: "Iraq",
    label: "Iraq",
  },
  {
    value: "Isle of Man",
    label: "Isle of Man",
  },
  {
    value: "Israel",
    label: "Israel",
  },
  {
    value: "Jamaica",
    label: "Jamaica",
  },
  {
    value: "Japan",
    label: "Japan",
  },
  {
    value: "Jersey",
    label: "Jersey",
  },
  {
    value: "Jordan",
    label: "Jordan",
  },
  {
    value: "Kazakhstan",
    label: "Kazakhstan",
  },
  {
    value: "Kenya",
    label: "Kenya",
  },
  {
    value: "Kiribati",
    label: "Kiribati",
  },
  {
    value: "Korea, Democratic People's Republic of",
    label: "Korea, Democratic People's Republic of",
  },
  {
    value: "Korea, Republic of",
    label: "Korea, Republic of",
  },
  {
    value: "Kuwait",
    label: "Kuwait",
  },
  {
    value: "Kyrgyzstan",
    label: "Kyrgyzstan",
  },
  {
    value: "Lao People's Democratic Republic",
    label: "Lao People's Democratic Republic",
  },
  {
    value: "Lebanon",
    label: "Lebanon",
  },
  {
    value: "Lesotho",
    label: "Lesotho",
  },
  {
    value: "Liberia",
    label: "Liberia",
  },
  {
    value: "Libyan Arab Jamahiriya",
    label: "Libyan Arab Jamahiriya",
  },
  {
    value: "Macau",
    label: "Macau",
  },
  {
    value: "Madagascar",
    label: "Madagascar",
  },
  {
    value: "Malawi",
    label: "Malawi",
  },
  {
    value: "Malaysia",
    label: "Malaysia",
  },
  {
    value: "Maldives",
    label: "Maldives",
  },
  {
    value: "Mali",
    label: "Mali",
  },
  {
    value: "Marshall Islands",
    label: "Marshall Islands",
  },
  {
    value: "Martinique",
    label: "Martinique",
  },
  {
    value: "Mauritania",
    label: "Mauritania",
  },
  {
    value: "Mauritius",
    label: "Mauritius",
  },
  {
    value: "Mayotte",
    label: "Mayotte",
  },
  {
    value: "Mexico",
    label: "Mexico",
  },
  {
    value: "Micronesia, Federated States of",
    label: "Micronesia, Federated States of",
  },
  {
    value: "Maldova, Republic of",
    label: "Maldova, Republic of",
  },
  {
    value: "Monaco",
    label: "Monaco",
  },
  {
    value: "Mongolia",
    label: "Mongolia",
  },
  {
    value: "Montenegro",
    label: "Montenegro",
  },
  {
    value: "Montserrat",
    label: "Montserrat",
  },
  {
    value: "Morocco",
    label: "Morocco",
  },
  {
    value: "Mozambique",
    label: "Mozambique",
  },
  {
    value: "Myanmar",
    label: "Myanmar",
  },
  {
    value: "Namibia",
    label: "Namibia",
  },
  {
    value: "Nauru",
    label: "Nauru",
  },
  {
    value: "Nepal",
    label: "Nepal",
  },
  {
    value: "New Caledonia",
    label: "New Caledonia",
  },
  {
    value: "New Zealand",
    label: "New Zealand",
  },
  {
    value: "Nicaragua",
    label: "Nicaragua",
  },
  {
    value: "Niger",
    label: "Niger",
  },
  {
    value: "Nigeria",
    label: "Nigeria",
  },
  {
    value: "Niue",
    label: "Niue",
  },
  {
    value: "Norfolk Island",
    label: "Norfolk Island",
  },
  {
    value: "North Macedonia",
    label: "North Macedonia",
  },
  {
    value: "Northern Mariana Islands",
    label: "Northern Mariana Islands",
  },
  {
    value: "Oman",
    label: "Oman",
  },
  {
    value: "Pakistan",
    label: "Pakistan",
  },
  {
    value: "Palau",
    label: "Palau",
  },
  {
    value: "Palestinian Territory, Occupied",
    label: "Palestinian Territory, Occupied",
  },
  {
    value: "Panama",
    label: "Panama",
  },
  {
    value: "Papua New Guinea",
    label: "Papua New Guinea",
  },
  {
    value: "Paraguay",
    label: "Paraguay",
  },
  {
    value: "Peru",
    label: "Peru",
  },
  {
    value: "Philippines",
    label: "Philippines",
  },
  {
    value: "Pitcairn",
    label: "Pitcairn",
  },
  {
    value: "Puerto Rico",
    label: "Puerto Rico",
  },
  {
    value: "Qatar",
    label: "Qatar",
  },
  {
    value: "Russian Federation",
    label: "Russian Federation",
  },
  {
    value: "Rwanda",
    label: "Rwanda",
  },
  {
    value: "Réunion",
    label: "Réunion",
  },
  {
    value: "Saint Barthelemy",
    label: "Saint Barthelemy",
  },
  {
    value: "Saint Helena, Ascension and Tristan da Cunha",
    label: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    value: "Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
  },
  {
    value: "Saint Lucia",
    label: "Saint Lucia",
  },
  {
    value: "Saint Martin (French Part)",
    label: "Saint Martin (French Part)",
  },
  {
    value: "Saint Pierre and Miquelon",
    label: "Saint Pierre and Miquelon",
  },
  {
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  {
    value: "Samoa",
    label: "Samoa",
  },
  {
    value: "San Marino",
    label: "San Marino",
  },
  {
    value: "Saudi Arabia",
    label: "Saudi Arabia",
  },
  {
    value: "Senegal",
    label: "Senegal",
  },
  {
    value: "Serbia",
    label: "Serbia",
  },
  {
    value: "Seychelles",
    label: "Seychelles",
  },
  {
    value: "Sierra Leone",
    label: "Sierra Leone",
  },
  {
    value: "Singapore",
    label: "Singapore",
  },
  {
    value: "Solomon Islands",
    label: "Solomon Islands",
  },
  {
    value: "Somalia",
    label: "Somalia",
  },
  {
    value: "South Africa",
    label: "South Africa",
  },
  {
    value: "South Georgia and the South Sandwich Islands",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    value: "Sri Lanka",
    label: "Sri Lanka",
  },
  {
    value: "Sudan",
    label: "Sudan",
  },
  {
    value: "Suriname",
    label: "Suriname",
  },
  {
    value: "Svalbard and Jan Mayen",
    label: "Svalbard and Jan Mayen",
  },
  {
    value: "Switzerland",
    label: "Switzerland",
  },
  {
    value: "Syria",
    label: "Syria",
  },
  {
    value: "São Tomé and Príncipe",
    label: "São Tomé and Príncipe",
  },
  {
    value: "Taiwan",
    label: "Taiwan",
  },
  {
    value: "Tajikistan",
    label: "Tajikistan",
  },
  {
    value: "Tanzania, United Republic of",
    label: "Tanzania, United Republic of",
  },
  {
    value: "Thailand",
    label: "Thailand",
  },
  {
    value: "Timor-Leste",
    label: "Timor-Leste",
  },
  {
    value: "Togo",
    label: "Togo",
  },
  {
    value: "Tokelau",
    label: "Tokelau",
  },
  {
    value: "Tonga",
    label: "Tonga",
  },
  {
    value: "Trinidad and Tobago",
    label: "Trinidad and Tobago",
  },
  {
    value: "Tunisia",
    label: "Tunisia",
  },
  {
    value: "Turkey",
    label: "Turkey",
  },
  {
    value: "Turkmenistan",
    label: "Turkmenistan",
  },
  {
    value: "Turks and Caicos Islands",
    label: "Turks and Caicos Islands",
  },
  {
    value: "Tuvalu",
    label: "Tuvalu",
  },
  {
    value: "Uganda",
    label: "Uganda",
  },
  {
    value: "Ukraine",
    label: "Ukraine",
  },
  {
    value: "United Arab Emirates",
    label: "United Arab Emirates",
  },
  {
    value: "United Kingdom",
    label: "United Kingdom",
  },
  {
    value: "United States",
    label: "United States",
  },
  {
    value: "United States Minor Outlying Islands",
    label: "United States Minor Outlying Islands",
  },
  {
    value: "Uruguay",
    label: "Uruguay",
  },
  {
    value: "Uzbekistan",
    label: "Uzbekistan",
  },
  {
    value: "Vanuatu",
    label: "Vanuatu",
  },
  {
    value: "Venezuela, Bolivian Republic of",
    label: "Venezuela, Bolivian Republic of",
  },
  {
    value: "Vietnam",
    label: "Vietnam",
  },
  {
    value: "Virgin Islands, British",
    label: "Virgin Islands, British",
  },
  {
    value: "Virgin Islands, U.S.",
    label: "Virgin Islands, U.S.",
  },
  {
    value: "Wallis and Futuna",
    label: "Wallis and Futuna",
  },
  {
    value: "Western Sahara",
    label: "Western Sahara",
  },
  {
    value: "Yemen",
    label: "Yemen",
  },
  {
    value: "Zambia",
    label: "Zambia",
  },
  {
    value: "Zimbabwe",
    label: "Zimbabwe",
  },
  {
    value: "Åland Islands",
    label: "Åland Islands",
  },
]

export const CTIS_THERA_AREA_OPTIONS = [
  {
    value: "Disease [C] - Bacterial Infections and Mycoses [C01]",
    label: "Disease [C] - Bacterial Infections and Mycoses [C01]",
  },
  {
    value: "Disease [C] - Virus Diseases [C02]",
    label: "Disease [C] - Virus Diseases [C02]",
  },
  {
    value: "Disease [C] - Parasitic Diseases [C03]",
    label: "Disease [C] - Parasitic Diseases [C03]",
  },
  {
    value: "Disease [C] - Neoplasms [C04]",
    label: "Disease [C] - Neoplasms [C04]",
  },
  {
    value: "Disease [C] - Musculoskeletal Diseases [C05]",
    label: "Disease [C] - Musculoskeletal Diseases [C05]",
  },
  {
    value: "Disease [C] - Digestive System Diseases [C06]",
    label: "Disease [C] - Digestive System Diseases [C06]",
  },
  {
    value: "Disease [C] - Stomatognathic Diseases [C07]",
    label: "Disease [C] - Stomatognathic Diseases [C07]",
  },
  {
    value: "Disease [C] - Respiratory Tract Diseases [C08]",
    label: "Disease [C] - Respiratory Tract Diseases [C08]",
  },
  {
    value: "Disease [C] - Otorhinolaryngologic Diseases [C09]",
    label: "Disease [C] - Otorhinolaryngologic Diseases [C09]",
  },
  {
    value: "Disease [C] - Nervous System Diseases [C10]",
    label: "Disease [C] - Nervous System Diseases [C10]",
  },
  {
    value: "Disease [C] - Eye Diseases [C11]",
    label: "Disease [C] - Eye Diseases [C11]",
  },
  {
    value: "Disease [C] - Male Urogenital Diseases [C12]",
    label: "Disease [C] - Male Urogenital Diseases [C12]",
  },
  {
    value: "Disease [C] - Female Urogenital Diseases and Pregnancy Complications [C13]",
    label: "Disease [C] - Female Urogenital Diseases and Pregnancy Complications [C13]",
  },
  {
    value: "Disease [C] - Cardiovascular Diseases [C14]",
    label: "Disease [C] - Cardiovascular Diseases [C14]",
  },
  {
    value: "Disease [C] - Hemic and Lymphatic Diseases [C15]",
    label: "Disease [C] - Hemic and Lymphatic Diseases [C15]",
  },
  {
    value: "Disease [C] - Congenital, Hereditary, and Neonatal Diseases and Abnormalities [C16]",
    label: "Disease [C] - Congenital, Hereditary, and Neonatal Diseases and Abnormalities [C16]",
  },
  {
    value: "Disease [C] - Skin and Connective Tissue Diseases [C17]",
    label: "Disease [C] - Skin and Connective Tissue Diseases [C17]",
  },
  {
    value: "Disease [C] - Nutritional and Metabolic Diseases [C18]",
    label: "Disease [C] - Nutritional and Metabolic Diseases [C18]",
  },
  {
    value: "Disease [C] - Hormonal diseases [C19]",
    label: "Disease [C] - Hormonal diseases [C19]",
  },
  {
    value: "Disease [C] - Immune System Diseases [C20]",
    label: "Disease [C] - Immune System Diseases [C20]",
  },
  {
    value: "Disease [C] - Disorders of Environmental Origin [C21]",
    label: "Disease [C] - Disorders of Environmental Origin [C21]",
  },
  {
    value: "Disease [C] - Animal Diseases [C22]",
    label: "Disease [C] - Animal Diseases [C22]",
  },
  {
    value: "Disease [C] - Pathological Conditions, Signs and Symptoms",
    label: "Disease [C] - Pathological Conditions, Signs and Symptoms",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Diagnosis [E01]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Diagnosis [E01]",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Therapeutics [E02]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Therapeutics [E02]",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Anesthesia and Analgesia [E03]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Anesthesia and Analgesia [E03]",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Surgical Procedures, Operative [E04]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Surgical Procedures, Operative [E04]",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Investigative Techniques [E05]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Investigative Techniques [E05]",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Dentistry [E06]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Dentistry [E06]",
  },
  {
    value: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Equipment and Supplies [E07]",
    label: "Analytical, Diagnostic and Therapeutic Techniques and Equipment [E] - Equipment and Supplies [E07]",
  },
  {
    value: "Psychiatry and Psychology [F] - Behavior and Behavior Mechanics [F01]",
    label: "Psychiatry and Psychology [F] - Behavior and Behavior Mechanics [F01]",
  },
  {
    value: "Psychiatry and Psychology [F] - Psychological Phenomena [F02]",
    label: "Psychiatry and Psychology [F] - Psychological Phenomena [F02]",
  },
  {
    value: "Psychiatry and Psychology [F] - Mental Disorders [F03]",
    label: "Psychiatry and Psychology [F] - Mental Disorders [F03]",
  },
  {
    value: "Psychiatry and Psychology [F] - Behavioral Disciplines and Activities [F04]",
    label: "Psychiatry and Psychology [F] - Behavioral Disciplines and Activities [F04]",
  },
  {
    value: "Phenomena and Processes [G] - Physical Phenomena [G01]",
    label: "Phenomena and Processes [G] - Physical Phenomena [G01]",
  },
  {
    value: "Phenomena and Processes [G] - Chemical Phenomena [G02]",
    label: "Phenomena and Processes [G] - Chemical Phenomena [G02]",
  },
  {
    value: "Phenomena and Processes [G] - Metabolism [G03]",
    label: "Phenomena and Processes [G] - Metabolism [G03]",
  },
  {
    value: "Phenomena and Processes [G] - Cell Physiological Phenomena [G04]",
    label: "Phenomena and Processes [G] - Cell Physiological Phenomena [G04]",
  },
  {
    value: "Phenomena and Processes [G] - Genetic Phenomena [G05]",
    label: "Phenomena and Processes [G] - Genetic Phenomena [G05]",
  },
  {
    value: "Phenomena and Processes [G] - Microbiological Phenomena [G06]",
    label: "Phenomena and Processes [G] - Microbiological Phenomena [G06]",
  },
  {
    value: "Phenomena and Processes [G] - Physiological processes [G07]",
    label: "Phenomena and Processes [G] - Physiological processes [G07]",
  },
  {
    value: "Phenomena and Processes [G] - Reproductive and Urinary Physiological Phenomena [G08]",
    label: "Phenomena and Processes [G] - Reproductive and Urinary Physiological Phenomena [G08]",
  },
  {
    value: "Phenomena and Processes [G] - Circulatory and Respiratory Physiological Phenomena [G09]",
    label: "Phenomena and Processes [G] - Circulatory and Respiratory Physiological Phenomena [G09]",
  },
  {
    value: "Phenomena and Processes [G] - Digestive System and Oral Physiological Phenomena [G10]",
    label: "Phenomena and Processes [G] - Digestive System and Oral Physiological Phenomena [G10]",
  },
  {
    value: "Phenomena and Processes [G] - Musculoskeletal and Neural Physiological Phenomena [G11]",
    label: "Phenomena and Processes [G] - Musculoskeletal and Neural Physiological Phenomena [G11]",
  },
  {
    value: "Phenomena and Processes [G] - Immune system processes [G12]",
    label: "Phenomena and Processes [G] - Immune system processes [G12]",
  },
  {
    value: "Phenomena and Processes [G] - Immune System Phenomena [G13]",
    label: "Phenomena and Processes [G] - Immune System Phenomena [G13]",
  },
  {
    value: "Phenomena and Processes [G] - Ocular Physiological Phenomena [G14]",
    label: "Phenomena and Processes [G] - Ocular Physiological Phenomena [G14]",
  },
  {
    value: "Phenomena and Processes [G] - Plant Physiological Phenomena [G15]",
    label: "Phenomena and Processes [G] - Plant Physiological Phenomena [G15]",
  },
  {
    value: "Phenomena and Processes [G] - Biological Phenomena [G16]",
    label: "Phenomena and Processes [G] - Biological Phenomena [G16]",
  },
  {
    value: "Phenomena and Processes [G] - Mathematical Concepts [G17]",
    label: "Phenomena and Processes [G] - Mathematical Concepts [G17]",
  },
  {
    value: "Health Care [N] - Population Concepts [N01]",
    label: "Health Care [N] - Population Concepts [N01]",
  },
  {
    value: "Health Care [N] - Health Care Facilities, Manpower, and Services [N02]",
    label: "Health Care [N] - Health Care Facilities, Manpower, and Services [N02]",
  },
  {
    value: "Health Care [N] - Health Care Economics and Organizations [N03]",
    label: "Health Care [N] - Health Care Economics and Organizations [N03]",
  },
  {
    value: "Health Care [N] - Health Services Administration [N04]",
    label: "Health Care [N] - Health Services Administration [N04]",
  },
  {
    value: "Health Care [N] - Health Care Quality, Access, and Evaluation [N05]",
    label: "Health Care [N] - Health Care Quality, Access, and Evaluation [N05]",
  },
  {
    value: "Health Care [N] - Environment and Public Health [N06]",
    label: "Health Care [N] - Environment and Public Health [N06]",
  },
  {
    value: "Not possible to specify",
    label: "Not possible to specify",
  },
]

export const CTIS_MEMBER_STATES = [
  {
    value: "Austria",
    label: "Austria",
  },
  {
    value: "Belgium",
    label: "Belgium",
  },
  {
    value: "Bulgaria",
    label: "Bulgaria",
  },
  {
    value: "Croatia",
    label: "Croatia",
  },
  {
    value: "Cyprus",
    label: "Cyprus",
  },
  {
    value: "Czechia",
    label: "Czechia",
  },
  {
    value: "Denmark",
    label: "Denmark",
  },
  {
    value: "Estonia",
    label: "Estonia",
  },
  {
    value: "Finland",
    label: "Finland",
  },
  {
    value: "France",
    label: "France",
  },
  {
    value: "Germany",
    label: "Germany",
  },
  {
    value: "Greece",
    label: "Greece",
  },
  {
    value: "Hungary",
    label: "Hungary",
  },
  {
    value: "Iceland",
    label: "Iceland",
  },
  {
    value: "Ireland",
    label: "Ireland",
  },
  {
    value: "Italy",
    label: "Italy",
  },
  {
    value: "Latvia",
    label: "Latvia",
  },
  {
    value: "Liechtenstein",
    label: "Liechtenstein",
  },
  {
    value: "Lithuania",
    label: "Lithuania",
  },
  {
    value: "Luxembourg",
    label: "Luxembourg",
  },
  {
    value: "Malta",
    label: "Malta",
  },
  {
    value: "Netherlands",
    label: "Netherlands",
  },
  {
    value: "Norway",
    label: "Norway",
  },
  {
    value: "Poland",
    label: "Poland",
  },
  {
    value: "Portugal",
    label: "Portugal",
  },
  {
    value: "Romania",
    label: "Romania",
  },
  {
    value: "Slovakia",
    label: "Slovakia",
  },
  {
    value: "Slovenia",
    label: "Slovenia",
  },
  {
    value: "Spain",
    label: "Spain",
  },
  {
    value: "Sweden",
    label: "Sweden",
  },
]

export const CTIS_PHARMA_FORMS = [
  {
    value: "177lu-ppf11n",
    label: "177lu-ppf11n",
  },
  {
    value: "Aav2 vector for gene therapy",
    label: "Aav2 vector for gene therapy",
  },
  {
    value: "Aav8 vector for gene therapy",
    label: "Aav8 vector for gene therapy",
  },
  {
    value: "Aerosol spray",
    label: "Aerosol spray",
  },
  {
    value: "Anticoagulant and preservative solution for blood",
    label: "Anticoagulant and preservative solution for blood",
  },
  {
    value: "Anticoagulant solution",
    label: "Anticoagulant solution",
  },
  {
    value: "Aqueous gel",
    label: "Aqueous gel",
  },
  {
    value: "Aqueous nanosuspension",
    label: "Aqueous nanosuspension",
  },
  {
    value: "Aqueous solution",
    label: "Aqueous solution",
  },
  {
    value: "Aqueous solution for injection",
    label: "Aqueous solution for injection",
  },
  {
    value: "Aqueous solution for intravenous (iv) administration",
    label: "Aqueous solution for intravenous (iv) administration",
  },
  {
    value: "Aqueous suspension",
    label: "Aqueous suspension",
  },
  {
    value:
      "Autologous cd4- and cd8- positive t-cells transduced with lentiviral vector expressing a high affinity afp specific tcr",
    label:
      "Autologous cd4- and cd8- positive t-cells transduced with lentiviral vector expressing a high affinity afp specific tcr",
  },
  {
    value:
      "Autologous cd4- and cd8-positive t cells that have been transduced with a self-inactivating lentiviral vector expressing a high affinity mage-aspecific tcr",
    label:
      "Autologous cd4- and cd8-positive t cells that have been transduced with a self-inactivating lentiviral vector expressing a high affinity mage-aspecific tcr",
  },
  {
    value: "Bath additive",
    label: "Bath additive",
  },
  {
    value: "Bladder irrigation",
    label: "Bladder irrigation",
  },
  {
    value: "Blood fraction modifier",
    label: "Blood fraction modifier",
  },
  {
    value: "Buccal film",
    label: "Buccal film",
  },
  {
    value: "Buccal tablet",
    label: "Buccal tablet",
  },
  {
    value: "Cachet",
    label: "Cachet",
  },
  {
    value: "Capsule",
    label: "Capsule",
  },
  {
    value: "Capsule for oral use",
    label: "Capsule for oral use",
  },
  {
    value: "Capsule, hard",
    label: "Capsule, hard",
  },
  {
    value: "Capsule, prolonged release, hard",
    label: "Capsule, prolonged release, hard",
  },
  {
    value: "Capsule, soft",
    label: "Capsule, soft",
  },
  {
    value: "Capsules",
    label: "Capsules",
  },
  {
    value: "Capsules containing prolonged-release microgranules",
    label: "Capsules containing prolonged-release microgranules",
  },
  {
    value: "Capsules liquid filled",
    label: "Capsules liquid filled",
  },
  {
    value: "Capsules, zacht",
    label: "Capsules, zacht",
  },
  {
    value: "Cell suspension",
    label: "Cell suspension",
  },
  {
    value: "Cell suspension for injection",
    label: "Cell suspension for injection",
  },
  {
    value: "Cell suspension for topical administration",
    label: "Cell suspension for topical administration",
  },
  {
    value: "Cells seeded on scaffold for implantation",
    label: "Cells seeded on scaffold for implantation",
  },
  {
    value: "Ceroxin 500 mg filmtabletta",
    label: "Ceroxin 500 mg filmtabletta",
  },
  {
    value: "Chewable capsule, soft",
    label: "Chewable capsule, soft",
  },
  {
    value: "Chewable tablet",
    label: "Chewable tablet",
  },
  {
    value: "Chewable/dispersible tablet",
    label: "Chewable/dispersible tablet",
  },
  {
    value: "Chewing gum",
    label: "Chewing gum",
  },
  {
    value: "Coated granules",
    label: "Coated granules",
  },
  {
    value: "Coated granules in sachet",
    label: "Coated granules in sachet",
  },
  {
    value: "Coated tablet",
    label: "Coated tablet",
  },
  {
    value: "Collodion",
    label: "Collodion",
  },
  {
    value: "Compressed lozenge",
    label: "Compressed lozenge",
  },
  {
    value: "Compressed tablet",
    label: "Compressed tablet",
  },
  {
    value: "Compressed tablet sustained release",
    label: "Compressed tablet sustained release",
  },
  {
    value: "Concentrate and diluent for solution for injection",
    label: "Concentrate and diluent for solution for injection",
  },
  {
    value: "Concentrate and solvent for concentrate for solution for infusion",
    label: "Concentrate and solvent for concentrate for solution for infusion",
  },
  {
    value: "Concentrate and solvent for cutaneous solution",
    label: "Concentrate and solvent for cutaneous solution",
  },
  {
    value: "Concentrate and solvent for dispersion for injection",
    label: "Concentrate and solvent for dispersion for injection",
  },
  {
    value: "Concentrate and solvent for emulsion for injection",
    label: "Concentrate and solvent for emulsion for injection",
  },
  {
    value: "Concentrate and solvent for intravesical solution",
    label: "Concentrate and solvent for intravesical solution",
  },
  {
    value: "Concentrate and solvent for solution for infusion",
    label: "Concentrate and solvent for solution for infusion",
  },
  {
    value: "Concentrate and solvent for solution for injection",
    label: "Concentrate and solvent for solution for injection",
  },
  {
    value: "Concentrate and solvent for solution for injection/infusion",
    label: "Concentrate and solvent for solution for injection/infusion",
  },
  {
    value: "Concentrate and solvent for suspension for injection",
    label: "Concentrate and solvent for suspension for injection",
  },
  {
    value: "Concentrate for concentrate for solution for infusion",
    label: "Concentrate for concentrate for solution for infusion",
  },
  {
    value: "Concentrate for cutaneous solution",
    label: "Concentrate for cutaneous solution",
  },
  {
    value: "Concentrate for cutaneous spray, emulsion",
    label: "Concentrate for cutaneous spray, emulsion",
  },
  {
    value: "Concentrate for dispersion for infusion",
    label: "Concentrate for dispersion for infusion",
  },
  {
    value: "Concentrate for dispersion for injection",
    label: "Concentrate for dispersion for injection",
  },
  {
    value: "Concentrate for emulsion for infusion",
    label: "Concentrate for emulsion for infusion",
  },
  {
    value: "Concentrate for emulsion for injection",
    label: "Concentrate for emulsion for injection",
  },
  {
    value: "Concentrate for gargle",
    label: "Concentrate for gargle",
  },
  {
    value: "Concentrate for haemodialysis solution",
    label: "Concentrate for haemodialysis solution",
  },
  {
    value: "Concentrate for infusion",
    label: "Concentrate for infusion",
  },
  {
    value: "Concentrate for intravesical solution",
    label: "Concentrate for intravesical solution",
  },
  {
    value: "Concentrate for nebuliser solution",
    label: "Concentrate for nebuliser solution",
  },
  {
    value: "Concentrate for oral solution",
    label: "Concentrate for oral solution",
  },
  {
    value: "Concentrate for oral suspension",
    label: "Concentrate for oral suspension",
  },
  {
    value: "Concentrate for oral/rectal solution",
    label: "Concentrate for oral/rectal solution",
  },
  {
    value: "Concentrate for oromucosal solution",
    label: "Concentrate for oromucosal solution",
  },
  {
    value: "Concentrate for rectal solution",
    label: "Concentrate for rectal solution",
  },
  {
    value: "Concentrate for solution for enteral spray",
    label: "Concentrate for solution for enteral spray",
  },
  {
    value: "Concentrate for solution for haemodialysis",
    label: "Concentrate for solution for haemodialysis",
  },
  {
    value: "Concentrate for solution for infusion",
    label: "Concentrate for solution for infusion",
  },
  {
    value: "Concentrate for solution for injection",
    label: "Concentrate for solution for injection",
  },
  {
    value: "Concentrate for solution for injection/infusion",
    label: "Concentrate for solution for injection/infusion",
  },
  {
    value: "Concentrate for solution for intraocular irrigation",
    label: "Concentrate for solution for intraocular irrigation",
  },
  {
    value: "Concentrate for solution for iv injection",
    label: "Concentrate for solution for iv injection",
  },
  {
    value: "Concentrate for solution for peritoneal dialysis",
    label: "Concentrate for solution for peritoneal dialysis",
  },
  {
    value: "Concentrate for suspension for infusion",
    label: "Concentrate for suspension for infusion",
  },
  {
    value: "Concentrate for suspension for injection",
    label: "Concentrate for suspension for injection",
  },
  {
    value: "Cream",
    label: "Cream",
  },
  {
    value: "Cutaneous emulsion",
    label: "Cutaneous emulsion",
  },
  {
    value: "Cutaneous foam",
    label: "Cutaneous foam",
  },
  {
    value: "Cutaneous liquid",
    label: "Cutaneous liquid",
  },
  {
    value: "Cutaneous paste",
    label: "Cutaneous paste",
  },
  {
    value: "Cutaneous patch",
    label: "Cutaneous patch",
  },
  {
    value: "Cutaneous powder",
    label: "Cutaneous powder",
  },
  {
    value: "Cutaneous solution",
    label: "Cutaneous solution",
  },
  {
    value: "Cutaneous solution in single-dose container",
    label: "Cutaneous solution in single-dose container",
  },
  {
    value: "Cutaneous solution/concentrate for oromucosal solution",
    label: "Cutaneous solution/concentrate for oromucosal solution",
  },
  {
    value: "Cutaneous spray",
    label: "Cutaneous spray",
  },
  {
    value: "Cutaneous spray, emulsion",
    label: "Cutaneous spray, emulsion",
  },
  {
    value: "Cutaneous spray, ointment",
    label: "Cutaneous spray, ointment",
  },
  {
    value: "Cutaneous spray, powder",
    label: "Cutaneous spray, powder",
  },
  {
    value: "Cutaneous spray, solution",
    label: "Cutaneous spray, solution",
  },
  {
    value: "Cutaneous spray, suspension",
    label: "Cutaneous spray, suspension",
  },
  {
    value: "Cutaneous stick",
    label: "Cutaneous stick",
  },
  {
    value: "Cutaneous suspension",
    label: "Cutaneous suspension",
  },
  {
    value: "Cutaneous use cream",
    label: "Cutaneous use cream",
  },
  {
    value: "Cutaneous/nasal ointment",
    label: "Cutaneous/nasal ointment",
  },
  {
    value: "Cutaneous/oromucosal solution",
    label: "Cutaneous/oromucosal solution",
  },
  {
    value: "Dental cement",
    label: "Dental cement",
  },
  {
    value: "Dental emulsion",
    label: "Dental emulsion",
  },
  {
    value: "Dental gel",
    label: "Dental gel",
  },
  {
    value: "Dental liquid",
    label: "Dental liquid",
  },
  {
    value: "Dental paste",
    label: "Dental paste",
  },
  {
    value: "Dental powder",
    label: "Dental powder",
  },
  {
    value: "Dental solution",
    label: "Dental solution",
  },
  {
    value: "Dental stick",
    label: "Dental stick",
  },
  {
    value: "Dental suspension",
    label: "Dental suspension",
  },
  {
    value: "Denture lacquer",
    label: "Denture lacquer",
  },
  {
    value: "Device for vaginal use",
    label: "Device for vaginal use",
  },
  {
    value: "Dispersible tablet",
    label: "Dispersible tablet",
  },
  {
    value: "Dispersible tablets for dose dispenser",
    label: "Dispersible tablets for dose dispenser",
  },
  {
    value: "Dispersion",
    label: "Dispersion",
  },
  {
    value: "Dispersion for concentrate for dispersion for infusion",
    label: "Dispersion for concentrate for dispersion for infusion",
  },
  {
    value: "Dispersion for infusion",
    label: "Dispersion for infusion",
  },
  {
    value: "Dispersion for injection",
    label: "Dispersion for injection",
  },
  {
    value: "Dispersion for injection/infusion",
    label: "Dispersion for injection/infusion",
  },
  {
    value: "Dna plasmid",
    label: "Dna plasmid",
  },
  {
    value: "Drops",
    label: "Drops",
  },
  {
    value: "Drug depot",
    label: "Drug depot",
  },
  {
    value: "Dry filled capsule (dfc)",
    label: "Dry filled capsule (dfc)",
  },
  {
    value: "Dry-filled capsule",
    label: "Dry-filled capsule",
  },
  {
    value: "Ear cream",
    label: "Ear cream",
  },
  {
    value: "Ear drops",
    label: "Ear drops",
  },
  {
    value: "Ear drops, emulsion",
    label: "Ear drops, emulsion",
  },
  {
    value: "Ear drops, powder and solvent for suspension",
    label: "Ear drops, powder and solvent for suspension",
  },
  {
    value: "Ear drops, powder for suspension",
    label: "Ear drops, powder for suspension",
  },
  {
    value: "Ear drops, solution",
    label: "Ear drops, solution",
  },
  {
    value: "Ear drops, suspension",
    label: "Ear drops, suspension",
  },
  {
    value: "Ear drops, suspension in single-dose container",
    label: "Ear drops, suspension in single-dose container",
  },
  {
    value: "Ear gel",
    label: "Ear gel",
  },
  {
    value: "Ear ointment",
    label: "Ear ointment",
  },
  {
    value: "Ear powder",
    label: "Ear powder",
  },
  {
    value: "Ear spray",
    label: "Ear spray",
  },
  {
    value: "Ear spray, emulsion",
    label: "Ear spray, emulsion",
  },
  {
    value: "Ear spray, solution",
    label: "Ear spray, solution",
  },
  {
    value: "Ear spray, suspension",
    label: "Ear spray, suspension",
  },
  {
    value: "Ear stick",
    label: "Ear stick",
  },
  {
    value: "Ear tampon",
    label: "Ear tampon",
  },
  {
    value: "Ear wash",
    label: "Ear wash",
  },
  {
    value: "Ear wash, emulsion",
    label: "Ear wash, emulsion",
  },
  {
    value: "Ear wash, solution",
    label: "Ear wash, solution",
  },
  {
    value: "Ear/eye drops, solution",
    label: "Ear/eye drops, solution",
  },
  {
    value: "Ear/eye drops, suspension",
    label: "Ear/eye drops, suspension",
  },
  {
    value: "Ear/eye ointment",
    label: "Ear/eye ointment",
  },
  {
    value: "Ear/eye/nasal drops, solution",
    label: "Ear/eye/nasal drops, solution",
  },
  {
    value: "Ear/nasal drops, suspension",
    label: "Ear/nasal drops, suspension",
  },
  {
    value: "Effervescent granules",
    label: "Effervescent granules",
  },
  {
    value: "Effervescent granules and suspension for oral suspension",
    label: "Effervescent granules and suspension for oral suspension",
  },
  {
    value: "Effervescent granules for oral suspension",
    label: "Effervescent granules for oral suspension",
  },
  {
    value: "Effervescent powder",
    label: "Effervescent powder",
  },
  {
    value: "Effervescent powder and powder for oral suspension",
    label: "Effervescent powder and powder for oral suspension",
  },
  {
    value: "Effervescent powder and suspension for oral suspension",
    label: "Effervescent powder and suspension for oral suspension",
  },
  {
    value: "Effervescent powder for oral suspension",
    label: "Effervescent powder for oral suspension",
  },
  {
    value: "Effervescent tablet",
    label: "Effervescent tablet",
  },
  {
    value: "Effervescent vaginal tablet",
    label: "Effervescent vaginal tablet",
  },
  {
    value: "Emulsion",
    label: "Emulsion",
  },
  {
    value: "Emulsion and suspension for emulsion for injection",
    label: "Emulsion and suspension for emulsion for injection",
  },
  {
    value: "Emulsion for emulsion for injection",
    label: "Emulsion for emulsion for injection",
  },
  {
    value: "Emulsion for infusion",
    label: "Emulsion for infusion",
  },
  {
    value: "Emulsion for infusion in administration system",
    label: "Emulsion for infusion in administration system",
  },
  {
    value: "Emulsion for injection",
    label: "Emulsion for injection",
  },
  {
    value: "Emulsion for injection/infusion",
    label: "Emulsion for injection/infusion",
  },
  {
    value: "Emulsion for injection/infusion in pre-filled syringe",
    label: "Emulsion for injection/infusion in pre-filled syringe",
  },
  {
    value: "Emulsion for suspension for injection",
    label: "Emulsion for suspension for injection",
  },
  {
    value: "Endocervical gel",
    label: "Endocervical gel",
  },
  {
    value: "Endosinusal wash, suspension",
    label: "Endosinusal wash, suspension",
  },
  {
    value: "Endosinusial solution",
    label: "Endosinusial solution",
  },
  {
    value: "Endosinusial wash, suspension",
    label: "Endosinusial wash, suspension",
  },
  {
    value: "Endotracheopulmonary instillation",
    label: "Endotracheopulmonary instillation",
  },
  {
    value: "Endotracheopulmonary instillation, powder and solvent for solution",
    label: "Endotracheopulmonary instillation, powder and solvent for solution",
  },
  {
    value: "Endotracheopulmonary instillation, powder and solvent for suspension",
    label: "Endotracheopulmonary instillation, powder and solvent for suspension",
  },
  {
    value: "Endotracheopulmonary instillation, powder for solution",
    label: "Endotracheopulmonary instillation, powder for solution",
  },
  {
    value: "Endotracheopulmonary instillation, powder for suspension",
    label: "Endotracheopulmonary instillation, powder for suspension",
  },
  {
    value: "Endotracheopulmonary instillation, solution",
    label: "Endotracheopulmonary instillation, solution",
  },
  {
    value: "Endotracheopulmonary instillation, suspension",
    label: "Endotracheopulmonary instillation, suspension",
  },
  {
    value: "Enema",
    label: "Enema",
  },
  {
    value: "Enteric-coated beads, 25 mg capsule",
    label: "Enteric-coated beads, 25 mg capsule",
  },
  {
    value: "Enteric-coated beads, 75 mg capsule",
    label: "Enteric-coated beads, 75 mg capsule",
  },
  {
    value: "Enterion capsules",
    label: "Enterion capsules",
  },
  {
    value: "Epilesional solution",
    label: "Epilesional solution",
  },
  {
    value: "Eye cream",
    label: "Eye cream",
  },
  {
    value: "Eye drops",
    label: "Eye drops",
  },
  {
    value: "Eye drops, emulsion",
    label: "Eye drops, emulsion",
  },
  {
    value: "Eye drops, emulsion in single-dose container",
    label: "Eye drops, emulsion in single-dose container",
  },
  {
    value: "Eye drops, powder and solvent for solution",
    label: "Eye drops, powder and solvent for solution",
  },
  {
    value: "Eye drops, powder and solvent for suspension",
    label: "Eye drops, powder and solvent for suspension",
  },
  {
    value: "Eye drops, powder for solution",
    label: "Eye drops, powder for solution",
  },
  {
    value: "Eye drops, powder for suspension",
    label: "Eye drops, powder for suspension",
  },
  {
    value: "Eye drops, prolonged-release",
    label: "Eye drops, prolonged-release",
  },
  {
    value: "Eye drops, prolonged-release solution in single-dose container",
    label: "Eye drops, prolonged-release solution in single-dose container",
  },
  {
    value: "Eye drops, solution",
    label: "Eye drops, solution",
  },
  {
    value: "Eye drops, solution in single-dose container",
    label: "Eye drops, solution in single-dose container",
  },
  {
    value: "Eye drops, solvent for reconstitution",
    label: "Eye drops, solvent for reconstitution",
  },
  {
    value: "Eye drops, suspension",
    label: "Eye drops, suspension",
  },
  {
    value: "Eye drops, suspension in single-dose container",
    label: "Eye drops, suspension in single-dose container",
  },
  {
    value: "Eye drops, tablet and solvent for solution",
    label: "Eye drops, tablet and solvent for solution",
  },
  {
    value: "Eye gel",
    label: "Eye gel",
  },
  {
    value: "Eye gel in single-dose container",
    label: "Eye gel in single-dose container",
  },
  {
    value: "Eye lotion",
    label: "Eye lotion",
  },
  {
    value: "Eye lotion, solvent for reconstitution",
    label: "Eye lotion, solvent for reconstitution",
  },
  {
    value: "Eye ointment",
    label: "Eye ointment",
  },
  {
    value: "Eye ointment in single-dose container",
    label: "Eye ointment in single-dose container",
  },
  {
    value: "Film coated gastro-resistant tablet",
    label: "Film coated gastro-resistant tablet",
  },
  {
    value: "Film coated tablet",
    label: "Film coated tablet",
  },
  {
    value: "Film coated tablets",
    label: "Film coated tablets",
  },
  {
    value: "Film-coated granules",
    label: "Film-coated granules",
  },
  {
    value: "Film-coated granules in single-dose container",
    label: "Film-coated granules in single-dose container",
  },
  {
    value: "Film-coated tablet",
    label: "Film-coated tablet",
  },
  {
    value: "Film-coated tablet and gastro-resistant granules in sachet",
    label: "Film-coated tablet and gastro-resistant granules in sachet",
  },
  {
    value: "Film-coated tablets",
    label: "Film-coated tablets",
  },
  {
    value: "Filmtabletten",
    label: "Filmtabletten",
  },
  {
    value: "Fluid extract",
    label: "Fluid extract",
  },
  {
    value: "Flushing solution for maintenance of intravenous devices",
    label: "Flushing solution for maintenance of intravenous devices",
  },
  {
    value: "Foam",
    label: "Foam",
  },
  {
    value: "Frozen vaccine preparation",
    label: "Frozen vaccine preparation",
  },
  {
    value: "Ft-apixabán aurovitas 2,5 mg-v01",
    label: "Ft-apixabán aurovitas 2,5 mg-v01",
  },
  {
    value: "Gargle",
    label: "Gargle",
  },
  {
    value: "Gargle, powder for solution",
    label: "Gargle, powder for solution",
  },
  {
    value: "Gargle, tablet for solution",
    label: "Gargle, tablet for solution",
  },
  {
    value: "Gargle/mouth wash",
    label: "Gargle/mouth wash",
  },
  {
    value: "Gargle/mouthwash",
    label: "Gargle/mouthwash",
  },
  {
    value: "Gargle/nasal wash",
    label: "Gargle/nasal wash",
  },
  {
    value: "Gas and solvent for dispersion for injection/infusion",
    label: "Gas and solvent for dispersion for injection/infusion",
  },
  {
    value: "Gas for dispersion for infusion",
    label: "Gas for dispersion for infusion",
  },
  {
    value: "Gas for dispersion for injection",
    label: "Gas for dispersion for injection",
  },
  {
    value: "Gas for dispersion for injection/infusion",
    label: "Gas for dispersion for injection/infusion",
  },
  {
    value: "Gastro resistant capsules, hard",
    label: "Gastro resistant capsules, hard",
  },
  {
    value: "Gastro-resistant capsule",
    label: "Gastro-resistant capsule",
  },
  {
    value: "Gastro-resistant capsule, hard",
    label: "Gastro-resistant capsule, hard",
  },
  {
    value: "Gastro-resistant capsule, soft",
    label: "Gastro-resistant capsule, soft",
  },
  {
    value: "Gastro-resistant capsules",
    label: "Gastro-resistant capsules",
  },
  {
    value: "Gastro-resistant coated tablet",
    label: "Gastro-resistant coated tablet",
  },
  {
    value: "Gastro-resistant coated tablets",
    label: "Gastro-resistant coated tablets",
  },
  {
    value: "Gastro-resistant delayed release tablet",
    label: "Gastro-resistant delayed release tablet",
  },
  {
    value: "Gastro-resistant granules",
    label: "Gastro-resistant granules",
  },
  {
    value: "Gastro-resistant granules for oral suspension",
    label: "Gastro-resistant granules for oral suspension",
  },
  {
    value: "Gastro-resistant granules for oral suspension in sachet",
    label: "Gastro-resistant granules for oral suspension in sachet",
  },
  {
    value: "Gastro-resistant microgranule in capsule",
    label: "Gastro-resistant microgranule in capsule",
  },
  {
    value: "Gastro-resistant oral suspension",
    label: "Gastro-resistant oral suspension",
  },
  {
    value: "Gastro-resistant powder and solvent for oral suspension",
    label: "Gastro-resistant powder and solvent for oral suspension",
  },
  {
    value: "Gastro-resistant powder for oral suspension",
    label: "Gastro-resistant powder for oral suspension",
  },
  {
    value: "Gastro-resistant tablet",
    label: "Gastro-resistant tablet",
  },
  {
    value: "Gastroenteral emulsion",
    label: "Gastroenteral emulsion",
  },
  {
    value: "Gastroenteral liquid",
    label: "Gastroenteral liquid",
  },
  {
    value: "Gastroenteral solution",
    label: "Gastroenteral solution",
  },
  {
    value: "Gastroenteral suspension",
    label: "Gastroenteral suspension",
  },
  {
    value: "Gel",
    label: "Gel",
  },
  {
    value: "Gel for gel",
    label: "Gel for gel",
  },
  {
    value: "Gel for injection",
    label: "Gel for injection",
  },
  {
    value: "Gel in pressurised container",
    label: "Gel in pressurised container",
  },
  {
    value: "Gel in sachet",
    label: "Gel in sachet",
  },
  {
    value:
      "Genetically engineered purified recombinant protein, derived from the major birch pollen allergen bet v 1.0101 isoform (betula verrucosa)---",
    label:
      "Genetically engineered purified recombinant protein, derived from the major birch pollen allergen bet v 1.0101 isoform (betula verrucosa)---",
  },
  {
    value: "Gingival gel",
    label: "Gingival gel",
  },
  {
    value: "Gingival paste",
    label: "Gingival paste",
  },
  {
    value: "Gingival solution",
    label: "Gingival solution",
  },
  {
    value: "Globules",
    label: "Globules",
  },
  {
    value: "Globuli",
    label: "Globuli",
  },
  {
    value: "Globuli velati",
    label: "Globuli velati",
  },
  {
    value: "Granules",
    label: "Granules",
  },
  {
    value: "Granules and solvent for oral suspension",
    label: "Granules and solvent for oral suspension",
  },
  {
    value: "Granules and solvent for suspension for injection",
    label: "Granules and solvent for suspension for injection",
  },
  {
    value: "Granules for oral solution",
    label: "Granules for oral solution",
  },
  {
    value: "Granules for oral solution in sachet",
    label: "Granules for oral solution in sachet",
  },
  {
    value: "Granules for oral suspension",
    label: "Granules for oral suspension",
  },
  {
    value: "Granules for oral suspension in sachet",
    label: "Granules for oral suspension in sachet",
  },
  {
    value: "Granules for oral/rectal suspension",
    label: "Granules for oral/rectal suspension",
  },
  {
    value: "Granules for rectal suspension",
    label: "Granules for rectal suspension",
  },
  {
    value: "Granules for suspension for injection",
    label: "Granules for suspension for injection",
  },
  {
    value: "Granules for syrup",
    label: "Granules for syrup",
  },
  {
    value: "Granules for use in drinking water",
    label: "Granules for use in drinking water",
  },
  {
    value: "Granules for vaginal solution",
    label: "Granules for vaginal solution",
  },
  {
    value: "Granules in capsules for opening",
    label: "Granules in capsules for opening",
  },
  {
    value: "Granules in sachet",
    label: "Granules in sachet",
  },
  {
    value: "Granules in single-dose container",
    label: "Granules in single-dose container",
  },
  {
    value: "Gélule à libération prolongée",
    label: "Gélule à libération prolongée",
  },
  {
    value: "Gélules à libération prolongée",
    label: "Gélules à libération prolongée",
  },
  {
    value: "Hard capsules",
    label: "Hard capsules",
  },
  {
    value: "Hard gelatin capsule",
    label: "Hard gelatin capsule",
  },
  {
    value: "Hard gelatin capsules",
    label: "Hard gelatin capsules",
  },
  {
    value: "Herbal tea",
    label: "Herbal tea",
  },
  {
    value: "Herbal tea in bag",
    label: "Herbal tea in bag",
  },
  {
    value: "Hm11260c",
    label: "Hm11260c",
  },
  {
    value: "Hm30181a",
    label: "Hm30181a",
  },
  {
    value: "Hydrogel",
    label: "Hydrogel",
  },
  {
    value: "Hydrogel for implantation",
    label: "Hydrogel for implantation",
  },
  {
    value: "Immediate release oral capsules",
    label: "Immediate release oral capsules",
  },
  {
    value: "Immediate-release capsule",
    label: "Immediate-release capsule",
  },
  {
    value: "Immediate-release capsules",
    label: "Immediate-release capsules",
  },
  {
    value: "Implant",
    label: "Implant",
  },
  {
    value: "Implant in pre-filled syringe",
    label: "Implant in pre-filled syringe",
  },
  {
    value: "Implantation chain",
    label: "Implantation chain",
  },
  {
    value: "Implantation matrix",
    label: "Implantation matrix",
  },
  {
    value: "Implantation paste",
    label: "Implantation paste",
  },
  {
    value: "Implantation suspension",
    label: "Implantation suspension",
  },
  {
    value: "Implantation tablet",
    label: "Implantation tablet",
  },
  {
    value: "Impregnated cutaneous swab",
    label: "Impregnated cutaneous swab",
  },
  {
    value: "Impregnated dressing",
    label: "Impregnated dressing",
  },
  {
    value: "Impregnated pad",
    label: "Impregnated pad",
  },
  {
    value: "Impregnated plug",
    label: "Impregnated plug",
  },
  {
    value: "Infusion",
    label: "Infusion",
  },
  {
    value: "Inhalation gas",
    label: "Inhalation gas",
  },
  {
    value: "Inhalation powder",
    label: "Inhalation powder",
  },
  {
    value: "Inhalation powder, hard capsule",
    label: "Inhalation powder, hard capsule",
  },
  {
    value: "Inhalation powder, pre-dispensed",
    label: "Inhalation powder, pre-dispensed",
  },
  {
    value: "Inhalation powder, tablet",
    label: "Inhalation powder, tablet",
  },
  {
    value: "Inhalation solution",
    label: "Inhalation solution",
  },
  {
    value: "Inhalation vapour",
    label: "Inhalation vapour",
  },
  {
    value: "Inhalation vapour, capsule",
    label: "Inhalation vapour, capsule",
  },
  {
    value: "Inhalation vapour, effervescent tablet",
    label: "Inhalation vapour, effervescent tablet",
  },
  {
    value: "Inhalation vapour, emulsion",
    label: "Inhalation vapour, emulsion",
  },
  {
    value: "Inhalation vapour, impregnated pad",
    label: "Inhalation vapour, impregnated pad",
  },
  {
    value: "Inhalation vapour, impregnated plug",
    label: "Inhalation vapour, impregnated plug",
  },
  {
    value: "Inhalation vapour, liquid",
    label: "Inhalation vapour, liquid",
  },
  {
    value: "Inhalation vapour, ointment",
    label: "Inhalation vapour, ointment",
  },
  {
    value: "Inhalation vapour, powder",
    label: "Inhalation vapour, powder",
  },
  {
    value: "Inhalation vapour, solution",
    label: "Inhalation vapour, solution",
  },
  {
    value: "Inhalation vapour, tablet",
    label: "Inhalation vapour, tablet",
  },
  {
    value: "Inhaler",
    label: "Inhaler",
  },
  {
    value: "Injectable",
    label: "Injectable",
  },
  {
    value: "Injectable aqueous solution",
    label: "Injectable aqueous solution",
  },
  {
    value: "Injection",
    label: "Injection",
  },
  {
    value: "Injection of intrathecal",
    label: "Injection of intrathecal",
  },
  {
    value: "Injection/infusion",
    label: "Injection/infusion",
  },
  {
    value: "Instant herbal tea",
    label: "Instant herbal tea",
  },
  {
    value: "Intestinal gel",
    label: "Intestinal gel",
  },
  {
    value: "Intraocular instillation solution",
    label: "Intraocular instillation solution",
  },
  {
    value: "Intraperitoneal solution",
    label: "Intraperitoneal solution",
  },
  {
    value: "Intrauterine delivery system",
    label: "Intrauterine delivery system",
  },
  {
    value: "Intrauterine gel",
    label: "Intrauterine gel",
  },
  {
    value: "Intrauterine liquid",
    label: "Intrauterine liquid",
  },
  {
    value: "Intravenous infusion",
    label: "Intravenous infusion",
  },
  {
    value: "Intravesical solution",
    label: "Intravesical solution",
  },
  {
    value: "Intravesical solution/solution for injection",
    label: "Intravesical solution/solution for injection",
  },
  {
    value: "Intravesical solution/solution for injection or infusion",
    label: "Intravesical solution/solution for injection or infusion",
  },
  {
    value: "Intravesical suspension",
    label: "Intravesical suspension",
  },
  {
    value: "Intravitreal implant in applicator",
    label: "Intravitreal implant in applicator",
  },
  {
    value: "Intrinsically enteric capsule",
    label: "Intrinsically enteric capsule",
  },
  {
    value: "Irrigation solution",
    label: "Irrigation solution",
  },
  {
    value: "Jam",
    label: "Jam",
  },
  {
    value: "Kit for radiopharmaceutical preparation",
    label: "Kit for radiopharmaceutical preparation",
  },
  {
    value: "Laryngopharyngeal solution",
    label: "Laryngopharyngeal solution",
  },
  {
    value: "Laryngopharyngeal spray, solution",
    label: "Laryngopharyngeal spray, solution",
  },
  {
    value: "Liquefied gas for dental use",
    label: "Liquefied gas for dental use",
  },
  {
    value: "Liquid",
    label: "Liquid",
  },
  {
    value: "Liquid dilution",
    label: "Liquid dilution",
  },
  {
    value: "Living tissue equivalent",
    label: "Living tissue equivalent",
  },
  {
    value: "Lotion",
    label: "Lotion",
  },
  {
    value: "Lotion for cutaneous use",
    label: "Lotion for cutaneous use",
  },
  {
    value: "Lozenge",
    label: "Lozenge",
  },
  {
    value: "Lyophilisate and solvent for solution for injection",
    label: "Lyophilisate and solvent for solution for injection",
  },
  {
    value: "Lyophilisate for concentrate for solution for infusion",
    label: "Lyophilisate for concentrate for solution for infusion",
  },
  {
    value: "Lyophilisate for parenteral use",
    label: "Lyophilisate for parenteral use",
  },
  {
    value: "Lyophilisate for solution for infusion",
    label: "Lyophilisate for solution for infusion",
  },
  {
    value: "Lyophilisate for solution for injection",
    label: "Lyophilisate for solution for injection",
  },
  {
    value: "Lyophilisate for solution for injection, infusion and inhalation",
    label: "Lyophilisate for solution for injection, infusion and inhalation",
  },
  {
    value: "Lyophilisate for suspension for injection",
    label: "Lyophilisate for suspension for injection",
  },
  {
    value: "Lyophilisate for use in drinking water",
    label: "Lyophilisate for use in drinking water",
  },
  {
    value: "Lyophilisated powder for intravenous and subcutaneous administration",
    label: "Lyophilisated powder for intravenous and subcutaneous administration",
  },
  {
    value: "Lyophilized",
    label: "Lyophilized",
  },
  {
    value: "Lyophilized cake",
    label: "Lyophilized cake",
  },
  {
    value: "Lyophilized powder",
    label: "Lyophilized powder",
  },
  {
    value: "Lyophilized powder for concentrate for solution for infusion",
    label: "Lyophilized powder for concentrate for solution for infusion",
  },
  {
    value: "Lyophilized powder for preparation for injection (8)",
    label: "Lyophilized powder for preparation for injection (8)",
  },
  {
    value: "Lyophilized powder for solution for infusion",
    label: "Lyophilized powder for solution for infusion",
  },
  {
    value: "Marmelade",
    label: "Marmelade",
  },
  {
    value: "Matrix for implantation matrix",
    label: "Matrix for implantation matrix",
  },
  {
    value: "Medicated chewing-gum",
    label: "Medicated chewing-gum",
  },
  {
    value: "Medicated nail lacquer",
    label: "Medicated nail lacquer",
  },
  {
    value: "Medicated patch",
    label: "Medicated patch",
  },
  {
    value: "Medicated pellets",
    label: "Medicated pellets",
  },
  {
    value: "Medicated plaster",
    label: "Medicated plaster",
  },
  {
    value: "Medicated sponge",
    label: "Medicated sponge",
  },
  {
    value: "Medicated thread",
    label: "Medicated thread",
  },
  {
    value: "Medicated vaginal tampon",
    label: "Medicated vaginal tampon",
  },
  {
    value: "Medicinal gas, compressed",
    label: "Medicinal gas, compressed",
  },
  {
    value: "Medicinal gas, cryogenic",
    label: "Medicinal gas, cryogenic",
  },
  {
    value: "Medicinal gas, liquefied",
    label: "Medicinal gas, liquefied",
  },
  {
    value: "Medicinal larvae",
    label: "Medicinal larvae",
  },
  {
    value: "Medicinal leech",
    label: "Medicinal leech",
  },
  {
    value: "Melting tablets",
    label: "Melting tablets",
  },
  {
    value: "Mixture",
    label: "Mixture",
  },
  {
    value: "Modified release capsule",
    label: "Modified release capsule",
  },
  {
    value: "Modified release tablet",
    label: "Modified release tablet",
  },
  {
    value: "Modified-release capsule",
    label: "Modified-release capsule",
  },
  {
    value: "Modified-release capsule, hard",
    label: "Modified-release capsule, hard",
  },
  {
    value: "Modified-release capsule, soft",
    label: "Modified-release capsule, soft",
  },
  {
    value: "Modified-release capsules",
    label: "Modified-release capsules",
  },
  {
    value: "Modified-release granules",
    label: "Modified-release granules",
  },
  {
    value: "Modified-release granules for oral suspension",
    label: "Modified-release granules for oral suspension",
  },
  {
    value: "Modified-release oral suspension",
    label: "Modified-release oral suspension",
  },
  {
    value: "Modified-release tablet",
    label: "Modified-release tablet",
  },
  {
    value: "Modified-release tablets",
    label: "Modified-release tablets",
  },
  {
    value: "Mouth disinfection solution",
    label: "Mouth disinfection solution",
  },
  {
    value: "Mouth wash",
    label: "Mouth wash",
  },
  {
    value: "Mouthwash",
    label: "Mouthwash",
  },
  {
    value: "Mouthwash, powder for solution",
    label: "Mouthwash, powder for solution",
  },
  {
    value: "Mouthwash, tablet for solution",
    label: "Mouthwash, tablet for solution",
  },
  {
    value: "Muco-adhesive buccal tablet",
    label: "Muco-adhesive buccal tablet",
  },
  {
    value: "Multiparticulate beads",
    label: "Multiparticulate beads",
  },
  {
    value: "N/a",
    label: "N/a",
  },
  {
    value: "Nano capsule",
    label: "Nano capsule",
  },
  {
    value: "Nasal cream",
    label: "Nasal cream",
  },
  {
    value: "Nasal drops",
    label: "Nasal drops",
  },
  {
    value: "Nasal drops, emulsion",
    label: "Nasal drops, emulsion",
  },
  {
    value: "Nasal drops, powder and solvent for solution",
    label: "Nasal drops, powder and solvent for solution",
  },
  {
    value: "Nasal drops, powder for solution",
    label: "Nasal drops, powder for solution",
  },
  {
    value: "Nasal drops, solution",
    label: "Nasal drops, solution",
  },
  {
    value: "Nasal drops, solution in single-dose container",
    label: "Nasal drops, solution in single-dose container",
  },
  {
    value: "Nasal drops, suspension",
    label: "Nasal drops, suspension",
  },
  {
    value: "Nasal gel",
    label: "Nasal gel",
  },
  {
    value: "Nasal ointment",
    label: "Nasal ointment",
  },
  {
    value: "Nasal powder",
    label: "Nasal powder",
  },
  {
    value: "Nasal powder in single-dose container",
    label: "Nasal powder in single-dose container",
  },
  {
    value: "Nasal spray",
    label: "Nasal spray",
  },
  {
    value: "Nasal spray, emulsion",
    label: "Nasal spray, emulsion",
  },
  {
    value: "Nasal spray, powder for solution",
    label: "Nasal spray, powder for solution",
  },
  {
    value: "Nasal spray, solution",
    label: "Nasal spray, solution",
  },
  {
    value: "Nasal spray, solution in single-dose container",
    label: "Nasal spray, solution in single-dose container",
  },
  {
    value: "Nasal spray, solution/oromucosal solution",
    label: "Nasal spray, solution/oromucosal solution",
  },
  {
    value: "Nasal spray, suspension",
    label: "Nasal spray, suspension",
  },
  {
    value: "Nasal stick",
    label: "Nasal stick",
  },
  {
    value: "Nasal wash",
    label: "Nasal wash",
  },
  {
    value: "Nasal/oromucosal solution",
    label: "Nasal/oromucosal solution",
  },
  {
    value: "Nasal/oromucosal spray, solution",
    label: "Nasal/oromucosal spray, solution",
  },
  {
    value: "Nebuliser dispersion",
    label: "Nebuliser dispersion",
  },
  {
    value: "Nebuliser emulsion",
    label: "Nebuliser emulsion",
  },
  {
    value: "Nebuliser liquid",
    label: "Nebuliser liquid",
  },
  {
    value: "Nebuliser solution",
    label: "Nebuliser solution",
  },
  {
    value: "Nebuliser suspension",
    label: "Nebuliser suspension",
  },
  {
    value: "Oil",
    label: "Oil",
  },
  {
    value: "Ointment",
    label: "Ointment",
  },
  {
    value: "Ophthalmic emulsion",
    label: "Ophthalmic emulsion",
  },
  {
    value: "Ophthalmic insert",
    label: "Ophthalmic insert",
  },
  {
    value: "Ophthalmic solution",
    label: "Ophthalmic solution",
  },
  {
    value: "Ophthalmic strip",
    label: "Ophthalmic strip",
  },
  {
    value: "Opthalmic solution",
    label: "Opthalmic solution",
  },
  {
    value: "Oral aqueous dispersion",
    label: "Oral aqueous dispersion",
  },
  {
    value: "Oral capsules",
    label: "Oral capsules",
  },
  {
    value: "Oral drops",
    label: "Oral drops",
  },
  {
    value: "Oral drops, emulsion",
    label: "Oral drops, emulsion",
  },
  {
    value: "Oral drops, granules for solution",
    label: "Oral drops, granules for solution",
  },
  {
    value: "Oral drops, liquid",
    label: "Oral drops, liquid",
  },
  {
    value: "Oral drops, powder for suspension",
    label: "Oral drops, powder for suspension",
  },
  {
    value: "Oral drops, solution",
    label: "Oral drops, solution",
  },
  {
    value: "Oral drops, suspension",
    label: "Oral drops, suspension",
  },
  {
    value: "Oral emulsion",
    label: "Oral emulsion",
  },
  {
    value: "Oral emulsion in sachet",
    label: "Oral emulsion in sachet",
  },
  {
    value: "Oral gel",
    label: "Oral gel",
  },
  {
    value: "Oral gum",
    label: "Oral gum",
  },
  {
    value: "Oral herbal material",
    label: "Oral herbal material",
  },
  {
    value: "Oral liquid",
    label: "Oral liquid",
  },
  {
    value: "Oral lyophilisate",
    label: "Oral lyophilisate",
  },
  {
    value: "Oral paste",
    label: "Oral paste",
  },
  {
    value: "Oral paste in sachet",
    label: "Oral paste in sachet",
  },
  {
    value: "Oral powder",
    label: "Oral powder",
  },
  {
    value: "Oral powder in sachet",
    label: "Oral powder in sachet",
  },
  {
    value: "Oral powder in single-dose container",
    label: "Oral powder in single-dose container",
  },
  {
    value: "Oral soluble film",
    label: "Oral soluble film",
  },
  {
    value: "Oral solution",
    label: "Oral solution",
  },
  {
    value: "Oral solution in multidose container with metering pump",
    label: "Oral solution in multidose container with metering pump",
  },
  {
    value: "Oral solution in sachet",
    label: "Oral solution in sachet",
  },
  {
    value: "Oral solution in single dose container",
    label: "Oral solution in single dose container",
  },
  {
    value: "Oral solution in single-dose container",
    label: "Oral solution in single-dose container",
  },
  {
    value: "Oral solution/concentrate for nebuliser solution",
    label: "Oral solution/concentrate for nebuliser solution",
  },
  {
    value: "Oral suspension",
    label: "Oral suspension",
  },
  {
    value: "Oral suspension in sachet",
    label: "Oral suspension in sachet",
  },
  {
    value: "Oral/rectal solution",
    label: "Oral/rectal solution",
  },
  {
    value: "Oral/rectal suspension",
    label: "Oral/rectal suspension",
  },
  {
    value: "Orodispersible film",
    label: "Orodispersible film",
  },
  {
    value: "Orodispersible tablet",
    label: "Orodispersible tablet",
  },
  {
    value: "Oromucosal capsule",
    label: "Oromucosal capsule",
  },
  {
    value: "Oromucosal cream",
    label: "Oromucosal cream",
  },
  {
    value: "Oromucosal drops",
    label: "Oromucosal drops",
  },
  {
    value: "Oromucosal film",
    label: "Oromucosal film",
  },
  {
    value: "Oromucosal gel",
    label: "Oromucosal gel",
  },
  {
    value: "Oromucosal liquid",
    label: "Oromucosal liquid",
  },
  {
    value: "Oromucosal ointment",
    label: "Oromucosal ointment",
  },
  {
    value: "Oromucosal paste",
    label: "Oromucosal paste",
  },
  {
    value: "Oromucosal patch",
    label: "Oromucosal patch",
  },
  {
    value: "Oromucosal pouch",
    label: "Oromucosal pouch",
  },
  {
    value: "Oromucosal powder in pouch",
    label: "Oromucosal powder in pouch",
  },
  {
    value: "Oromucosal solution",
    label: "Oromucosal solution",
  },
  {
    value: "Oromucosal spray",
    label: "Oromucosal spray",
  },
  {
    value: "Oromucosal spray, emulsion",
    label: "Oromucosal spray, emulsion",
  },
  {
    value: "Oromucosal spray, solution",
    label: "Oromucosal spray, solution",
  },
  {
    value: "Oromucosal spray, suspension",
    label: "Oromucosal spray, suspension",
  },
  {
    value: "Oromucosal suspension",
    label: "Oromucosal suspension",
  },
  {
    value: "Oromucosal/laryngopharyngeal solution",
    label: "Oromucosal/laryngopharyngeal solution",
  },
  {
    value: "Oromucosal/laryngopharyngeal solution/spray, solution",
    label: "Oromucosal/laryngopharyngeal solution/spray, solution",
  },
  {
    value: "Parenteral solution for iv infusion",
    label: "Parenteral solution for iv infusion",
  },
  {
    value: "Paste",
    label: "Paste",
  },
  {
    value: "Pastille",
    label: "Pastille",
  },
  {
    value: "Peg400 as a cosolvent",
    label: "Peg400 as a cosolvent",
  },
  {
    value: "Pellets, enteric coated",
    label: "Pellets, enteric coated",
  },
  {
    value: "Periodontal gel",
    label: "Periodontal gel",
  },
  {
    value: "Periodontal insert",
    label: "Periodontal insert",
  },
  {
    value: "Periodontal powder",
    label: "Periodontal powder",
  },
  {
    value: "Pessary",
    label: "Pessary",
  },
  {
    value: "Pillules",
    label: "Pillules",
  },
  {
    value: "Pillules in single-dose container",
    label: "Pillules in single-dose container",
  },
  {
    value: "Plaster for provocation test",
    label: "Plaster for provocation test",
  },
  {
    value: "Plėvele dengtos tabletės",
    label: "Plėvele dengtos tabletės",
  },
  {
    value: "Polvo para solución oral",
    label: "Polvo para solución oral",
  },
  {
    value: "Pouch",
    label: "Pouch",
  },
  {
    value: "Poultice",
    label: "Poultice",
  },
  {
    value: "Powder",
    label: "Powder",
  },
  {
    value: "Powder and gel for gel",
    label: "Powder and gel for gel",
  },
  {
    value: "Powder and solution for dental cement",
    label: "Powder and solution for dental cement",
  },
  {
    value: "Powder and solution for oral solution",
    label: "Powder and solution for oral solution",
  },
  {
    value: "Powder and solution for solution for injection",
    label: "Powder and solution for solution for injection",
  },
  {
    value: "Powder and solution for suspension for injection",
    label: "Powder and solution for suspension for injection",
  },
  {
    value: "Powder and solvent for concentrate for solution for infusion",
    label: "Powder and solvent for concentrate for solution for infusion",
  },
  {
    value: "Powder and solvent for cutaneous solution",
    label: "Powder and solvent for cutaneous solution",
  },
  {
    value: "Powder and solvent for dental gel",
    label: "Powder and solvent for dental gel",
  },
  {
    value: "Powder and solvent for dispersion for injection",
    label: "Powder and solvent for dispersion for injection",
  },
  {
    value: "Powder and solvent for emulsion for injection",
    label: "Powder and solvent for emulsion for injection",
  },
  {
    value: "Powder and solvent for endocervical gel",
    label: "Powder and solvent for endocervical gel",
  },
  {
    value: "Powder and solvent for endosinusial solution",
    label: "Powder and solvent for endosinusial solution",
  },
  {
    value: "Powder and solvent for epilesional solution",
    label: "Powder and solvent for epilesional solution",
  },
  {
    value: "Powder and solvent for gingival gel",
    label: "Powder and solvent for gingival gel",
  },
  {
    value: "Powder and solvent for implantation paste",
    label: "Powder and solvent for implantation paste",
  },
  {
    value: "Powder and solvent for instillation solution for intraocular use",
    label: "Powder and solvent for instillation solution for intraocular use",
  },
  {
    value: "Powder and solvent for intramuscular injection",
    label: "Powder and solvent for intramuscular injection",
  },
  {
    value: "Powder and solvent for intravesical solution",
    label: "Powder and solvent for intravesical solution",
  },
  {
    value: "Powder and solvent for intravesical suspension",
    label: "Powder and solvent for intravesical suspension",
  },
  {
    value: "Powder and solvent for nebuliser solution",
    label: "Powder and solvent for nebuliser solution",
  },
  {
    value: "Powder and solvent for oral solution",
    label: "Powder and solvent for oral solution",
  },
  {
    value: "Powder and solvent for oral suspension",
    label: "Powder and solvent for oral suspension",
  },
  {
    value: "Powder and solvent for prolonged-release suspension for injection",
    label: "Powder and solvent for prolonged-release suspension for injection",
  },
  {
    value: "Powder and solvent for prolonged-release suspension for injection in pre-filled pen",
    label: "Powder and solvent for prolonged-release suspension for injection in pre-filled pen",
  },
  {
    value: "Powder and solvent for prolonged-release suspension for injection in pre-filled syringe",
    label: "Powder and solvent for prolonged-release suspension for injection in pre-filled syringe",
  },
  {
    value: "Powder and solvent for sealant",
    label: "Powder and solvent for sealant",
  },
  {
    value: "Powder and solvent for solution for infusion",
    label: "Powder and solvent for solution for infusion",
  },
  {
    value: "Powder and solvent for solution for injection",
    label: "Powder and solvent for solution for injection",
  },
  {
    value: "Powder and solvent for solution for injection in cartridge",
    label: "Powder and solvent for solution for injection in cartridge",
  },
  {
    value: "Powder and solvent for solution for injection in pre-filled pen",
    label: "Powder and solvent for solution for injection in pre-filled pen",
  },
  {
    value: "Powder and solvent for solution for injection in pre-filled syringe",
    label: "Powder and solvent for solution for injection in pre-filled syringe",
  },
  {
    value: "Powder and solvent for solution for injection/ skin-prick test",
    label: "Powder and solvent for solution for injection/ skin-prick test",
  },
  {
    value: "Powder and solvent for solution for injection/infusion",
    label: "Powder and solvent for solution for injection/infusion",
  },
  {
    value: "Powder and solvent for solution for intraocular irrigation",
    label: "Powder and solvent for solution for intraocular irrigation",
  },
  {
    value: "Powder and solvent for suspension for injection",
    label: "Powder and solvent for suspension for injection",
  },
  {
    value: "Powder and solvent for suspension for injection in multidose container",
    label: "Powder and solvent for suspension for injection in multidose container",
  },
  {
    value: "Powder and solvent for suspension for injection in pre-filled syringe",
    label: "Powder and solvent for suspension for injection in pre-filled syringe",
  },
  {
    value: "Powder and solvent for syrup",
    label: "Powder and solvent for syrup",
  },
  {
    value: "Powder and suspension for suspension for injection",
    label: "Powder and suspension for suspension for injection",
  },
  {
    value: "Powder and suspension for suspension for injection in pre-filled syringe",
    label: "Powder and suspension for suspension for injection in pre-filled syringe",
  },
  {
    value: "Powder for bladder irrigation",
    label: "Powder for bladder irrigation",
  },
  {
    value: "Powder for concentrate",
    label: "Powder for concentrate",
  },
  {
    value: "Powder for concentrate and solution for solution for infusion",
    label: "Powder for concentrate and solution for solution for infusion",
  },
  {
    value: "Powder for concentrate for dispersion for infusion",
    label: "Powder for concentrate for dispersion for infusion",
  },
  {
    value: "Powder for concentrate for intravesical suspension",
    label: "Powder for concentrate for intravesical suspension",
  },
  {
    value: "Powder for concentrate for solution for haemodialysis",
    label: "Powder for concentrate for solution for haemodialysis",
  },
  {
    value: "Powder for concentrate for solution for infusion",
    label: "Powder for concentrate for solution for infusion",
  },
  {
    value: "Powder for concentrate for solution for infusion and for oral solution",
    label: "Powder for concentrate for solution for infusion and for oral solution",
  },
  {
    value: "Powder for concentrate for solution for injection/infusion",
    label: "Powder for concentrate for solution for injection/infusion",
  },
  {
    value: "Powder for cutaneous solution",
    label: "Powder for cutaneous solution",
  },
  {
    value: "Powder for dental cement",
    label: "Powder for dental cement",
  },
  {
    value: "Powder for dental gel",
    label: "Powder for dental gel",
  },
  {
    value: "Powder for dental solution",
    label: "Powder for dental solution",
  },
  {
    value: "Powder for dispersion for infusion",
    label: "Powder for dispersion for infusion",
  },
  {
    value: "Powder for dispersion for injection",
    label: "Powder for dispersion for injection",
  },
  {
    value: "Powder for emulsion for injection",
    label: "Powder for emulsion for injection",
  },
  {
    value: "Powder for endocervical gel",
    label: "Powder for endocervical gel",
  },
  {
    value: "Powder for endosinusial solution",
    label: "Powder for endosinusial solution",
  },
  {
    value: "Powder for epilesional solution",
    label: "Powder for epilesional solution",
  },
  {
    value: "Powder for gel",
    label: "Powder for gel",
  },
  {
    value: "Powder for gingival gel",
    label: "Powder for gingival gel",
  },
  {
    value: "Powder for implantation matrix",
    label: "Powder for implantation matrix",
  },
  {
    value: "Powder for implantation paste",
    label: "Powder for implantation paste",
  },
  {
    value: "Powder for implantation suspension",
    label: "Powder for implantation suspension",
  },
  {
    value: "Powder for infusion",
    label: "Powder for infusion",
  },
  {
    value: "Powder for inhalation",
    label: "Powder for inhalation",
  },
  {
    value: "Powder for injection",
    label: "Powder for injection",
  },
  {
    value: "Powder for intraocular instillation solution",
    label: "Powder for intraocular instillation solution",
  },
  {
    value: "Powder for intravesical solution",
    label: "Powder for intravesical solution",
  },
  {
    value: "Powder for intravesical solution/solution for injection",
    label: "Powder for intravesical solution/solution for injection",
  },
  {
    value: "Powder for intravesical solution/solution for injection or infusion",
    label: "Powder for intravesical solution/solution for injection or infusion",
  },
  {
    value: "Powder for intravesical suspension",
    label: "Powder for intravesical suspension",
  },
  {
    value: "Powder for nebuliser solution",
    label: "Powder for nebuliser solution",
  },
  {
    value: "Powder for nebuliser suspension",
    label: "Powder for nebuliser suspension",
  },
  {
    value: "Powder for oral solution",
    label: "Powder for oral solution",
  },
  {
    value: "Powder for oral solution in sachet",
    label: "Powder for oral solution in sachet",
  },
  {
    value: "Powder for oral suspension",
    label: "Powder for oral suspension",
  },
  {
    value: "Powder for oral suspension in sachet",
    label: "Powder for oral suspension in sachet",
  },
  {
    value: "Powder for oral suspension in sachet-dose",
    label: "Powder for oral suspension in sachet-dose",
  },
  {
    value: "Powder for oral use",
    label: "Powder for oral use",
  },
  {
    value: "Powder for oral/rectal suspension",
    label: "Powder for oral/rectal suspension",
  },
  {
    value: "Powder for oral/rectal suspension in sachet",
    label: "Powder for oral/rectal suspension in sachet",
  },
  {
    value: "Powder for orale/rectale suspension",
    label: "Powder for orale/rectale suspension",
  },
  {
    value: "Powder for prolonged-release injection",
    label: "Powder for prolonged-release injection",
  },
  {
    value: "Powder for prolonged-release suspension for injection",
    label: "Powder for prolonged-release suspension for injection",
  },
  {
    value: "Powder for rectal solution",
    label: "Powder for rectal solution",
  },
  {
    value: "Powder for rectal suspension",
    label: "Powder for rectal suspension",
  },
  {
    value: "Powder for sealant",
    label: "Powder for sealant",
  },
  {
    value: "Powder for solution",
    label: "Powder for solution",
  },
  {
    value: "Powder for solution for infusion",
    label: "Powder for solution for infusion",
  },
  {
    value: "Powder for solution for inhalation",
    label: "Powder for solution for inhalation",
  },
  {
    value: "Powder for solution for injection",
    label: "Powder for solution for injection",
  },
  {
    value: "Powder for solution for injection or infusion",
    label: "Powder for solution for injection or infusion",
  },
  {
    value: "Powder for solution for injection, infusion and inhalation",
    label: "Powder for solution for injection, infusion and inhalation",
  },
  {
    value: "Powder for solution for injection/infusion",
    label: "Powder for solution for injection/infusion",
  },
  {
    value: "Powder for solution for injection/infusion/inhalation",
    label: "Powder for solution for injection/infusion/inhalation",
  },
  {
    value: "Powder for solution for injection/skin-prick test",
    label: "Powder for solution for injection/skin-prick test",
  },
  {
    value: "Powder for solution for intraocular irrigation",
    label: "Powder for solution for intraocular irrigation",
  },
  {
    value: "Powder for solution for iontophoresis",
    label: "Powder for solution for iontophoresis",
  },
  {
    value: "Powder for solution for skin-prick test",
    label: "Powder for solution for skin-prick test",
  },
  {
    value: "Powder for suspension",
    label: "Powder for suspension",
  },
  {
    value: "Powder for suspension for injection",
    label: "Powder for suspension for injection",
  },
  {
    value: "Powder for suspension for solution",
    label: "Powder for suspension for solution",
  },
  {
    value: "Powder for syrup",
    label: "Powder for syrup",
  },
  {
    value: "Powder for vaginal solution",
    label: "Powder for vaginal solution",
  },
  {
    value: "Powder in capsule (pic)",
    label: "Powder in capsule (pic)",
  },
  {
    value: "Powder, dispersion and solvent for concentrate for dispersion for infusion",
    label: "Powder, dispersion and solvent for concentrate for dispersion for infusion",
  },
  {
    value: "Powder, solvent and diluent for provocation test",
    label: "Powder, solvent and diluent for provocation test",
  },
  {
    value: "Powder, solvent and matrix for implantation matrix",
    label: "Powder, solvent and matrix for implantation matrix",
  },
  {
    value: "Powder-filled hard gelatin capsules",
    label: "Powder-filled hard gelatin capsules",
  },
  {
    value: "Pre-filled pen",
    label: "Pre-filled pen",
  },
  {
    value: "Premix for medicated feeding stuff",
    label: "Premix for medicated feeding stuff",
  },
  {
    value: "Preservative solution",
    label: "Preservative solution",
  },
  {
    value: "Pressed juice",
    label: "Pressed juice",
  },
  {
    value: "Pressurised inhalation",
    label: "Pressurised inhalation",
  },
  {
    value: "Pressurised inhalation, emulsion",
    label: "Pressurised inhalation, emulsion",
  },
  {
    value: "Pressurised inhalation, solution",
    label: "Pressurised inhalation, solution",
  },
  {
    value: "Pressurised inhalation, suspension",
    label: "Pressurised inhalation, suspension",
  },
  {
    value: "Pressurized inhalation, suspension",
    label: "Pressurized inhalation, suspension",
  },
  {
    value: "Prolonged release film-coated tablet",
    label: "Prolonged release film-coated tablet",
  },
  {
    value: "Prolonged release film-coated tablets",
    label: "Prolonged release film-coated tablets",
  },
  {
    value: "Prolonged release oral capsules",
    label: "Prolonged release oral capsules",
  },
  {
    value: "Prolonged release tablets",
    label: "Prolonged release tablets",
  },
  {
    value: "Prolonged-release capsule",
    label: "Prolonged-release capsule",
  },
  {
    value: "Prolonged-release capsule, hard",
    label: "Prolonged-release capsule, hard",
  },
  {
    value: "Prolonged-release capsule, soft",
    label: "Prolonged-release capsule, soft",
  },
  {
    value: "Prolonged-release dispersion for injection",
    label: "Prolonged-release dispersion for injection",
  },
  {
    value: "Prolonged-release film-coated tablet",
    label: "Prolonged-release film-coated tablet",
  },
  {
    value: "Prolonged-release granules",
    label: "Prolonged-release granules",
  },
  {
    value: "Prolonged-release granules for oral suspension",
    label: "Prolonged-release granules for oral suspension",
  },
  {
    value: "Prolonged-release granules for oral suspension in sachet",
    label: "Prolonged-release granules for oral suspension in sachet",
  },
  {
    value: "Prolonged-release granules in sachet",
    label: "Prolonged-release granules in sachet",
  },
  {
    value: "Prolonged-release oral suspension",
    label: "Prolonged-release oral suspension",
  },
  {
    value: "Prolonged-release pessary",
    label: "Prolonged-release pessary",
  },
  {
    value: "Prolonged-release solution for injection",
    label: "Prolonged-release solution for injection",
  },
  {
    value: "Prolonged-release solution for injection in a pre-filled syringe",
    label: "Prolonged-release solution for injection in a pre-filled syringe",
  },
  {
    value: "Prolonged-release suspension for injection",
    label: "Prolonged-release suspension for injection",
  },
  {
    value: "Prolonged-release suspension for injection in pre-filled pen",
    label: "Prolonged-release suspension for injection in pre-filled pen",
  },
  {
    value: "Prolonged-release suspension for injection in pre-filled syringe",
    label: "Prolonged-release suspension for injection in pre-filled syringe",
  },
  {
    value: "Prolonged-release tablet",
    label: "Prolonged-release tablet",
  },
  {
    value: "Prolonged-release wound solution",
    label: "Prolonged-release wound solution",
  },
  {
    value: "Pulver im beutel zur herstellung einer lösung zum einnehmen",
    label: "Pulver im beutel zur herstellung einer lösung zum einnehmen",
  },
  {
    value: "Purple, lyophilised cake",
    label: "Purple, lyophilised cake",
  },
  {
    value: "Radionuclide generator",
    label: "Radionuclide generator",
  },
  {
    value: "Radiopharmaceutical precursor",
    label: "Radiopharmaceutical precursor",
  },
  {
    value: "Radiopharmaceutical precursor, solution",
    label: "Radiopharmaceutical precursor, solution",
  },
  {
    value: "Rectal capsule",
    label: "Rectal capsule",
  },
  {
    value: "Rectal cream",
    label: "Rectal cream",
  },
  {
    value: "Rectal emulsion",
    label: "Rectal emulsion",
  },
  {
    value: "Rectal foam",
    label: "Rectal foam",
  },
  {
    value: "Rectal gel",
    label: "Rectal gel",
  },
  {
    value: "Rectal ointment",
    label: "Rectal ointment",
  },
  {
    value: "Rectal solution",
    label: "Rectal solution",
  },
  {
    value: "Rectal suspension",
    label: "Rectal suspension",
  },
  {
    value: "Rectal tampon",
    label: "Rectal tampon",
  },
  {
    value: "Saline solution specific for ocular surgery",
    label: "Saline solution specific for ocular surgery",
  },
  {
    value: "Scored film coated tablet",
    label: "Scored film coated tablet",
  },
  {
    value: "Sealant",
    label: "Sealant",
  },
  {
    value: "Sealant matrix",
    label: "Sealant matrix",
  },
  {
    value: "Sealant powder",
    label: "Sealant powder",
  },
  {
    value: "Seeds",
    label: "Seeds",
  },
  {
    value: "Semi-solid solution in capsules",
    label: "Semi-solid solution in capsules",
  },
  {
    value: "Shampoo",
    label: "Shampoo",
  },
  {
    value: "Single use vial containng lyophilised powder",
    label: "Single use vial containng lyophilised powder",
  },
  {
    value: "Soft capsule",
    label: "Soft capsule",
  },
  {
    value: "Soft gelatin capsule",
    label: "Soft gelatin capsule",
  },
  {
    value: "Soft gelatine capsule",
    label: "Soft gelatine capsule",
  },
  {
    value: "Solid dispersion in capsules",
    label: "Solid dispersion in capsules",
  },
  {
    value: "Soluble tablet",
    label: "Soluble tablet",
  },
  {
    value: "Solution for addition to bicarbonate concentrate",
    label: "Solution for addition to bicarbonate concentrate",
  },
  {
    value: "Solution for infusion/injection",
    label: "Solution for infusion/injection",
  },
  {
    value: "Solution",
    label: "Solution",
  },
  {
    value: "Solution against gingival hemorrhage and stomatitis",
    label: "Solution against gingival hemorrhage and stomatitis",
  },
  {
    value: "Solution and emulsion for emulsion for injection",
    label: "Solution and emulsion for emulsion for injection",
  },
  {
    value: "Solution and suspension for suspension for injection in pre-filled syringe",
    label: "Solution and suspension for suspension for injection in pre-filled syringe",
  },
  {
    value: "Solution for blood fraction modification",
    label: "Solution for blood fraction modification",
  },
  {
    value: "Solution for cardioplegia",
    label: "Solution for cardioplegia",
  },
  {
    value: "Solution for cardioplegia/organ preservation",
    label: "Solution for cardioplegia/organ preservation",
  },
  {
    value: "Solution for cold compress",
    label: "Solution for cold compress",
  },
  {
    value: "Solution for dental cement",
    label: "Solution for dental cement",
  },
  {
    value: "Solution for disinfection of skin rich in sebaceous glands",
    label: "Solution for disinfection of skin rich in sebaceous glands",
  },
  {
    value: "Solution for external use",
    label: "Solution for external use",
  },
  {
    value: "Solution for external wound cleaning",
    label: "Solution for external wound cleaning",
  },
  {
    value: "Solution for haemodiafiltration",
    label: "Solution for haemodiafiltration",
  },
  {
    value: "Solution for haemodialysis",
    label: "Solution for haemodialysis",
  },
  {
    value: "Solution for haemodialysis/haemofiltration",
    label: "Solution for haemodialysis/haemofiltration",
  },
  {
    value: "Solution for haemofiltration",
    label: "Solution for haemofiltration",
  },
  {
    value: "Solution for hygienic hand disinfection",
    label: "Solution for hygienic hand disinfection",
  },
  {
    value: "Solution for i.v. injection",
    label: "Solution for i.v. injection",
  },
  {
    value: "Solution for infusion",
    label: "Solution for infusion",
  },
  {
    value: "Solution for infusion and oral solution",
    label: "Solution for infusion and oral solution",
  },
  {
    value: "Solution for infusion in administration system",
    label: "Solution for infusion in administration system",
  },
  {
    value: "Solution for infusion in cartridge",
    label: "Solution for infusion in cartridge",
  },
  {
    value: "Solution for infusion in pre-filled syringe",
    label: "Solution for infusion in pre-filled syringe",
  },
  {
    value: "Solution for infusion or injection",
    label: "Solution for infusion or injection",
  },
  {
    value: "Solution for infusion/oral solution",
    label: "Solution for infusion/oral solution",
  },
  {
    value: "Solution for inhalation",
    label: "Solution for inhalation",
  },
  {
    value: "Solution for injection",
    label: "Solution for injection",
  },
  {
    value: "Solution for injection / concentrate for solution for infusion",
    label: "Solution for injection / concentrate for solution for infusion",
  },
  {
    value: "Solution for injection and oral solution",
    label: "Solution for injection and oral solution",
  },
  {
    value: "Solution for injection in a pre-filled syringe",
    label: "Solution for injection in a pre-filled syringe",
  },
  {
    value: "Solution for injection in administration system",
    label: "Solution for injection in administration system",
  },
  {
    value: "Solution for injection in cartridge",
    label: "Solution for injection in cartridge",
  },
  {
    value: "Solution for injection in dose-dispenser cartridge",
    label: "Solution for injection in dose-dispenser cartridge",
  },
  {
    value: "Solution for injection in multidose container",
    label: "Solution for injection in multidose container",
  },
  {
    value: "Solution for injection in needle-free injector",
    label: "Solution for injection in needle-free injector",
  },
  {
    value: "Solution for injection in pre-filled injector",
    label: "Solution for injection in pre-filled injector",
  },
  {
    value: "Solution for injection in pre-filled pen",
    label: "Solution for injection in pre-filled pen",
  },
  {
    value: "Solution for injection in pre-filled syringe",
    label: "Solution for injection in pre-filled syringe",
  },
  {
    value: "Solution for injection in vial",
    label: "Solution for injection in vial",
  },
  {
    value: "Solution for injection or infusion",
    label: "Solution for injection or infusion",
  },
  {
    value: "Solution for injection or infusion or oral solution",
    label: "Solution for injection or infusion or oral solution",
  },
  {
    value: "Solution for injection, concentrate for solution for infusion",
    label: "Solution for injection, concentrate for solution for infusion",
  },
  {
    value: "Solution for injection/concentrate for solution for infusion",
    label: "Solution for injection/concentrate for solution for infusion",
  },
  {
    value: "Solution for injection/infusion",
    label: "Solution for injection/infusion",
  },
  {
    value: "Solution for injection/infusion and inhalation",
    label: "Solution for injection/infusion and inhalation",
  },
  {
    value: "Solution for injection/infusion in pre-filled syringe",
    label: "Solution for injection/infusion in pre-filled syringe",
  },
  {
    value: "Solution for injection/infusion/inhalation",
    label: "Solution for injection/infusion/inhalation",
  },
  {
    value: "Solution for injection/skin-prick test",
    label: "Solution for injection/skin-prick test",
  },
  {
    value: "Solution for intradermal test",
    label: "Solution for intradermal test",
  },
  {
    value: "Solution for intraocular injection",
    label: "Solution for intraocular injection",
  },
  {
    value: "Solution for intraocular irrigation",
    label: "Solution for intraocular irrigation",
  },
  {
    value: "Solution for intraperitoneal use",
    label: "Solution for intraperitoneal use",
  },
  {
    value: "Solution for intravesical use",
    label: "Solution for intravesical use",
  },
  {
    value: "Solution for intravitreal injection",
    label: "Solution for intravitreal injection",
  },
  {
    value: "Solution for iontophoresis",
    label: "Solution for iontophoresis",
  },
  {
    value: "Solution for nasal administration",
    label: "Solution for nasal administration",
  },
  {
    value: "Solution for nebulisation",
    label: "Solution for nebulisation",
  },
  {
    value: "Solution for nebulization",
    label: "Solution for nebulization",
  },
  {
    value: "Solution for organ preservation",
    label: "Solution for organ preservation",
  },
  {
    value: "Solution for peritoneal dialysis",
    label: "Solution for peritoneal dialysis",
  },
  {
    value: "Solution for provocation test",
    label: "Solution for provocation test",
  },
  {
    value: "Solution for sealant",
    label: "Solution for sealant",
  },
  {
    value: "Solution for skin disinfection before injections and puncture of peripheral vessels",
    label: "Solution for skin disinfection before injections and puncture of peripheral vessels",
  },
  {
    value: "Solution for skin disinfection before operations and puncture of joints",
    label: "Solution for skin disinfection before operations and puncture of joints",
  },
  {
    value: "Solution for skin-prick test",
    label: "Solution for skin-prick test",
  },
  {
    value: "Solution for skin-scratch test",
    label: "Solution for skin-scratch test",
  },
  {
    value: "Solution for solution for injection",
    label: "Solution for solution for injection",
  },
  {
    value: "Solution for sublingual administration or intradermal injection",
    label: "Solution for sublingual administration or intradermal injection",
  },
  {
    value: "Solution for suspension for injection",
    label: "Solution for suspension for injection",
  },
  {
    value: "Solutions for sealant",
    label: "Solutions for sealant",
  },
  {
    value: "Soluton for injection",
    label: "Soluton for injection",
  },
  {
    value: "Solvent for parenteral use",
    label: "Solvent for parenteral use",
  },
  {
    value: "Solvent for solution for infusion",
    label: "Solvent for solution for infusion",
  },
  {
    value: "Solvent for solution for injection",
    label: "Solvent for solution for injection",
  },
  {
    value: "Solvent for solution for intraocular irrigation",
    label: "Solvent for solution for intraocular irrigation",
  },
  {
    value: "Spot-on solution",
    label: "Spot-on solution",
  },
  {
    value: "Spray",
    label: "Spray",
  },
  {
    value: "Sterile aqueous solution",
    label: "Sterile aqueous solution",
  },
  {
    value: "Sterile concentrate",
    label: "Sterile concentrate",
  },
  {
    value: "Sterile solution",
    label: "Sterile solution",
  },
  {
    value: "Sterile suspension",
    label: "Sterile suspension",
  },
  {
    value: "Stomach irrigation",
    label: "Stomach irrigation",
  },
  {
    value: "Storage solution",
    label: "Storage solution",
  },
  {
    value: "Sublingual film",
    label: "Sublingual film",
  },
  {
    value: "Sublingual lyophilisate",
    label: "Sublingual lyophilisate",
  },
  {
    value: "Sublingual powder",
    label: "Sublingual powder",
  },
  {
    value: "Sublingual spray",
    label: "Sublingual spray",
  },
  {
    value: "Sublingual spray, emulsion",
    label: "Sublingual spray, emulsion",
  },
  {
    value: "Sublingual spray, solution",
    label: "Sublingual spray, solution",
  },
  {
    value: "Sublingual spray, suspension",
    label: "Sublingual spray, suspension",
  },
  {
    value: "Sublingual tablet",
    label: "Sublingual tablet",
  },
  {
    value: "Sugar-coated tablet",
    label: "Sugar-coated tablet",
  },
  {
    value: "Suppository",
    label: "Suppository",
  },
  {
    value: "Suspension",
    label: "Suspension",
  },
  {
    value: "Suspension and effervescent granules for oral suspension",
    label: "Suspension and effervescent granules for oral suspension",
  },
  {
    value: "Suspension and solution for spray",
    label: "Suspension and solution for spray",
  },
  {
    value: "Suspension and solvent for suspension for injection",
    label: "Suspension and solvent for suspension for injection",
  },
  {
    value: "Suspension for emulsion for injection",
    label: "Suspension for emulsion for injection",
  },
  {
    value: "Suspension for endoscopic administration",
    label: "Suspension for endoscopic administration",
  },
  {
    value: "Suspension for infusion",
    label: "Suspension for infusion",
  },
  {
    value: "Suspension for injection",
    label: "Suspension for injection",
  },
  {
    value: "Suspension for injection in cartridge",
    label: "Suspension for injection in cartridge",
  },
  {
    value: "Suspension for injection in multidose container",
    label: "Suspension for injection in multidose container",
  },
  {
    value: "Suspension for injection in pre-filled injector",
    label: "Suspension for injection in pre-filled injector",
  },
  {
    value: "Suspension for injection in pre-filled pen",
    label: "Suspension for injection in pre-filled pen",
  },
  {
    value: "Suspension for injection in pre-filled syringe",
    label: "Suspension for injection in pre-filled syringe",
  },
  {
    value: "Suspension for intraocular injection",
    label: "Suspension for intraocular injection",
  },
  {
    value: "Suspension for intravenous administration",
    label: "Suspension for intravenous administration",
  },
  {
    value: "Suspension for oral suspension",
    label: "Suspension for oral suspension",
  },
  {
    value: "Suspension for suspension for injection",
    label: "Suspension for suspension for injection",
  },
  {
    value: "Sustained release tablet",
    label: "Sustained release tablet",
  },
  {
    value: "Sustained-release tablet",
    label: "Sustained-release tablet",
  },
  {
    value: "Syrup",
    label: "Syrup",
  },
  {
    value: "Syrup in sachet",
    label: "Syrup in sachet",
  },
  {
    value: "Tablet",
    label: "Tablet",
  },
  {
    value: "Tablet and powder for oral solution",
    label: "Tablet and powder for oral solution",
  },
  {
    value: "Tablet and solvent for rectal suspension",
    label: "Tablet and solvent for rectal suspension",
  },
  {
    value: "Tablet for rectal solution",
    label: "Tablet for rectal solution",
  },
  {
    value: "Tablet for rectal suspension",
    label: "Tablet for rectal suspension",
  },
  {
    value: "Tablet for solution",
    label: "Tablet for solution",
  },
  {
    value: "Tablet for vaginal solution",
    label: "Tablet for vaginal solution",
  },
  {
    value: "Tablet with sensor",
    label: "Tablet with sensor",
  },
  {
    value: "Tablets",
    label: "Tablets",
  },
  {
    value: "Tablets for oral suspension",
    label: "Tablets for oral suspension",
  },
  {
    value: "Tabletten",
    label: "Tabletten",
  },
  {
    value: "Teeaufgusspulver",
    label: "Teeaufgusspulver",
  },
  {
    value: "The io102 drug product is a freeze-dried powder to be dissolved in water for injection",
    label: "The io102 drug product is a freeze-dried powder to be dissolved in water for injection",
  },
  {
    value: "Toothpaste",
    label: "Toothpaste",
  },
  {
    value: "Top1288",
    label: "Top1288",
  },
  {
    value: "Topical gel",
    label: "Topical gel",
  },
  {
    value: "Topical use",
    label: "Topical use",
  },
  {
    value: "Topical wipe",
    label: "Topical wipe",
  },
  {
    value: "Transdermal gel",
    label: "Transdermal gel",
  },
  {
    value: "Transdermal gel in sachet",
    label: "Transdermal gel in sachet",
  },
  {
    value: "Transdermal ointment",
    label: "Transdermal ointment",
  },
  {
    value: "Transdermal patch",
    label: "Transdermal patch",
  },
  {
    value: "Transdermal solution",
    label: "Transdermal solution",
  },
  {
    value: "Transdermal spray, solution",
    label: "Transdermal spray, solution",
  },
  {
    value: "Transdermal system",
    label: "Transdermal system",
  },
  {
    value: "Transplant of human origin",
    label: "Transplant of human origin",
  },
  {
    value: "Trinomia 100 mg/20 mg/10 mg capsule",
    label: "Trinomia 100 mg/20 mg/10 mg capsule",
  },
  {
    value: "Uncoated tablets",
    label: "Uncoated tablets",
  },
  {
    value: "Urethral emulsion",
    label: "Urethral emulsion",
  },
  {
    value: "Urethral gel",
    label: "Urethral gel",
  },
  {
    value: "Urethral ointment",
    label: "Urethral ointment",
  },
  {
    value: "Urethral stick",
    label: "Urethral stick",
  },
  {
    value: "Vaginal capsule",
    label: "Vaginal capsule",
  },
  {
    value: "Vaginal capsule, hard",
    label: "Vaginal capsule, hard",
  },
  {
    value: "Vaginal capsule, soft",
    label: "Vaginal capsule, soft",
  },
  {
    value: "Vaginal cream",
    label: "Vaginal cream",
  },
  {
    value: "Vaginal delivery system",
    label: "Vaginal delivery system",
  },
  {
    value: "Vaginal emulsion",
    label: "Vaginal emulsion",
  },
  {
    value: "Vaginal foam",
    label: "Vaginal foam",
  },
  {
    value: "Vaginal gel",
    label: "Vaginal gel",
  },
  {
    value: "Vaginal liquid",
    label: "Vaginal liquid",
  },
  {
    value: "Vaginal ointment",
    label: "Vaginal ointment",
  },
  {
    value: "Vaginal solution",
    label: "Vaginal solution",
  },
  {
    value: "Vaginal suspension",
    label: "Vaginal suspension",
  },
  {
    value: "Vaginal tablet",
    label: "Vaginal tablet",
  },
  {
    value: "Vial for intramuscular use",
    label: "Vial for intramuscular use",
  },
  {
    value: "Vial for intravenous use",
    label: "Vial for intravenous use",
  },
  {
    value: "Wafer",
    label: "Wafer",
  },
  {
    value: "White powder, freeze-dried in vials without any excipient",
    label: "White powder, freeze-dried in vials without any excipient",
  },
  {
    value: "White tablets",
    label: "White tablets",
  },
  {
    value: "Wound stick",
    label: "Wound stick",
  },
]

export const EUDRACT_PHARMA_FORMS = [
  {
    value: "Anticoagulant and preservative solution for blood",
    label: "Anticoagulant and preservative solution for blood",
  },
  { value: "Bath additive", label: "Bath additive" },
  { value: "Bladder irrigation", label: "Bladder irrigation" },
  { value: "Blood fraction modifier", label: "Blood fraction modifier" },
  { value: "Buccal film", label: "Buccal film" },
  { value: "Buccal tablet", label: "Buccal tablet" },
  { value: "Cachet", label: "Cachet" },
  { value: "Capsule", label: "Capsule" },
  { value: "Capsule, hard", label: "Capsule, hard" },
  { value: "Capsule, hard + tablet", label: "Capsule, hard + tablet" },
  { value: "Capsule, soft", label: "Capsule, soft" },
  { value: "Capsule, soft + tablet", label: "Capsule, soft + tablet" },
  { value: "Chewable capsule, soft", label: "Chewable capsule, soft" },
  { value: "Chewable tablet", label: "Chewable tablet" },
  { value: "Chewable/dispersible tablet", label: "Chewable/dispersible tablet" },
  { value: "Coated granules", label: "Coated granules" },
  { value: "Coated granules in sachet", label: "Coated granules in sachet" },
  { value: "Coated tablet", label: "Coated tablet" },
  { value: "Collodion", label: "Collodion" },
  { value: "Compressed lozenge", label: "Compressed lozenge" },
  {
    value: "Concentrate and solvent for concentrate for solution for infusion",
    label: "Concentrate and solvent for concentrate for solution for infusion",
  },
  { value: "Concentrate and solvent for cutaneous solution", label: "Concentrate and solvent for cutaneous solution" },
  {
    value: "Concentrate and solvent for dispersion for injection",
    label: "Concentrate and solvent for dispersion for injection",
  },
  {
    value: "Concentrate and solvent for intravesical solution",
    label: "Concentrate and solvent for intravesical solution",
  },
  {
    value: " Concentrate and solvent for solution for infusion",
    label: " Concentrate and solvent for solution for infusion",
  },
  {
    value: "Concentrate and solvent for solution for injection",
    label: "Concentrate and solvent for solution for injection",
  },
  {
    value: "Concentrate and solvent for solution for injection/infusion",
    label: "Concentrate and solvent for solution for injection/infusion",
  },
  {
    value: "Concentrate and solvent for suspension for injection",
    label: "Concentrate and solvent for suspension for injection",
  },
  {
    value: "Concentrate for concentrate for solution for infusion",
    label: "Concentrate for concentrate for solution for infusion",
  },
  { value: "Concentrate for cutaneous solution", label: "Concentrate for cutaneous solution" },
  { value: "Concentrate for cutaneous spray, emulsion", label: "Concentrate for cutaneous spray, emulsion" },
  { value: "Concentrate for dispersion for infusion", label: "Concentrate for dispersion for infusion" },
  { value: "Concentrate for dispersion for injection", label: "Concentrate for dispersion for injection" },
  { value: "Concentrate for emulsion for infusion", label: "Concentrate for emulsion for infusion" },
  { value: "Concentrate for gargle", label: "Concentrate for gargle" },
  { value: "Concentrate for intravesical solution", label: "Concentrate for intravesical solution" },
  { value: "Concentrate for nebuliser solution", label: "Concentrate for nebuliser solution" },
  { value: "Concentrate for oral solution", label: "Concentrate for oral solution" },
  { value: "Concentrate for oral suspension", label: "Concentrate for oral suspension" },
  { value: "Concentrate for oral/rectal solution", label: "Concentrate for oral/rectal solution" },
  { value: "Concentrate for oromucosal solution", label: "Concentrate for oromucosal solution" },
  { value: "Concentrate for rectal solution", label: "Concentrate for rectal solution" },
  { value: "Concentrate for solution for haemodialysis", label: "Concentrate for solution for haemodialysis" },
  { value: "Concentrate for solution for infusion", label: "Concentrate for solution for infusion" },
  { value: "Concentrate for solution for injection", label: "Concentrate for solution for injection" },
  {
    value: "Concentrate for solution for injection/infusion",
    label: "Concentrate for solution for injection/infusion",
  },
  {
    value: "Concentrate for solution for intraocular irrigation",
    label: "Concentrate for solution for intraocular irrigation",
  },
  {
    value: "Concentrate for solution for peritoneal dialysis",
    label: "Concentrate for solution for peritoneal dialysis",
  },
  { value: "Concentrate for suspension for injection", label: "Concentrate for suspension for injection" },
  { value: "Cream", label: "Cream" },
  { value: "Cream + pessary", label: "Cream + pessary" },
  { value: "Cream + vaginal capsule, soft", label: "Cream + vaginal capsule, soft" },
  { value: "Cream + vaginal tablet", label: "Cream + vaginal tablet" },
  { value: "Cutaneous emulsion", label: "Cutaneous emulsion" },
  { value: "Cutaneous foam", label: "Cutaneous foam" },
  { value: " Cutaneous liquid", label: " Cutaneous liquid" },
  { value: "Cutaneous paste", label: "Cutaneous paste" },
  { value: "Cutaneous powder", label: "Cutaneous powder" },
  { value: "Cutaneous solution", label: "Cutaneous solution" },
  { value: "Cutaneous solution + medicated sponge", label: "Cutaneous solution + medicated sponge" },
  { value: "Cutaneous solution in single-dose container", label: "Cutaneous solution in single-dose container" },
  {
    value: "Cutaneous solution/concentrate for oromucosal solution",
    label: "Cutaneous solution/concentrate for oromucosal solution",
  },
  { value: "Cutaneous spray", label: "Cutaneous spray" },
  { value: "Cutaneous spray, emulsion", label: "Cutaneous spray, emulsion" },
  { value: "Cutaneous spray, ointment", label: "Cutaneous spray, ointment" },
  { value: "Cutaneous spray, powder", label: "Cutaneous spray, powder" },
  { value: "Cutaneous spray, solution", label: "Cutaneous spray, solution" },
  { value: "Cutaneous spray, suspension", label: "Cutaneous spray, suspension" },
  { value: "Cutaneous stick", label: "Cutaneous stick" },
  { value: "Cutaneous suspension", label: "Cutaneous suspension" },
  { value: "Cutaneous/nasal ointment", label: "Cutaneous/nasal ointment" },
  { value: "Cutaneous/oromucosal solution", label: "Cutaneous/oromucosal solution" },
  { value: "Dental cement", label: "Dental cement" },
  { value: "Dental emulsion", label: "Dental emulsion" },
  { value: "Dental gel", label: "Dental gel" },
  { value: "Dental liquid", label: "Dental liquid" },
  { value: "Dental paste", label: "Dental paste" },
  { value: "Dental powder", label: "Dental powder" },
  { value: "Dental solution", label: "Dental solution" },
  { value: "Dental stick", label: "Dental stick" },
  { value: "Dental suspension", label: "Dental suspension" },
  { value: "Denturelacquer", label: "Denturelacquer" },
  { value: "Dispersible tablet", label: "Dispersible tablet" },
  { value: "Dispersible tablets for dose dispenser", label: "Dispersible tablets for dose dispenser" },
  {
    value: "Dispersion for concentrate for dispersion for infusion",
    label: "Dispersion for concentrate for dispersion for infusion",
  },
  { value: "Dispersion for infusion", label: "Dispersion for infusion" },
  { value: "Dispersion for injection", label: "Dispersion for injection" },
  { value: "Dispersion for injection/infusion", label: "Dispersion for injection/infusion" },
  { value: "Ear cream", label: "Ear cream" },
  { value: "Ear drops", label: "Ear drops" },
  { value: "Ear drops, emulsion", label: "Ear drops, emulsion" },
  { value: "Ear drops, powder and solvent for suspension", label: "Ear drops, powder and solvent for suspension" },
  { value: "Ear drops, powder for suspension", label: "Ear drops, powder for suspension" },
  { value: "Ear drops, solution", label: "Ear drops, solution" },
  { value: "Ear drops, solution in single-dose container", label: "Ear drops, solution in single-dose container" },
  { value: "Ear drops, suspension", label: "Ear drops, suspension" },
  { value: "Ear drops, suspension in single-dose container", label: "Ear drops, suspension in single-dose container" },
  { value: "Ear gel", label: "Ear gel" },
  { value: "Ear ointment", label: "Ear ointment" },
  { value: "Ear powder", label: "Ear powder" },
  { value: "Ear spray", label: "Ear spray" },
  { value: "Ear spray, emulsion", label: "Ear spray, emulsion" },
  { value: "Ear spray, solution", label: "Ear spray, solution" },
  { value: "Ear spray, suspension", label: "Ear spray, suspension" },
  { value: "Ear stick", label: "Ear stick" },
  { value: "Ear tampon", label: "Ear tampon" },
  { value: "Ear wash", label: "Ear wash" },
  { value: "Ear wash, emulsion", label: "Ear wash, emulsion" },
  { value: "Ear wash, solution", label: "Ear wash, solution" },
  { value: "Ear/eye drops, solution", label: "Ear/eye drops, solution" },
  { value: "Ear/eye drops, suspension", label: "Ear/eye drops, suspension" },
  { value: "Ear/eye ointment", label: "Ear/eye ointment" },
  { value: "Ear/eye/nasal drops, solution", label: "Ear/eye/nasal drops, solution" },
  { value: "Ear/nasal drops, suspension", label: "Ear/nasal drops, suspension" },
  { value: "Effervescent granules", label: "Effervescent granules" },
  { value: "Effervescent granules + film-coated tablet", label: "Effervescent granules + film-coated tablet" },
  {
    value: "Effervescent granules + gastro-resistant tablet",
    label: "Effervescent granules + gastro-resistant tablet",
  },
  { value: "Effervescent granules for oral suspension", label: "Effervescent granules for oral suspension" },
  { value: "Effervescent powder", label: "Effervescent powder" },
  {
    value: "Effervescent powder and powder for oral suspension",
    label: "Effervescent powder and powder for oral suspension",
  },
  { value: "Effervescent tablet", label: "Effervescent tablet" },
  { value: "Effervescent tablet + film-coated tablet", label: "Effervescent tablet + film-coated tablet" },
  { value: "Effervescent vaginal tablet", label: "Effervescent vaginal tablet" },
  {
    value: "Emulsion and suspension for emulsion for injection",
    label: "Emulsion and suspension for emulsion for injection",
  },
  { value: "Emulsion for emulsion for injection", label: "Emulsion for emulsion for injection" },
  { value: "Emulsion for infusion", label: "Emulsion for infusion" },
  { value: "Emulsion for infusion in administration system", label: "Emulsion for infusion in administration system" },
  { value: "Emulsion for injection", label: "Emulsion for injection" },
  { value: "Emulsion for injection/infusion", label: "Emulsion for injection/infusion" },
  {
    value: "Emulsion for injection/infusion in pre-filled syringe",
    label: "Emulsion for injection/infusion in pre-filled syringe",
  },
  { value: "Emulsion for suspension for injection", label: "Emulsion for suspension for injection" },
  { value: "Endocervical gel", label: "Endocervical gel" },
  { value: "Endosinusial solution", label: "Endosinusial solution" },
  { value: "Endosinusial wash, suspension", label: "Endosinusial wash, suspension" },
  { value: "Endotracheopulmonary instillation", label: "Endotracheopulmonary instillation" },
  {
    value: "Endotracheopulmonary instillation, powder and solvent for solution",
    label: "Endotracheopulmonary instillation, powder and solvent for solution",
  },
  {
    value: "Endotracheopulmonary instillation, powder and solvent for suspension",
    label: "Endotracheopulmonary instillation, powder and solvent for suspension",
  },
  {
    value: "Endotracheopulmonary instillation, powder for solution",
    label: "Endotracheopulmonary instillation, powder for solution",
  },
  {
    value: "Endotracheopulmonary instillation, powder for suspension",
    label: "Endotracheopulmonary instillation, powder for suspension",
  },
  { value: "Endotracheopulmonary instillation, solution", label: "Endotracheopulmonary instillation, solution" },
  { value: "Endotracheopulmonary instillation, suspension", label: "Endotracheopulmonary instillation, suspension" },
  { value: "Enema", label: "Enema" },
  { value: "Epilesional solution", label: "Epilesional solution" },
  { value: "Eye cream", label: "Eye cream" },
  { value: "Eye drops", label: "Eye drops" },
  { value: "Eye drops, emulsion", label: "Eye drops, emulsion" },
  { value: "Eye drops, emulsion in single-dose container", label: "Eye drops, emulsion in single-dose container" },
  { value: "Eye drops, powder and solvent for solution", label: "Eye drops, powder and solvent for solution" },
  { value: "Eye drops, powder and solvent for suspension", label: "Eye drops, powder and solvent for suspension" },
  { value: "Eye drops, powder for solution", label: "Eye drops, powder for solution" },
  { value: "Eye drops, powder for suspension", label: "Eye drops, powder for suspension" },
  { value: "Eye drops, prolonged-release", label: "Eye drops, prolonged-release" },
  {
    value: "Eye drops, prolonged-release solution in single-dose container",
    label: "Eye drops, prolonged-release solution in single-dose container",
  },
  { value: "Eye drops, solution", label: "Eye drops, solution" },
  { value: "Eye drops, solution in single-dose container", label: "Eye drops, solution in single-dose container" },
  { value: "Eye drops, solvent for reconstitution", label: "Eye drops, solvent for reconstitution" },
  { value: "Eye drops, suspension", label: "Eye drops, suspension" },
  { value: "Eye drops, suspension in single-dose container", label: "Eye drops, suspension in single-dose container" },
  { value: "Eye gel", label: "Eye gel" },
  { value: "Eye gel in single-dose container", label: "Eye gel in single-dose container" },
  { value: "Eye lotion", label: "Eye lotion" },
  { value: "Eye lotion, solvent for reconstitution", label: "Eye lotion, solvent for reconstitution" },
  { value: "Eye ointment", label: "Eye ointment" },
  { value: "Eye ointment in single-dose container", label: "Eye ointment in single-dose container" },
  { value: "Film-coated tablet", label: "Film-coated tablet" },
  { value: "Film-coated tablet + pessary", label: "Film-coated tablet + pessary" },
  { value: "Film-coated tablet + tablet", label: "Film-coated tablet + tablet" },
  {
    value: "Film-coated tablet and gastro-resistant granules in sachet",
    label: "Film-coated tablet and gastro-resistant granules in sachet",
  },
  { value: "Gargle", label: "Gargle" },
  { value: "Gargle, powder for solution", label: "Gargle, powder for solution" },
  { value: "Gargle, tablet for solution", label: "Gargle, tablet for solution" },
  { value: "Gargle/mouthwash", label: "Gargle/mouthwash" },
  { value: "Gargle/nasal wash", label: "Gargle/nasal wash" },
  {
    value: "Gas and solvent for dispersion for injection/infusion",
    label: "Gas and solvent for dispersion for injection/infusion",
  },
  { value: "Gas for dispersion for infusion", label: "Gas for dispersion for infusion" },
  { value: "Gas for dispersion for injection", label: "Gas for dispersion for injection" },
  { value: "Gas for dispersion for injection/infusion", label: "Gas for dispersion for injection/infusion" },
  { value: "Gastro-resistant capsule", label: "Gastro-resistant capsule" },
  { value: "Gastro-resistant capsule, hard", label: "Gastro-resistant capsule, hard" },
  { value: "Gastro-resistant capsule, soft", label: "Gastro-resistant capsule, soft" },
  { value: "Gastro-resistant granules", label: "Gastro-resistant granules" },
  { value: "Gastro-resistant granules for oral suspension", label: "Gastro-resistant granules for oral suspension" },
  {
    value: "Gastro-resistant granules for oral suspension in sachet",
    label: "Gastro-resistant granules for oral suspension in sachet",
  },
  { value: "Gastro-resistant oral suspension", label: "Gastro-resistant oral suspension" },
  {
    value: "Gastro-resistant powder and solvent for oral suspension",
    label: "Gastro-resistant powder and solvent for oral suspension",
  },
  { value: "Gastro-resistant powder for oral suspension", label: "Gastro-resistant powder for oral suspension" },
  { value: "Gastro-resistant tablet", label: "Gastro-resistant tablet" },
  { value: "Gastro-resistant tablet + rectal suspension", label: "Gastro-resistant tablet + rectal suspension" },
  { value: "Gastroenteral emulsion", label: "Gastroenteral emulsion" },
  { value: "Gastroenteral liquid", label: "Gastroenteral liquid" },
  { value: "Gastroenteral solution", label: "Gastroenteral solution" },
  { value: "Gastroenteral suspension", label: "Gastroenteral suspension" },
  { value: "Gel", label: "Gel" },
  { value: "Gel for gel", label: "Gel for gel" },
  { value: "Gel for injection", label: "Gel for injection" },
  { value: "Gel in pressurised container", label: "Gel in pressurised container" },
  { value: "Gel in sachet", label: "Gel in sachet" },
  { value: "Gingival gel", label: "Gingival gel" },
  { value: "Gingival paste", label: "Gingival paste" },
  { value: "Gingival solution", label: "Gingival solution" },
  { value: "Granules", label: "Granules" },
  { value: "Granules and solvent for oral suspension", label: "Granules and solvent for oral suspension" },
  {
    value: "Granules and solvent for suspension for injection",
    label: "Granules and solvent for suspension for injection",
  },
  { value: "Granules for oral solution", label: "Granules for oral solution" },
  { value: "Granules for oral solution in sachet", label: "Granules for oral solution in sachet" },
  { value: "Granules for oral suspension", label: "Granules for oral suspension" },
  { value: "Granules for oral suspension in sachet", label: "Granules for oral suspension in sachet" },
  { value: "Granules for oral/rectal suspension", label: "Granules for oral/rectal suspension" },
  { value: "Granules for rectal suspension", label: "Granules for rectal suspension" },
  { value: "Granules for suspension for injection", label: "Granules for suspension for injection" },
  { value: "Granules for syrup", label: "Granules for syrup" },
  { value: "Granules for vaginal solution", label: "Granules for vaginal solution" },
  { value: "Granules in sachet", label: "Granules in sachet" },
  { value: "Granules in single-dose container", label: "Granules in single-dose container" },
  { value: "Herbal tea", label: "Herbal tea" },
  { value: "Herbal tea in bag", label: "Herbal tea in bag" },
  { value: "Implant", label: "Implant" },
  { value: "Implant in pre-filled syringe", label: "Implant in pre-filled syringe" },
  { value: "Implantation chain", label: "Implantation chain" },
  { value: "Implantation matrix", label: "Implantation matrix" },
  { value: "Implantation paste", label: "Implantation paste" },
  { value: "Implantation suspension", label: "Implantation suspension" },
  { value: "Implantation tablet", label: "Implantation tablet" },
  { value: "Impregnated cutaneous swab", label: "Impregnated cutaneous swab" },
  { value: "Impregnated dressing", label: "Impregnated dressing" },
  { value: "Impregnated pad", label: "Impregnated pad" },
  { value: "Impregnated plug", label: "Impregnated plug" },
  { value: "Infusion", label: "Infusion" },
  { value: "Inhalation powder", label: "Inhalation powder" },
  { value: "Inhalation powder", label: "Inhalation powder" },
  { value: "Inhalation powder, hard capsule", label: "Inhalation powder, hard capsule" },
  { value: "Inhalation powder, pre-dispensed", label: "Inhalation powder, pre-dispensed" },
  { value: "Inhalation powder, tablet", label: "Inhalation powder, tablet" },
  { value: "Inhalation solution", label: "Inhalation solution" },
  { value: "Inhalation vapour", label: "Inhalation vapour" },
  { value: "Inhalation vapour, capsule", label: "Inhalation vapour, capsule" },
  { value: "Inhalation vapour, effervescent tablet", label: "Inhalation vapour, effervescent tablet" },
  { value: "Inhalation vapour, emulsion", label: "Inhalation vapour, emulsion" },
  { value: "Inhalation vapour, impregnated pad", label: "Inhalation vapour, impregnated pad" },
  { value: "Inhalation vapour, impregnated plug", label: "Inhalation vapour, impregnated plug" },
  { value: "Inhalation vapour, liquid", label: "Inhalation vapour, liquid" },
  { value: "Inhalation vapour, ointment", label: "Inhalation vapour, ointment" },
  { value: "Inhalation vapour, powder", label: "Inhalation vapour, powder" },
  { value: "Inhalation vapour, solution", label: "Inhalation vapour, solution" },
  { value: "Inhalation vapour, tablet", label: "Inhalation vapour, tablet" },
  { value: "Injection", label: "Injection" },
  { value: "Injection/infusion", label: "Injection/infusion" },
  { value: "Instant herbal tea", label: "Instant herbal tea" },
  { value: "Intestinal gel", label: "Intestinal gel" },
  { value: "Intraocular instillation solution", label: "Intraocular instillation solution" },
  { value: "Intraperitoneal solution", label: "Intraperitoneal solution" },
  { value: "Intrauterine delivery system", label: "Intrauterine delivery system" },
  { value: "Intrauterine gel", label: "Intrauterine gel" },
  { value: "Intravesical solution", label: "Intravesical solution" },
  { value: "Intravesical solution/solution for injection", label: "Intravesical solution/solution for injection" },
  { value: "Intravesical suspension", label: "Intravesical suspension" },
  { value: "Intravitreal implant in applicator", label: "Intravitreal implant in applicator" },
  { value: "Irrigation solution", label: "Irrigation solution" },
  { value: "Kit for radiopharmaceutical preparation", label: "Kit for radiopharmaceutical preparation" },
  { value: "Laryngopharyngeal solution", label: "Laryngopharyngeal solution" },
  { value: "Laryngopharyngeal spray, solution", label: "Laryngopharyngeal spray, solution" },
  { value: "Living tissue equivalent", label: "Living tissue equivalent" },
  { value: "Lozenge", label: "Lozenge" },
  { value: "Matrix for implantation matrix", label: "Matrix for implantation matrix" },
  { value: "Medicated chewing-gum", label: "Medicated chewing-gum" },
  { value: "Medicated nail lacquer", label: "Medicated nail lacquer" },
  { value: "Medicated plaster", label: "Medicated plaster" },
  { value: "Medicated sponge", label: "Medicated sponge" },
  { value: "Medicated thread", label: "Medicated thread" },
  { value: "Medicated vaginal tampon", label: "Medicated vaginal tampon" },
  { value: "Medicinal gas, compressed", label: "Medicinal gas, compressed" },
  { value: "Medicinal gas, cryogenic", label: "Medicinal gas, cryogenic" },
  { value: "Medicinal gas, liquefied", label: "Medicinal gas, liquefied" },
  { value: "Medicinal larvae", label: "Medicinal larvae" },
  { value: "Medicinal leech", label: "Medicinal leech" },
  { value: "Modified-release capsule, hard", label: "Modified-release capsule, hard" },
  { value: "Modified-release capsule, soft", label: "Modified-release capsule, soft" },
  { value: "Modified-release granules", label: "Modified-release granules" },
  { value: "Modified-release granules for oral suspension", label: "Modified-release granules for oral suspension" },
  { value: "Modified-release oral suspension", label: "Modified-release oral suspension" },
  { value: "Modified-release tablet", label: "Modified-release tablet" },
  { value: "Mouthwash", label: "Mouthwash" },
  { value: "Mouthwash, powder for solution", label: "Mouthwash, powder for solution" },
  { value: "Mouthwash, tablet for solution", label: "Mouthwash, tablet for solution" },
  { value: "Muco-adhesive buccal tablet", label: "Muco-adhesive buccal tablet" },
  { value: "Nasal cream", label: "Nasal cream" },
  { value: "Nasal drops", label: "Nasal drops" },
  { value: "Nasal drops, emulsion", label: "Nasal drops, emulsion" },
  { value: "Nasal drops, powder and solvent for solution", label: "Nasal drops, powder and solvent for solution" },
  { value: "Nasal drops, powder for solution", label: "Nasal drops, powder for solution" },
  { value: "Nasal drops, solution", label: "Nasal drops, solution" },
  { value: "Nasal drops, solution in single-dose container", label: "Nasal drops, solution in single-dose container" },
  { value: "Nasal drops, suspension", label: "Nasal drops, suspension" },
  { value: "Nasal gel", label: "Nasal gel" },
  { value: "Nasal ointment", label: "Nasal ointment" },
  { value: "Nasal powder", label: "Nasal powder" },
  { value: "Nasal powder in single-dose container", label: "Nasal powder in single-dose container" },
  { value: "Nasal spray", label: "Nasal spray" },
  { value: "Nasal spray, emulsion", label: "Nasal spray, emulsion" },
  { value: "Nasal spray, powder for solution", label: "Nasal spray, powder for solution" },
  { value: "Nasal spray, solution", label: "Nasal spray, solution" },
  { value: "Nasal spray, solution in single-dose container", label: "Nasal spray, solution in single-dose container" },
  { value: "Nasal spray, solution/oromucosal solution", label: "Nasal spray, solution/oromucosal solution" },
  { value: "Nasal spray, suspension", label: "Nasal spray, suspension" },
  { value: "Nasal stick", label: "Nasal stick" },
  { value: "Nasal wash", label: "Nasal wash" },
  { value: "Nasal/oromucosal solution", label: "Nasal/oromucosal solution" },
  { value: "Nasal/oromucosal spray, solution", label: "Nasal/oromucosal spray, solution" },
  { value: "Nebuliser dispersion", label: "Nebuliser dispersion" },
  { value: "Nebuliser emulsion", label: "Nebuliser emulsion" },
  { value: "Nebuliser liquid", label: "Nebuliser liquid" },
  { value: "Nebuliser solution", label: "Nebuliser solution" },
  { value: "Nebuliser suspension", label: "Nebuliser suspension" },
  { value: "Ointment", label: "Ointment" },
  { value: "Ointment + vaginal tablet", label: "Ointment + vaginal tablet" },
  { value: "Ophthalmic insert", label: "Ophthalmic insert" },
  { value: "Ophthalmic strip", label: "Ophthalmic strip" },
  { value: "Oral drops", label: "Oral drops" },
  { value: "Oral drops, emulsion", label: "Oral drops, emulsion" },
  { value: "Oral drops, granules for solution", label: "Oral drops, granules for solution" },
  { value: "Oral drops, liquid", label: "Oral drops, liquid" },
  { value: "Oral drops, powder for suspension", label: "Oral drops, powder for suspension" },
  { value: "Oral drops, solution", label: "Oral drops, solution" },
  { value: "Oral drops, suspension", label: "Oral drops, suspension" },
  { value: "Oral emulsion", label: "Oral emulsion" },
  { value: "Oral emulsion in sachet", label: "Oral emulsion in sachet" },
  { value: "Oral gel", label: "Oral gel" },
  { value: "Oral gum", label: "Oral gum" },
  { value: "Oral herbal material", label: "Oral herbal material" },
  { value: "Oral liquid", label: "Oral liquid" },
  { value: "Oral lyophilisate", label: "Oral lyophilisate" },
  { value: "Oral paste", label: "Oral paste" },
  { value: "Oral paste in sachet", label: "Oral paste in sachet" },
  { value: "Oral powder", label: "Oral powder" },
  { value: "Oral powder in sachet", label: "Oral powder in sachet" },
  { value: "Oral powder in single-dose container", label: "Oral powder in single-dose container" },
  { value: "Oral solution", label: "Oral solution" },
  { value: "Oral solution in bottle", label: "Oral solution in bottle" },
  { value: "Oral solution in sachet", label: "Oral solution in sachet" },
  { value: "Oral solution in single-dose container", label: "Oral solution in single-dose container" },
  {
    value: "Oral solution/concentrate for nebuliser solution",
    label: "Oral solution/concentrate for nebuliser solution",
  },
  { value: "Oral suspension", label: "Oral suspension" },
  { value: "Oral suspension in pre-filled oral applicator", label: "Oral suspension in pre-filled oral applicator" },
  { value: "Oral suspension in sachet", label: "Oral suspension in sachet" },
  { value: "Oral/rectal solution", label: "Oral/rectal solution" },
  { value: "Oral/rectal suspension", label: "Oral/rectal suspension" },
  { value: "Orodispersible film", label: "Orodispersible film" },
  { value: "Orodispersible tablet", label: "Orodispersible tablet" },
  { value: "Oromucosal capsule", label: "Oromucosal capsule" },
  { value: "Oromucosal cream", label: "Oromucosal cream" },
  { value: "Oromucosal drops", label: "Oromucosal drops" },
  { value: "Oromucosal gel", label: "Oromucosal gel" },
  { value: "Oromucosal liquid", label: "Oromucosal liquid" },
  { value: "Oromucosal ointment", label: "Oromucosal ointment" },
  { value: "Oromucosal paste", label: "Oromucosal paste" },
  { value: "Oromucosal patch", label: "Oromucosal patch" },
  { value: "Oromucosal pouch", label: "Oromucosal pouch" },
  { value: "Oromucosal powder in pouch", label: "Oromucosal powder in pouch" },
  { value: "Oromucosal solution", label: "Oromucosal solution" },
  { value: "Oromucosal spray", label: "Oromucosal spray" },
  { value: "Oromucosal spray, emulsion", label: "Oromucosal spray, emulsion" },
  { value: "Oromucosal spray, solution", label: "Oromucosal spray, solution" },
  { value: "Oromucosal spray, suspension", label: "Oromucosal spray, suspension" },
  { value: "Oromucosal suspension", label: "Oromucosal suspension" },
  { value: "Oromucosal/laryngopharyngeal solution", label: "Oromucosal/laryngopharyngeal solution" },
  {
    value: "Oromucosal/laryngopharyngeal solution/spray, solution",
    label: "Oromucosal/laryngopharyngeal solution/spray, solution",
  },
  { value: "Pastille", label: "Pastille" },
  { value: "Periodontal gel", label: "Periodontal gel" },
  { value: "Periodontal insert", label: "Periodontal insert" },
  { value: "Periodontal powder", label: "Periodontal powder" },
  { value: "Pessary", label: "Pessary" },
  { value: "Pillules", label: "Pillules" },
  { value: "Pillules in single-dose container", label: "Pillules in single-dose container" },
  { value: "Plaster for provocation test", label: "Plaster for provocation test" },
  { value: "Pouch", label: "Pouch" },
  { value: "Poultice", label: "Poultice" },
  { value: "Powder and gel for gel", label: "Powder and gel for gel" },
  { value: "Powder and solution for dental cement", label: "Powder and solution for dental cement" },
  { value: "Powder and solution for solution for injection", label: "Powder and solution for solution for injection" },
  {
    value: "Powder and solution for suspension for injection",
    label: "Powder and solution for suspension for injection",
  },
  {
    value: "Powder and solvent for concentrate for solution for infusion",
    label: "Powder and solvent for concentrate for solution for infusion",
  },
  { value: "Powder and solvent for cutaneous solution", label: "Powder and solvent for cutaneous solution" },
  { value: "Powder and solvent for dental gel", label: "Powder and solvent for dental gel" },
  {
    value: "Powder and solvent for dispersion for injection",
    label: "Powder and solvent for dispersion for injection",
  },
  { value: "Powder and solvent for emulsion for injection", label: "Powder and solvent for emulsion for injection" },
  { value: "Powder and solvent for endocervical gel", label: "Powder and solvent for endocervical gel" },
  { value: "Powder and solvent for endosinusial solution", label: "Powder and solvent for endosinusial solution" },
  { value: "Powder and solvent for epilesional solution", label: "Powder and solvent for epilesional solution" },
  { value: "Powder and solvent for gingival gel", label: "Powder and solvent for gingival gel" },
  { value: "Powder and solvent for implantation paste", label: "Powder and solvent for implantation paste" },
  {
    value: "Powder and solvent for intraocular instillation solution",
    label: "Powder and solvent for intraocular instillation solution",
  },
  { value: "Powder and solvent for intravesical solution", label: "Powder and solvent for intravesical solution" },
  { value: "Powder and solvent for intravesical suspension", label: "Powder and solvent for intravesical suspension" },
  { value: "Powder and solvent for nebuliser solution", label: "Powder and solvent for nebuliser solution" },
  { value: "Powder and solvent for oral solution", label: "Powder and solvent for oral solution" },
  { value: "Powder and solvent for oral suspension", label: "Powder and solvent for oral suspension" },
  {
    value: "Powder and solvent for prolonged-release suspension for injection",
    label: "Powder and solvent for prolonged-release suspension for injection",
  },
  {
    value: "Powder and solvent for prolonged-release suspension for injection in pre-filled pen",
    label: "Powder and solvent for prolonged-release suspension for injection in pre-filled pen",
  },
  {
    value: "Powder and solvent for prolonged-release suspension for injection in pre-filled syringe",
    label: "Powder and solvent for prolonged-release suspension for injection in pre-filled syringe",
  },
  { value: "Powder and solvent for sealant", label: "Powder and solvent for sealant" },
  { value: "Powder and solvent for solution for infusion", label: "Powder and solvent for solution for infusion" },
  { value: "Powder and solvent for solution for injection", label: "Powder and solvent for solution for injection" },
  {
    value: "Powder and solvent for solution for injection in cartridge",
    label: "Powder and solvent for solution for injection in cartridge",
  },
  {
    value: "Powder and solvent for solution for injection in pre-filled pen",
    label: "Powder and solvent for solution for injection in pre-filled pen",
  },
  {
    value: "Powder and solvent for solution for injection in pre-filled syringe",
    label: "Powder and solvent for solution for injection in pre-filled syringe",
  },
  {
    value: "Powder and solvent for solution for injection/infusion",
    label: "Powder and solvent for solution for injection/infusion",
  },
  {
    value: "Powder and solvent for solution for injection/skin-prick test",
    label: "Powder and solvent for solution for injection/skin-prick test",
  },
  {
    value: "Powder and solvent for suspension for injection",
    label: "Powder and solvent for suspension for injection",
  },
  {
    value: "Powder and solvent for suspension for injection in multidose container",
    label: "Powder and solvent for suspension for injection in multidose container",
  },
  {
    value: "Powder and solvent for suspension for injection in pre-filled syringe",
    label: "Powder and solvent for suspension for injection in pre-filled syringe",
  },
  { value: "Powder and solvent for syrup", label: "Powder and solvent for syrup" },
  {
    value: "Powder and suspension for suspension for injection",
    label: "Powder and suspension for suspension for injection",
  },
  { value: "Powder for bladder irrigation", label: "Powder for bladder irrigation" },
  { value: "Powder for concentrate", label: "Powder for concentrate" },
  {
    value: "Powder for concentrate and solution for solution for infusion",
    label: "Powder for concentrate and solution for solution for infusion",
  },
  {
    value: "Powder for concentrate for dispersion for infusion",
    label: "Powder for concentrate for dispersion for infusion",
  },
  {
    value: "Powder for concentrate for intravesical suspension",
    label: "Powder for concentrate for intravesical suspension",
  },
  {
    value: "Powder for concentrate for solution for haemodialysis",
    label: "Powder for concentrate for solution for haemodialysis",
  },
  {
    value: "Powder for concentrate for solution for infusion",
    label: "Powder for concentrate for solution for infusion",
  },
  {
    value: "Powder for concentrate for solution for injection/infusion",
    label: "Powder for concentrate for solution for injection/infusion",
  },
  { value: "Powder for cutaneous solution", label: "Powder for cutaneous solution" },
  { value: "Powder for dental cement", label: "Powder for dental cement" },
  { value: "Powder for dental gel", label: "Powder for dental gel" },
  { value: "Powder for dental solution", label: "Powder for dental solution" },
  { value: "Powder for dispersion for infusion", label: "Powder for dispersion for infusion" },
  { value: "Powder for dispersion for injection", label: "Powder for dispersion for injection" },
  { value: "Powder for emulsion for injection", label: "Powder for emulsion for injection" },
  { value: "Powder for endocervical gel", label: "Powder for endocervical gel" },
  { value: "Powder for endosinusial solution", label: "Powder for endosinusial solution" },
  { value: "Powder for epilesional solution", label: "Powder for epilesional solution" },
  { value: "Powder for gel", label: "Powder for gel" },
  { value: "Powder for gingival gel", label: "Powder for gingival gel" },
  { value: "Powder for implantation matrix", label: "Powder for implantation matrix" },
  { value: "Powder for implantation paste", label: "Powder for implantation paste" },
  { value: "Powder for implantation suspension", label: "Powder for implantation suspension" },
  { value: "Powder for infusion", label: "Powder for infusion" },
  { value: "Powder for injection", label: "Powder for injection" },
  { value: "Powder for intraocular instillation solution", label: "Powder for intraocular instillation solution" },
  { value: "Powder for intravesical solution", label: "Powder for intravesical solution" },
  {
    value: "Powder for intravesical solution/solution for injection",
    label: "Powder for intravesical solution/solution for injection",
  },
  { value: "Powder for intravesical suspension", label: "Powder for intravesical suspension" },
  { value: "Powder for nebuliser solution", label: "Powder for nebuliser solution" },
  { value: "Powder for nebuliser suspension", label: "Powder for nebuliser suspension" },
  { value: "Powder for oral solution", label: "Powder for oral solution" },
  { value: "Powder for oral solution in sachet", label: "Powder for oral solution in sachet" },
  { value: "Powder for oral suspension", label: "Powder for oral suspension" },
  { value: "Powder for oral/rectal suspension", label: "Powder for oral/rectal suspension" },
  { value: "Powder for oral/rectal suspension in sachet", label: "Powder for oral/rectal suspension in sachet" },
  { value: "Powder for prolonged-release injection", label: "Powder for prolonged-release injection" },
  {
    value: "Powder for prolonged-release suspension for injection",
    label: "Powder for prolonged-release suspension for injection",
  },
  { value: "Powder for rectal solution", label: "Powder for rectal solution" },
  { value: "Powder for rectal suspension", label: "Powder for rectal suspension" },
  { value: "Powder for sealant", label: "Powder for sealant" },
  { value: "Powder for solution for infusion", label: "Powder for solution for infusion" },
  { value: "Powder for solution for injection", label: "Powder for solution for injection" },
  { value: "Powder for solution for injection/infusion", label: "Powder for solution for injection/infusion" },
  {
    value: "Powder for solution for injection/skin-prick test",
    label: "Powder for solution for injection/skin-prick test",
  },
  { value: "Powder for solution for intraocular irrigation", label: "Powder for solution for intraocular irrigation" },
  { value: "Powder for solution for iontophoresis", label: "Powder for solution for iontophoresis" },
  { value: "Powder for solution for skin-prick test", label: "Powder for solution for skin-prick test" },
  { value: "Powder for suspension for injection", label: "Powder for suspension for injection" },
  { value: "Powder for syrup", label: "Powder for syrup" },
  { value: "Powder for vaginal solution", label: "Powder for vaginal solution" },
  {
    value: "Powder dispersion and solvent for concentrate for dispersion for infusion",
    label: "Powder dispersion and solvent for concentrate for dispersion for infusion",
  },
  {
    value: "Powder, solvent and matrix for implantation matrix",
    label: "Powder, solvent and matrix for implantation matrix",
  },
  { value: "Pressurised inhalation", label: "Pressurised inhalation" },
  { value: "Pressurised inhalation, emulsion", label: "Pressurised inhalation, emulsion" },
  { value: "Pressurised inhalation, solution", label: "Pressurised inhalation, solution" },
  { value: "Pressurised inhalation, suspension", label: "Pressurised inhalation, suspension" },
  { value: "Prolonged-release capsule", label: "Prolonged-release capsule" },
  { value: "Prolonged-release capsule, hard", label: "Prolonged-release capsule, hard" },
  { value: "Prolonged-release capsule, soft", label: "Prolonged-release capsule, soft" },
  { value: "Prolonged-release dispersion for injection", label: "Prolonged-release dispersion for injection" },
  { value: "Prolonged-release granules", label: "Prolonged-release granules" },
  { value: "Prolonged-release granules for oral suspension", label: "Prolonged-release granules for oral suspension" },
  {
    value: "Prolonged-release granules for oral suspension in sachet",
    label: "Prolonged-release granules for oral suspension in sachet",
  },
  { value: "Prolonged-release granules in sachet", label: "Prolonged-release granules in sachet" },
  { value: "Prolonged-release oral suspension", label: "Prolonged-release oral suspension" },
  { value: "Prolonged-release solution for injection", label: "Prolonged-release solution for injection" },
  { value: "Prolonged-release suspension for injection", label: "Prolonged-release suspension for injection" },
  {
    value: "Prolonged-release suspension for injection in pre-filled pen",
    label: "Prolonged-release suspension for injection in pre-filled pen",
  },
  {
    value: "Prolonged-release suspension for injection in pre-filled syringe",
    label: "Prolonged-release suspension for injection in pre-filled syringe",
  },
  { value: "Prolonged-release tablet", label: "Prolonged-release tablet" },
  { value: "Prolonged-release wound solution", label: "Prolonged-release wound solution" },
  { value: "Radionuclide generator", label: "Radionuclide generator" },
  { value: "Radiopharmaceutical precursor", label: "Radiopharmaceutical precursor" },
  { value: "Radiopharmaceutical precursor, solution", label: "Radiopharmaceutical precursor, solution" },
  { value: "Rectal capsule", label: "Rectal capsule" },
  { value: "Rectal cream", label: "Rectal cream" },
  { value: "Rectal emulsion", label: "Rectal emulsion" },
  { value: "Rectal foam", label: "Rectal foam" },
  { value: "Rectal gel", label: "Rectal gel" },
  { value: "Rectal ointment", label: "Rectal ointment" },
  { value: "Rectal solution", label: "Rectal solution" },
  { value: "Rectal suspension", label: "Rectal suspension" },
  { value: "Rectal tampon", label: "Rectal tampon" },
  { value: "Sealant", label: "Sealant" },
  { value: "Sealant matrix", label: "Sealant matrix" },
  { value: "Sealant powder", label: "Sealant powder" },
  { value: "Shampoo", label: "Shampoo" },
  { value: "Soluble tablet", label: "Soluble tablet" },
  {
    value: "Solution and suspension for suspension for injection in pre-filled syringe",
    label: "Solution and suspension for suspension for injection in pre-filled syringe",
  },
  { value: "Solution for blood fraction modification", label: "Solution for blood fraction modification" },
  { value: "Solution for cardioplegia", label: "Solution for cardioplegia" },
  { value: "Solution for cardioplegia/organ preservation", label: "Solution for cardioplegia/organ preservation" },
  { value: "Solution for dental cement", label: "Solution for dental cement" },
  { value: "Solution for haemodiafiltration", label: "Solution for haemodiafiltration" },
  { value: "Solution for haemodialysis", label: "Solution for haemodialysis" },
  { value: "Solution for haemodialysis/haemofiltration", label: "Solution for haemodialysis/haemofiltration" },
  { value: "Solution for haemofiltration", label: "Solution for haemofiltration" },
  { value: "Solution for infusion", label: "Solution for infusion" },
  { value: "Solution for infusion in administration system", label: "Solution for infusion in administration system" },
  { value: "Solution for infusion in cartridge", label: "Solution for infusion in cartridge" },
  { value: "Solution for infusion in pre-filled syringe", label: "Solution for infusion in pre-filled syringe" },
  { value: "Solution for injection", label: "Solution for injection" },
  {
    value: "Solution for injection in administration system",
    label: "Solution for injection in administration system",
  },
  { value: "Solution for injection in cartridge", label: "Solution for injection in cartridge" },
  {
    value: "Solution for injection in dose-dispenser cartridge",
    label: "Solution for injection in dose-dispenser cartridge",
  },
  { value: "Solution for injection in multidose container", label: "Solution for injection in multidose container" },
  { value: "Solution for injection in needle-free injector", label: "Solution for injection in needle-free injector" },
  { value: "Solution for injection in pre-filled injector", label: "Solution for injection in pre-filled injector" },
  { value: "Solution for injection in pre-filled pen", label: "Solution for injection in pre-filled pen" },
  { value: "Solution for injection in pre-filled syringe", label: "Solution for injection in pre-filled syringe" },
  { value: "Solution for injection in vial", label: "Solution for injection in vial" },
  { value: "Solution for injection/infusion", label: "Solution for injection/infusion" },
  {
    value: "Solution for injection/infusion in pre-filled syringe",
    label: "Solution for injection/infusion in pre-filled syringe",
  },
  { value: "Solution for injection/skin-prick test", label: "Solution for injection/skin-prick test" },
  { value: "Solution for intraocular irrigation", label: "Solution for intraocular irrigation" },
  { value: "Solution for iontophoresis", label: "Solution for iontophoresis" },
  { value: "Solution for organ preservation", label: "Solution for organ preservation" },
  { value: "Solution for peritoneal dialysis", label: "Solution for peritoneal dialysis" },
  { value: "Solution for provocation test", label: "Solution for provocation test" },
  { value: "Solution for sealant", label: "Solution for sealant" },
  { value: "Solution for skin-prick test", label: "Solution for skin-prick test" },
  { value: "Solution for skin-scratch test", label: "Solution for skin-scratch test" },
  { value: "Solution for solution for infusion", label: "Solution for solution for infusion" },
  { value: "Solution for solution for injection", label: "Solution for solution for injection" },
  { value: "Solution for suspension for injection", label: "Solution for suspension for injection" },
  { value: "Solvent for parenteral use", label: "Solvent for parenteral use" },
  { value: "Solvent for solution for infusion", label: "Solvent for solution for infusion" },
  {
    value: "Solvent for solution for intraocular irrigation",
    label: "Solvent for solution for intraocular irrigation",
  },
  { value: "Solvent for...", label: "Solvent for..." },
  { value: "Sterile concentrate", label: "Sterile concentrate" },
  { value: "Stomach irrigation", label: "Stomach irrigation" },
  { value: "Sublingual film", label: "Sublingual film" },
  { value: "Sublingual lyophilisate", label: "Sublingual lyophilisate" },
  { value: "Sublingual powder", label: "Sublingual powder" },
  { value: "Sublingual spray", label: "Sublingual spray" },
  { value: "Sublingual spray, emulsion", label: "Sublingual spray, emulsion" },
  { value: "Sublingual spray, solution", label: "Sublingual spray, solution" },
  { value: "Sublingual spray, suspension", label: "Sublingual spray, suspension" },
  { value: "Sublingual tablet", label: "Sublingual tablet" },
  { value: "Suppository", label: "Suppository" },
  {
    value: "Suspension and effervescent granules for oral suspension",
    label: "Suspension and effervescent granules for oral suspension",
  },
  { value: "Suspension and solution for spray", label: "Suspension and solution for spray" },
  { value: "Suspension for emulsion for injection", label: "Suspension for emulsion for injection" },
  { value: "Suspension for injection", label: "Suspension for injection" },
  { value: "Suspension for injection in cartridge", label: "Suspension for injection in cartridge" },
  {
    value: "Suspension for injection in multidose container",
    label: "Suspension for injection in multidose container",
  },
  {
    value: "Suspension for injection in pre-filled injector",
    label: "Suspension for injection in pre-filled injector",
  },
  { value: "Suspension for injection in pre-filled pen", label: "Suspension for injection in pre-filled pen" },
  { value: "Suspension for injection in pre-filled syringe", label: "Suspension for injection in pre-filled syringe" },
  { value: "Suspension for oral suspension", label: "Suspension for oral suspension" },
  { value: "Suspension for suspension for injection", label: "Suspension for suspension for injection" },
  { value: "Syrup", label: "Syrup" },
  { value: "Syrup in sachet", label: "Syrup in sachet" },
  { value: "Tablet", label: "Tablet" },
  { value: "Tablet + vaginal tablet", label: "Tablet + vaginal tablet" },
  { value: "Tablet and powder for oral solution", label: "Tablet and powder for oral solution" },
  { value: "Tablet and solvent for rectal suspension", label: "Tablet and solvent for rectal suspension" },
  { value: "Tablet for cutaneous solution", label: "Tablet for cutaneous solution" },
  { value: "Tablet for rectal solution", label: "Tablet for rectal solution" },
  { value: "Tablet for rectal suspension", label: "Tablet for rectal suspension" },
  { value: "Tablet for vaginal solution", label: "Tablet for vaginal solution" },
  { value: "Tablet with sensor", label: "Tablet with sensor" },
  { value: "Toothpaste", label: "Toothpaste" },
  { value: "Transdermal gel", label: "Transdermal gel" },
  { value: "Transdermal gel in sachet", label: "Transdermal gel in sachet" },
  { value: "Transdermal ointment", label: "Transdermal ointment" },
  { value: "Transdermal patch", label: "Transdermal patch" },
  { value: "Transdermal solution", label: "Transdermal solution" },
  { value: "Transdermal spray, solution", label: "Transdermal spray, solution" },
  { value: "Transdermal system", label: "Transdermal system" },
  { value: "Urethral emulsion", label: "Urethral emulsion" },
  { value: "Urethral gel", label: "Urethral gel" },
  { value: "Urethral ointment", label: "Urethral ointment" },
  { value: "Urethral stick", label: "Urethral stick" },
  { value: "Vaginal capsule", label: "Vaginal capsule" },
  { value: "Vaginal capsule, hard", label: "Vaginal capsule, hard" },
  { value: "Vaginal capsule, soft", label: "Vaginal capsule, soft" },
  { value: "Vaginal capsule, soft + vaginal cream", label: "Vaginal capsule, soft + vaginal cream" },
  { value: "Vaginal cream", label: "Vaginal cream" },
  { value: "Vaginal cream + vaginal tablet", label: "Vaginal cream + vaginal tablet" },
  { value: "Vaginal delivery system", label: "Vaginal delivery system" },
  { value: "Vaginal emulsion", label: "Vaginal emulsion" },
  { value: "Vaginal foam", label: "Vaginal foam" },
  { value: "Vaginal gel", label: "Vaginal gel" },
  { value: "Vaginal liquid", label: "Vaginal liquid" },
  { value: "Vaginal ointment", label: "Vaginal ointment" },
  { value: "Vaginal solution", label: "Vaginal solution" },
  { value: "Vaginal suspension", label: "Vaginal suspension" },
  { value: "Vaginal tablet", label: "Vaginal tablet" },
  { value: "Wound stick", label: "Wound stick" },
]

export const EXCLUDED_MSC = [
  {
    value: "Bulgaria",
    label: "Bulgaria",
  },
  {
    value: "Czechia",
    label: "Czechia",
  },
  {
    value: "Estonia",
    label: "Estonia",
  },
  {
    value: "Belgium",
    label: "Belgium",
  },
  {
    value: "Cyprus",
    label: "Cyprus",
  },
  {
    value: "Malta",
    label: "Malta",
  },
]

export const CTIS_ROUTE_ADMINISTRATION = [
  {
    value: "ANTEGRADE EPICARDIAL CORONARY ARTERY INFUSION",
    label: "ANTEGRADE EPICARDIAL CORONARY ARTERY INFUSION",
  },
  {
    value: "ANTICOAGULANT SOLUTION",
    label: "ANTICOAGULANT SOLUTION",
  },
  {
    value: "APPLICATION",
    label: "APPLICATION",
  },
  {
    value: "AURICULAR USE",
    label: "AURICULAR USE",
  },
  {
    value: "BUCCAL USE",
    label: "BUCCAL USE",
  },
  {
    value: "CONCENTRATE FOR SOLUTION FOR INFUSION",
    label: "CONCENTRATE FOR SOLUTION FOR INFUSION",
  },
  {
    value: "CONJUNCTIVAL USE",
    label: "CONJUNCTIVAL USE",
  },
  {
    value: "CUTANEOUS USE",
    label: "CUTANEOUS USE",
  },
  {
    value: "DENTAL USE",
    label: "DENTAL USE",
  },
  {
    value: "DIRECT INTRAVENOUS INJECTION",
    label: "DIRECT INTRAVENOUS INJECTION",
  },
  {
    value: "ENDOCERVICAL USE",
    label: "ENDOCERVICAL USE",
  },
  {
    value: "ENDOSINUSIAL USE",
    label: "ENDOSINUSIAL USE",
  },
  {
    value: "ENDOTRACHEOPULMONARY USE",
    label: "ENDOTRACHEOPULMONARY USE",
  },
  {
    value: "ENTERAL FEEDING TUBE",
    label: "ENTERAL FEEDING TUBE",
  },
  {
    value: "EPIDURAL USE",
    label: "EPIDURAL USE",
  },
  {
    value: "EPILESIONAL USE",
    label: "EPILESIONAL USE",
  },
  {
    value: "EXTERNAL USE",
    label: "EXTERNAL USE",
  },
  {
    value: "EXTRAAMNIOTIC USE",
    label: "EXTRAAMNIOTIC USE",
  },
  {
    value: "EXTRACORPOREAL USE",
    label: "EXTRACORPOREAL USE",
  },
  {
    value: "EXTRAPLEURAL USE",
    label: "EXTRAPLEURAL USE",
  },
  {
    value: "EYE/EAR/NOSE DROPS",
    label: "EYE/EAR/NOSE DROPS",
  },
  {
    value: "FOR CLEANING OF INDWELLING CANNULAE",
    label: "FOR CLEANING OF INDWELLING CANNULAE",
  },
  {
    value: "GASTRIC USE",
    label: "GASTRIC USE",
  },
  {
    value: "GASTROENTERAL USE",
    label: "GASTROENTERAL USE",
  },
  {
    value: "GINGIVAL USE",
    label: "GINGIVAL USE",
  },
  {
    value: "HAEMODIALYSIS",
    label: "HAEMODIALYSIS",
  },
  {
    value: "I.T. BOLUS INJECTION TO THE INTRATHECAL SPACE",
    label: "I.T. BOLUS INJECTION TO THE INTRATHECAL SPACE",
  },
  {
    value: "IMPLANTATION",
    label: "IMPLANTATION",
  },
  {
    value: "IN DRINKING WATER USE",
    label: "IN DRINKING WATER USE",
  },
  {
    value: "INFILTRATION",
    label: "INFILTRATION",
  },
  {
    value: "INFUSION",
    label: "INFUSION",
  },
  {
    value: "INHALATION",
    label: "INHALATION",
  },
  {
    value: "INHALATION GAS",
    label: "INHALATION GAS",
  },
  {
    value: "INHALATION USE",
    label: "INHALATION USE",
  },
  {
    value: "INJECTION",
    label: "INJECTION",
  },
  {
    value: "INJECTION INTO EPICARDIAL FAT PADS",
    label: "INJECTION INTO EPICARDIAL FAT PADS",
  },
  {
    value: "INTESTINAL",
    label: "INTESTINAL",
  },
  {
    value: "INTESTINAL USE",
    label: "INTESTINAL USE",
  },
  {
    value: "INTRA SEROSA",
    label: "INTRA SEROSA",
  },
  {
    value: "INTRA-ABDOMINAL USE",
    label: "INTRA-ABDOMINAL USE",
  },
  {
    value: "INTRAAMNIOTIC USE",
    label: "INTRAAMNIOTIC USE",
  },
  {
    value: "INTRAARTERIAL USE",
    label: "INTRAARTERIAL USE",
  },
  {
    value: "INTRAARTICULAR USE",
    label: "INTRAARTICULAR USE",
  },
  {
    value: "INTRABURSAL USE",
    label: "INTRABURSAL USE",
  },
  {
    value: "INTRACAMERAL USE",
    label: "INTRACAMERAL USE",
  },
  {
    value: "INTRACARDIAC USE",
    label: "INTRACARDIAC USE",
  },
  {
    value: "INTRACARTILAGINOUS USE",
    label: "INTRACARTILAGINOUS USE",
  },
  {
    value: "INTRACAVERNOUS USE",
    label: "INTRACAVERNOUS USE",
  },
  {
    value: "INTRACEREBRAL USE",
    label: "INTRACEREBRAL USE",
  },
  {
    value: "INTRACEREBROVENTRICULAR (ICV)",
    label: "INTRACEREBROVENTRICULAR (ICV)",
  },
  {
    value: "INTRACEREBROVENTRICULAR USE",
    label: "INTRACEREBROVENTRICULAR USE",
  },
  {
    value: "INTRACERVICAL USE",
    label: "INTRACERVICAL USE",
  },
  {
    value: "INTRACHOLANGIOPANCREATIC USE",
    label: "INTRACHOLANGIOPANCREATIC USE",
  },
  {
    value: "INTRACISTERNAL USE",
    label: "INTRACISTERNAL USE",
  },
  {
    value: "INTRACORNEAL USE",
    label: "INTRACORNEAL USE",
  },
  {
    value: "INTRACORONARY USE",
    label: "INTRACORONARY USE",
  },
  {
    value: "INTRADERMAL",
    label: "INTRADERMAL",
  },
  {
    value: "INTRADERMAL USE",
    label: "INTRADERMAL USE",
  },
  {
    value: "INTRADISCAL USE",
    label: "INTRADISCAL USE",
  },
  {
    value: "INTRADUODENAL USE",
    label: "INTRADUODENAL USE",
  },
  {
    value: "INTRAEPIDERMAL USE",
    label: "INTRAEPIDERMAL USE",
  },
  {
    value: "INTRAGLANDULAR USE",
    label: "INTRAGLANDULAR USE",
  },
  {
    value: "INTRALESIONAL USE",
    label: "INTRALESIONAL USE",
  },
  {
    value: "INTRALYMPHATIC USE",
    label: "INTRALYMPHATIC USE",
  },
  {
    value: "INTRAMENINGEAL USE",
    label: "INTRAMENINGEAL USE",
  },
  {
    value: "INTRAMUSCULAR",
    label: "INTRAMUSCULAR",
  },
  {
    value: "INTRAMUSCULAR AND INTRAVENOUS",
    label: "INTRAMUSCULAR AND INTRAVENOUS",
  },
  {
    value: "INTRAMUSCULAR INJECTION",
    label: "INTRAMUSCULAR INJECTION",
  },
  {
    value: "INTRAMUSCULAR OR INTRAVENOUS",
    label: "INTRAMUSCULAR OR INTRAVENOUS",
  },
  {
    value: "INTRAMUSCULAR OR SUBCUTANEOUS",
    label: "INTRAMUSCULAR OR SUBCUTANEOUS",
  },
  {
    value: "INTRAMUSCULAR USE",
    label: "INTRAMUSCULAR USE",
  },
  {
    value: "INTRAMYOCARDIAL INJECTION",
    label: "INTRAMYOCARDIAL INJECTION",
  },
  {
    value: "INTRANASAL USE",
    label: "INTRANASAL USE",
  },
  {
    value: "INTRAOCULAR USE",
    label: "INTRAOCULAR USE",
  },
  {
    value: "INTRAOCULAR USE(SUBRETINAL ADMINISTRATION)",
    label: "INTRAOCULAR USE(SUBRETINAL ADMINISTRATION)",
  },
  {
    value: "INTRAOSSEOUS USE",
    label: "INTRAOSSEOUS USE",
  },
  {
    value: "INTRAPARENCHYMAL USE",
    label: "INTRAPARENCHYMAL USE",
  },
  {
    value: "INTRAPERICARDIAL USE",
    label: "INTRAPERICARDIAL USE",
  },
  {
    value: "INTRAPERITONEAL USE",
    label: "INTRAPERITONEAL USE",
  },
  {
    value: "INTRAPLEURAL USE",
    label: "INTRAPLEURAL USE",
  },
  {
    value: "INTRAPORTAL",
    label: "INTRAPORTAL",
  },
  {
    value: "INTRAPORTAL INFUSION",
    label: "INTRAPORTAL INFUSION",
  },
  {
    value: "INTRAPORTAL USE",
    label: "INTRAPORTAL USE",
  },
  {
    value: "INTRAPROSTATIC USE",
    label: "INTRAPROSTATIC USE",
  },
  {
    value: "INTRAPUTAMINAL USE",
    label: "INTRAPUTAMINAL USE",
  },
  {
    value: "INTRASTERNAL USE",
    label: "INTRASTERNAL USE",
  },
  {
    value: "INTRATENDINOUS USE",
    label: "INTRATENDINOUS USE",
  },
  {
    value: "INTRATHECAL",
    label: "INTRATHECAL",
  },
  {
    value: "INTRATHECAL USE",
    label: "INTRATHECAL USE",
  },
  {
    value: "INTRATHORACIC USE",
    label: "INTRATHORACIC USE",
  },
  {
    value: "INTRATRACHEAL USE",
    label: "INTRATRACHEAL USE",
  },
  {
    value: "INTRATUMORAL USE",
    label: "INTRATUMORAL USE",
  },
  {
    value: "INTRATYMPANIC",
    label: "INTRATYMPANIC",
  },
  {
    value: "INTRAUTERINE USE",
    label: "INTRAUTERINE USE",
  },
  {
    value: "INTRAVASCULAR USE",
    label: "INTRAVASCULAR USE",
  },
  {
    value: "INTRAVENIOUS INFUSION",
    label: "INTRAVENIOUS INFUSION",
  },
  {
    value: "INTRAVENOUS",
    label: "INTRAVENOUS",
  },
  {
    value: "INTRAVENOUS (IV) OR SUBCUTANEOUS (SC)",
    label: "INTRAVENOUS (IV) OR SUBCUTANEOUS (SC)",
  },
  {
    value: "INTRAVENOUS ADMINISTRATION",
    label: "INTRAVENOUS ADMINISTRATION",
  },
  {
    value: "INTRAVENOUS BOLUS INJECTION/IV INFUSION",
    label: "INTRAVENOUS BOLUS INJECTION/IV INFUSION",
  },
  {
    value: "INTRAVENOUS BOLUS USE",
    label: "INTRAVENOUS BOLUS USE",
  },
  {
    value: "INTRAVENOUS DRIP",
    label: "INTRAVENOUS DRIP",
  },
  {
    value: "INTRAVENOUS DRIP USE",
    label: "INTRAVENOUS DRIP USE",
  },
  {
    value: "INTRAVENOUS DRIP USE (NONCURRENT)",
    label: "INTRAVENOUS DRIP USE (NONCURRENT)",
  },
  {
    value: "INTRAVENOUS INFUSION",
    label: "INTRAVENOUS INFUSION",
  },
  {
    value: "INTRAVENOUS INFUSION OR INTRAMUSCULAR INJECTION",
    label: "INTRAVENOUS INFUSION OR INTRAMUSCULAR INJECTION",
  },
  {
    value: "INTRAVENOUS INJECTION",
    label: "INTRAVENOUS INJECTION",
  },
  {
    value: "INTRAVENOUS INJECTION/INFUSION, INTRAMUSCULAR INJECTION",
    label: "INTRAVENOUS INJECTION/INFUSION, INTRAMUSCULAR INJECTION",
  },
  {
    value: "INTRAVENOUS PERFUSION USE",
    label: "INTRAVENOUS PERFUSION USE",
  },
  {
    value: "INTRAVENOUS SLOW BOLUS INJECTION",
    label: "INTRAVENOUS SLOW BOLUS INJECTION",
  },
  {
    value: "INTRAVENOUS USE",
    label: "INTRAVENOUS USE",
  },
  {
    value: "INTRAVENOUS USE AND ORAL USE",
    label: "INTRAVENOUS USE AND ORAL USE",
  },
  {
    value: "INTRAVENOUS, INTRA-ARTERIAL, INTRATHECAL USE",
    label: "INTRAVENOUS, INTRA-ARTERIAL, INTRATHECAL USE",
  },
  {
    value: "INTRAVENOUS/SUBCUTANEOUS/INTRAMUSCULAR",
    label: "INTRAVENOUS/SUBCUTANEOUS/INTRAMUSCULAR",
  },
  {
    value: "INTRAVENOUS/SUBCUTANEOUS/INTRAMUSCULAR AND ORAL",
    label: "INTRAVENOUS/SUBCUTANEOUS/INTRAMUSCULAR AND ORAL",
  },
  {
    value: "INTRAVENOUSLY / INTRAMUSCULARLY",
    label: "INTRAVENOUSLY / INTRAMUSCULARLY",
  },
  {
    value: "INTRAVENTRICULAR USE",
    label: "INTRAVENTRICULAR USE",
  },
  {
    value: "INTRAVESICAL USE",
    label: "INTRAVESICAL USE",
  },
  {
    value: "INTRAVITREAL USE",
    label: "INTRAVITREAL USE",
  },
  {
    value: "INTUBATION SURFACTANT EXTUBATION (INSURE)",
    label: "INTUBATION SURFACTANT EXTUBATION (INSURE)",
  },
  {
    value: "IONTOPHORESIS",
    label: "IONTOPHORESIS",
  },
  {
    value: "IRRIGATION",
    label: "IRRIGATION",
  },
  {
    value: "IV INFUSION",
    label: "IV INFUSION",
  },
  {
    value: "IV INJECTION, IV INFUSION",
    label: "IV INJECTION, IV INFUSION",
  },
  {
    value: "LARYNGOPHARYNGEAL USE",
    label: "LARYNGOPHARYNGEAL USE",
  },
  {
    value: "LESS INVASIVE SURFACTANT ADMINISTRATION (LISA)",
    label: "LESS INVASIVE SURFACTANT ADMINISTRATION (LISA)",
  },
  {
    value: "LOCAL INJECTION",
    label: "LOCAL INJECTION",
  },
  {
    value: "LOCAL USE",
    label: "LOCAL USE",
  },
  {
    value: "NANOSUSPENSION INJECTION",
    label: "NANOSUSPENSION INJECTION",
  },
  {
    value: "NASAL SPRAY",
    label: "NASAL SPRAY",
  },
  {
    value: "NASAL USE",
    label: "NASAL USE",
  },
  {
    value: "NEW",
    label: "NEW",
  },
  {
    value: "OCCLUSIVE DRESSING TECHNIQUE USE",
    label: "OCCLUSIVE DRESSING TECHNIQUE USE",
  },
  {
    value: "OCULAR USE",
    label: "OCULAR USE",
  },
  {
    value: "OPHTHALMIC",
    label: "OPHTHALMIC",
  },
  {
    value: "OPHTHALMIC USE",
    label: "OPHTHALMIC USE",
  },
  {
    value: "ORAL",
    label: "ORAL",
  },
  {
    value: "ORAL AND IV",
    label: "ORAL AND IV",
  },
  {
    value: "ORAL USE",
    label: "ORAL USE",
  },
  {
    value: "ORAL, NASOGASTRIC TUBE OR PERCUTANEOUS ENDOSCOPIC GASTROSTOMY TUBE USE",
    label: "ORAL, NASOGASTRIC TUBE OR PERCUTANEOUS ENDOSCOPIC GASTROSTOMY TUBE USE",
  },
  {
    value: "OROMUCOSAL",
    label: "OROMUCOSAL",
  },
  {
    value: "OROMUCOSAL USE",
    label: "OROMUCOSAL USE",
  },
  {
    value: "OROPHARYNGEAL USE",
    label: "OROPHARYNGEAL USE",
  },
  {
    value: "OTHER USE",
    label: "OTHER USE",
  },
  {
    value: "PARAVERTEBRAL USE",
    label: "PARAVERTEBRAL USE",
  },
  {
    value: "PARENTERAL",
    label: "PARENTERAL",
  },
  {
    value: "PARENTERAL USE",
    label: "PARENTERAL USE",
  },
  {
    value: "PARTICLE MEDIATED EPIDERMAL DELIVERY",
    label: "PARTICLE MEDIATED EPIDERMAL DELIVERY",
  },
  {
    value: "PERCUTANEOUS USE",
    label: "PERCUTANEOUS USE",
  },
  {
    value: "PERIARTICULAR USE",
    label: "PERIARTICULAR USE",
  },
  {
    value: "PERINEURAL USE",
    label: "PERINEURAL USE",
  },
  {
    value: "PERIODONTAL USE",
    label: "PERIODONTAL USE",
  },
  {
    value: "PERIOSSEOUS USE",
    label: "PERIOSSEOUS USE",
  },
  {
    value: "PERITUMORAL USE",
    label: "PERITUMORAL USE",
  },
  {
    value: "PERIVASCULAR",
    label: "PERIVASCULAR",
  },
  {
    value: "POSTERIOR JUXTASCLERAL USE",
    label: "POSTERIOR JUXTASCLERAL USE",
  },
  {
    value: "PRESERVATIVE SOLUTION",
    label: "PRESERVATIVE SOLUTION",
  },
  {
    value: "RECTAL USE",
    label: "RECTAL USE",
  },
  {
    value: "RESPIRATORY USE",
    label: "RESPIRATORY USE",
  },
  {
    value: "RETROBULBAR USE",
    label: "RETROBULBAR USE",
  },
  {
    value: "ROUTE OF ADMINISTRATION NOT APPLICABLE",
    label: "ROUTE OF ADMINISTRATION NOT APPLICABLE",
  },
  {
    value: "SKIN SCARIFICATION",
    label: "SKIN SCARIFICATION",
  },
  {
    value: "SLOW INTRAVENOUS USE",
    label: "SLOW INTRAVENOUS USE",
  },
  {
    value: "SOFT TISSUE USE",
    label: "SOFT TISSUE USE",
  },
  {
    value: "SOLUTION FOR INFUSION",
    label: "SOLUTION FOR INFUSION",
  },
  {
    value: "SOLUTION FOR INJECTION",
    label: "SOLUTION FOR INJECTION",
  },
  {
    value: "SOLUTION FOR INJECTION IN PRE-FILLED SYRINGE",
    label: "SOLUTION FOR INJECTION IN PRE-FILLED SYRINGE",
  },
  {
    value: "SOLUTION FOR INJECTION OR INFUSION",
    label: "SOLUTION FOR INJECTION OR INFUSION",
  },
  {
    value: "SPC",
    label: "SPC",
  },
  {
    value: "SUB RETINAL",
    label: "SUB RETINAL",
  },
  {
    value: "SUBCONJUNCTIVAL USE",
    label: "SUBCONJUNCTIVAL USE",
  },
  {
    value: "SUBCUTANEOUS",
    label: "SUBCUTANEOUS",
  },
  {
    value: "SUBCUTANEOUS AND INTRAVENOUS USE",
    label: "SUBCUTANEOUS AND INTRAVENOUS USE",
  },
  {
    value: "SUBCUTANEOUS INJECTION",
    label: "SUBCUTANEOUS INJECTION",
  },
  {
    value: "SUBCUTANEOUS OR INTRAVENOUS",
    label: "SUBCUTANEOUS OR INTRAVENOUS",
  },
  {
    value: "SUBCUTANEOUS USE",
    label: "SUBCUTANEOUS USE",
  },
  {
    value: "SUBCUTANEOUSLY, INTRAMUSCULARLY OR INTRAVENOUSLY",
    label: "SUBCUTANEOUSLY, INTRAMUSCULARLY OR INTRAVENOUSLY",
  },
  {
    value: "SUBDERMAL USE",
    label: "SUBDERMAL USE",
  },
  {
    value: "SUBLINGUAL USE",
    label: "SUBLINGUAL USE",
  },
  {
    value: "SUBMUCOSAL USE",
    label: "SUBMUCOSAL USE",
  },
  {
    value: "SUBRETINAL USE",
    label: "SUBRETINAL USE",
  },
  {
    value: "TOPICAL",
    label: "TOPICAL",
  },
  {
    value: "TOPICAL ADMINISTRATION",
    label: "TOPICAL ADMINISTRATION",
  },
  {
    value: "TOPICAL APPLICATION",
    label: "TOPICAL APPLICATION",
  },
  {
    value: "TOPICAL APPLICATION ON CORNEAL AND LIMBAL AREA OF THE EYE",
    label: "TOPICAL APPLICATION ON CORNEAL AND LIMBAL AREA OF THE EYE",
  },
  {
    value: "TOPICAL APPLICATION ON WOUND",
    label: "TOPICAL APPLICATION ON WOUND",
  },
  {
    value: "TOPICAL USE",
    label: "TOPICAL USE",
  },
  {
    value: "TRANSDERMAL USE",
    label: "TRANSDERMAL USE",
  },
  {
    value: "TRANSPLACENTAL USE",
    label: "TRANSPLACENTAL USE",
  },
  {
    value: "TRANSTYMPANIC INJECTION",
    label: "TRANSTYMPANIC INJECTION",
  },
  {
    value: "UNKNOWN USE",
    label: "UNKNOWN USE",
  },
  {
    value: "URETHRAL",
    label: "URETHRAL",
  },
  {
    value: "URETHRAL USE",
    label: "URETHRAL USE",
  },
  {
    value: "VAGINAL USE",
    label: "VAGINAL USE",
  },
  {
    value: "VOIE BUCCALE",
    label: "VOIE BUCCALE",
  },
  {
    value: "ΕΝΔΟΑΡΘΡΙΚΗ ΧΡΗΣΗ",
    label: "ΕΝΔΟΑΡΘΡΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΕΝΔΟΒΛΑΒΙΚΗ ΧΡΗΣΗ",
    label: "ΕΝΔΟΒΛΑΒΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΕΝΔΟΘΥΛΑΚΙΚΗ ΧΡΗΣΗ",
    label: "ΕΝΔΟΘΥΛΑΚΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΕΝΔΟΜΥΙΚΗ ΧΡΗΣΗ",
    label: "ΕΝΔΟΜΥΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΟΡΘΙΚΗ ΧΡΗΣΗ",
    label: "ΟΡΘΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΠΑΡΕΝΤΕΡΙΚΗ ΧΡΗΣΗ",
    label: "ΠΑΡΕΝΤΕΡΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΡΙΝΙΚΗ ΧΡΗΣΗ",
    label: "ΡΙΝΙΚΗ ΧΡΗΣΗ",
  },
  {
    value: "ΧΡΗΣΗ ΑΠΟ ΤΟ ΑΝΑΠΝΕΥΣΤΙΚΟ",
    label: "ΧΡΗΣΗ ΑΠΟ ΤΟ ΑΝΑΠΝΕΥΣΤΙΚΟ",
  },
]

export const CTIS_UNIT_MEASURE = [
  {
    value: "Kg kilogram(s)",
    label: "Kg kilogram(s)",
  },
  {
    value: "g gram(s)",
    label: "g gram(s)",
  },
  {
    value: "mg milligram(s)",
    label: "mg milligram(s)",
  },
  {
    value: "µg microgram(s)",
    label: "µg microgram(s)",
  },
  {
    value: "ng nanogram(s)",
    label: "ng nanogram(s)",
  },
  {
    value: "pg picogram(s)",
    label: "pg picogram(s)",
  },
  {
    value: "mg/Kg milligram(s)/kilogram",
    label: "mg/Kg milligram(s)/kilogram",
  },
  {
    value: "µg/Kg microgram(s)/kilogram",
    label: "µg/Kg microgram(s)/kilogram",
  },
  {
    value: "mg/m2 milligram(s)/sq. meter",
    label: "mg/m2 milligram(s)/sq. meter",
  },
  {
    value: "µg/ m2 microgram(s)/ sq. Meter",
    label: "µg/ m2 microgram(s)/ sq. Meter",
  },
  {
    value: "l litre(s)",
    label: "l litre(s)",
  },
  {
    value: "ml millilitre(s)",
    label: "ml millilitre(s)",
  },
  {
    value: "µl microlitre(s)",
    label: "µl microlitre(s)",
  },
  {
    value: "Bq becquerel(s)",
    label: "Bq becquerel(s)",
  },
  {
    value: "GBq gigabecquerel(s)",
    label: "GBq gigabecquerel(s)",
  },
  {
    value: "MBq megabecquerel(s)",
    label: "MBq megabecquerel(s)",
  },
  {
    value: "Kbq kilobecquerel(s)",
    label: "Kbq kilobecquerel(s)",
  },
  {
    value: "Ci curie(s)",
    label: "Ci curie(s)",
  },
  {
    value: "mCi millicurie(s)",
    label: "mCi millicurie(s)",
  },
  {
    value: "µCi microcurie(s)",
    label: "µCi microcurie(s)",
  },
  {
    value: "NCi nanocurie(s)",
    label: "NCi nanocurie(s)",
  },
  {
    value: "Mol mole(s)",
    label: "Mol mole(s)",
  },
  {
    value: "Mmol millimole(s)",
    label: "Mmol millimole(s)",
  },
  {
    value: "µmol micromole(s)",
    label: "µmol micromole(s)",
  },
  {
    value: "IU international unit(s)",
    label: "IU international unit(s)",
  },
  {
    value: "Kiu iu(1000s)",
    label: "Kiu iu(1000s)",
  },
  {
    value: "Miu iu(1,000,000s)",
    label: "Miu iu(1,000,000s)",
  },
  {
    value: "IU/Kg iu/kilogram",
    label: "IU/Kg iu/kilogram",
  },
  {
    value: "Meq milliequivalent(s)",
    label: "Meq milliequivalent(s)",
  },
  {
    value: "% percent",
    label: "% percent",
  },
  {
    value: "Gtt drop(s)",
    label: "Gtt drop(s)",
  },
  {
    value: "DF dosage form",
    label: "DF dosage form",
  },
]

export const TRIAL_SCOPE_CTIS = [
  {
    value: "Diagnosis",
    label: "Diagnosis",
  },
  {
    value: "Prophylaxis",
    label: "Prophylaxis",
  },
  {
    value: "Therapy",
    label: "Therapy",
  },
  {
    value: "Safety",
    label: "Safety",
  },
  {
    value: "Efficacy",
    label: "Efficacy",
  },
  {
    value: "Pharmacokinetic",
    label: "Pharmacokinetic",
  },
  {
    value: "Pharmacodynamic",
    label: "Pharmacodynamic",
  },
  {
    value: "Bioequivalence",
    label: "Bioequivalence",
  },
  {
    value: "Dose response",
    label: "Dose response",
  },
  {
    value: "Pharmacogenetic",
    label: "Pharmacogenetic",
  },
  {
    value: "Pharmacogenomic",
    label: "Pharmacogenomic",
  },
  {
    value: "Pharmacoeconomic",
    label: "Pharmacoeconomic",
  },
  {
    value: "Other",
    label: "Other",
  },
]

export const TRIAL_PHASE_CTIS = [
  {
    value: "Human Pharmacology (Phase I)- First administration to humans",
    label: "Human Pharmacology (Phase I)- First administration to humans",
  },
  {
    value: "Human Pharmacology (Phase I)- Bioequivalence Study",
    label: "Human Pharmacology (Phase I)- Bioequivalence Study",
  },
  {
    value: "Human Pharmacology (Phase I)- Other",
    label: "Human Pharmacology (Phase I)- Other",
  },
  {
    value: "Therapeutic exploratory (Phase II)",
    label: "Therapeutic exploratory (Phase II)",
  },
  {
    value: "Therapeutic confirmatory (Phase III)",
    label: "Therapeutic confirmatory (Phase III)",
  },
  {
    value: "Therapeutic use (Phase IV)",
    label: "Therapeutic use (Phase IV)",
  },
  {
    value: "Phase I and Phase II (Integrated)- First administration to humans",
    label: "Phase I and Phase II (Integrated)- First administration to humans",
  },
  {
    value: "Phase I and Phase II (Integrated)- Bioequivalence Study",
    label: "Phase I and Phase II (Integrated)- Bioequivalence Study",
  },
  {
    value: "Phase I and Phase II (Integrated)- Other",
    label: "Phase I and Phase II (Integrated)- Other",
  },
  {
    value: "Phase II and Phase III (Integrated)",
    label: "Phase II and Phase III (Integrated)",
  },
  {
    value: "Phase III and Phase IV (Integrated)",
    label: "Phase III and Phase IV (Integrated)",
  },
]

export const CTIS_DUTIES = [
  {
    value: "On site monitoring",
    label: "On site monitoring",
  },
  {
    value: "Investigator recruitment",
    label: "Investigator recruitment",
  },
  {
    value: "Interactive response technologies (IRT)",
    label: "Interactive response technologies (IRT)",
  },
  {
    value: "Laboratory analysis",
    label: "Laboratory analysis",
  },
  {
    value: "Project management",
    label: "Project management",
  },
  {
    value: "Data management",
    label: "Data management",
  },
  {
    value: "E-data capture",
    label: "E-data capture",
  },
  {
    value: "Safety reporting",
    label: "Safety reporting",
  },
  {
    value: "Q/A auditing",
    label: "Q/A auditing",
  },
  {
    value: "Statistical analysis",
    label: "Statistical analysis",
  },
  {
    value: "Medical writing",
    label: "Medical writing",
  },
  {
    value: "Regulatory expertise",
    label: "Regulatory expertise",
  },
  {
    value: "Medical expertise",
    label: "Medical expertise",
  },
  {
    value: "Medicinal product management",
    label: "Medicinal product management",
  },
  {
    value: "Other",
    label: "Other",
  },
]

export const AGE_RANGE_CTIS = [
  {
    value: "In Utero",
    label: "In Utero",
  },
  {
    value: "0-17 years",
    label: "0-17 years",
  },
  {
    value: "18-64 years",
    label: "18-64 years",
  },
  {
    value: "65+ years",
    label: "65+ years",
  },
]

export const AGE_RANGE_SECONDARY_IDS_CTIS = [
  {
    value: "Preterm newborn infants (up to gestational age < 37 weeks)",
    label: "Preterm newborn infants (up to gestational age < 37 weeks)",
  },
  {
    value: "0-27 days",
    label: "0-27 days",
  },
  {
    value: "28 days - 23 months",
    label: "28 days - 23 months",
  },
  {
    value: "2-5 years",
    label: "2-5 years",
  },
  {
    value: "6-11 years",
    label: "6-11 years",
  },
  {
    value: "12-17 years",
    label: "12-17 years",
  },
  {
    value: "18-64 years",
    label: "18-64 years",
  },
  {
    value: "65-84 years",
    label: "65-84 years",
  },
  {
    value: "85+ years",
    label: "85+ years",
  },
]

export const CLINICAL_TRIAL_GROUPS_CTIS = [
  {
    value: "Healthy volunteers",
    label: "Healthy volunteers",
  },
  {
    value: "Patients",
    label: "Patients",
  },
]

// TODO: review phaseShortcutMap above
export const STUDY_PHASES = [
  {
    value: "Early Phase 1 (or Phase 0)",
    label: "Early Phase 1 (or Phase 0)",
    translations: {
      jp: "0",
    },
    registries: {
      jrct: "0",
    },
    hideInRegistries: ["eupas"],
  },
  {
    value: "Phase 1",
    label: "Phase 1",
    translations: {
      jp: "1",
    },
    registries: {
      jrct: "1",
      eupas: "Human pharmacology (Phase I)",
    },
  },
  {
    value: "Phase 1/Phase 2",
    label: "Phase 1/Phase 2",
    translations: {
      jp: "1/2",
    },
    registries: {
      jrct: "1/2",
    },
    hideInRegistries: ["eupas"],
  },
  {
    value: "Phase 2",
    label: "Phase 2",
    translations: {
      jp: "2",
    },
    registries: {
      jrct: "2",
      eupas: "Therapeutic exploratory (Phase II)",
    },
  },
  {
    value: "Phase 2/Phase 3",
    label: "Phase 2/Phase 3",
    translations: {
      jp: "2/3",
    },
    registries: {
      jrct: "2/3",
    },
    hideInRegistries: ["eupas"],
  },
  {
    value: "Phase 3",
    label: "Phase 3",
    translations: {
      jp: "3",
    },
    registries: {
      jrct: "3",
      eupas: "Therapeutic confirmatory (Phase III)",
    },
  },
  {
    value: "Phase 4",
    label: "Phase 4",
    translations: {
      jp: "4",
    },
    registries: {
      jrct: "4",
      eupas: "Therapeutic use (Phase IV)",
    },
  },
  {
    value: "N/A",
    label: "N/A",
    translations: {
      jp: "N/A",
    },
    registries: {
      eupas: "None",
    },
  },
]

export const AGE_TYPES = [
  {
    value: "--Select--",
    label: "--Select--",
    translations: {
      jp: "--Select--",
    },
  },
  {
    value: "Years",
    label: "Years",
    translations: {
      jp: "Years",
    },
  },
  {
    value: "Months",
    label: "Months",
    translations: {
      jp: "Months",
    },
  },
  {
    value: "Weeks",
    label: "Weeks",
    translations: {
      jp: "Weeks",
    },
  },
  {
    value: "Days",
    label: "Days",
    translations: {
      jp: "Days",
    },
  },
  {
    value: "Hours",
    label: "Hours",
    translations: {
      jp: "Hours",
    },
  },
  {
    value: "Minutes",
    label: "Minutes",
    translations: {
      jp: "Minutes",
    },
  },
  {
    value: "N/A(No limit)",
    label: "N/A(No limit)",
    translations: {
      jp: "N/A(No limit)",
    },
  },
]

export const JRCT_PREFECTURES_OPTIONS = [
  {
    value: "Hokkaido",
    label: "Hokkaido",
    translations: {
      jp: "北海道",
    },
  },
  {
    value: "Aomori",
    label: "Aomori",
    translations: {
      jp: "青森県",
    },
  },
  {
    value: "Iwate",
    label: "Iwate",
    translations: {
      jp: "岩手県",
    },
  },
  {
    value: "Miyagi",
    label: "Miyagi",
    translations: {
      jp: "宮城県",
    },
  },
  {
    value: "Akita",
    label: "Akita",
    translations: {
      jp: "秋田県",
    },
  },
  {
    value: "Yamagata",
    label: "Yamagata",
    translations: {
      jp: "山形県",
    },
  },
  {
    value: "Fukushima",
    label: "Fukushima",
    translations: {
      jp: "福島県",
    },
  },
  {
    value: "Ibaraki",
    label: "Ibaraki",
    translations: {
      jp: "茨城県",
    },
  },
  {
    value: "Tochigi",
    label: "Tochigi",
    translations: {
      jp: "栃木県",
    },
  },
  {
    value: "Gunma",
    label: "Gunma",
    translations: {
      jp: "群馬県",
    },
  },
  {
    value: "Saitama",
    label: "Saitama",
    translations: {
      jp: "埼玉県",
    },
  },
  {
    value: "Chiba",
    label: "Chiba",
    translations: {
      jp: "千葉県",
    },
  },
  {
    value: "Tokyo",
    label: "Tokyo",
    translations: {
      jp: "東京都",
    },
  },
  {
    value: "Kanagawa",
    label: "Kanagawa",
    translations: {
      jp: "神奈川県",
    },
  },
  {
    value: "Niigata",
    label: "Niigata",
    translations: {
      jp: "新潟県",
    },
  },
  {
    value: "Toyama",
    label: "Toyama",
    translations: {
      jp: "富山県",
    },
  },
  {
    value: "Ishikawa",
    label: "Ishikawa",
    translations: {
      jp: "石川県",
    },
  },
  {
    value: "Fukui",
    label: "Fukui",
    translations: {
      jp: "福井県",
    },
  },
  {
    value: "Yamanashi",
    label: "Yamanashi",
    translations: {
      jp: "山梨県",
    },
  },
  {
    value: "Nagano",
    label: "Nagano",
    translations: {
      jp: "長野県",
    },
  },
  {
    value: "Gifu",
    label: "Gifu",
    translations: {
      jp: "岐阜県",
    },
  },
  {
    value: "Shizuoka",
    label: "Shizuoka",
    translations: {
      jp: "静岡県",
    },
  },
  {
    value: "Aichi",
    label: "Aichi",
    translations: {
      jp: "愛知県",
    },
  },
  {
    value: "Mie",
    label: "Mie",
    translations: {
      jp: "三重県",
    },
  },
  {
    value: "Shiga",
    label: "Shiga",
    translations: {
      jp: "滋賀県",
    },
  },
  {
    value: "Kyoto",
    label: "Kyoto",
    translations: {
      jp: "京都府",
    },
  },
  {
    value: "Osaka",
    label: "Osaka",
    translations: {
      jp: "大阪府",
    },
  },
  {
    value: "Hyogo",
    label: "Hyogo",
    translations: {
      jp: "兵庫県",
    },
  },
  {
    value: "Nara",
    label: "Nara",
    translations: {
      jp: "奈良県",
    },
  },
  {
    value: "Wakayama",
    label: "Wakayama",
    translations: {
      jp: "和歌山県",
    },
  },
  {
    value: "Tottori",
    label: "Tottori",
    translations: {
      jp: "鳥取県",
    },
  },
  {
    value: "Shimane",
    label: "Shimane",
    translations: {
      jp: "島根県",
    },
  },
  {
    value: "Okayama",
    label: "Okayama",
    translations: {
      jp: "岡山県",
    },
  },
  {
    value: "Hiroshima",
    label: "Hiroshima",
    translations: {
      jp: "広島県",
    },
  },
  {
    value: "Yamaguchi",
    label: "Yamaguchi",
    translations: {
      jp: "山口県",
    },
  },
  {
    value: "Tokushima",
    label: "Tokushima",
    translations: {
      jp: "徳島県",
    },
  },
  {
    value: "Kagawa",
    label: "Kagawa",
    translations: {
      jp: "香川県",
    },
  },
  {
    value: "Ehime",
    label: "Ehime",
    translations: {
      jp: "愛媛県",
    },
  },
  {
    value: "Kochi",
    label: "Kochi",
    translations: {
      jp: "高知県",
    },
  },
  {
    value: "Fukuoka",
    label: "Fukuoka",
    translations: {
      jp: "福岡県",
    },
  },
  {
    value: "Saga",
    label: "Saga",
    translations: {
      jp: "佐賀県",
    },
  },
  {
    value: "Nagasaki",
    label: "Nagasaki",
    translations: {
      jp: "長崎県",
    },
  },
  {
    value: "Kumamoto",
    label: "Kumamoto",
    translations: {
      jp: "熊本県",
    },
  },
  {
    value: "Oita",
    label: "Oita",
    translations: {
      jp: "大分県",
    },
  },
  {
    value: "Miyazaki",
    label: "Miyazaki",
    translations: {
      jp: "宮崎県",
    },
  },
  {
    value: "Kagoshima",
    label: "Kagoshima",
    translations: {
      jp: "鹿児島県",
    },
  },
  {
    value: "Okinawa",
    label: "Okinawa",
    translations: {
      jp: "沖縄県",
    },
  },
  {
    value: "Other",
    label: "Other",
    translations: {
      jp: "その他",
    },
  },
]

export const RECRUITMENT_STATUS_OPTIONS = [
  {
    value: "--Select--",
    label: "--Select--",
  },
  {
    value: "Active, not recruiting",
    label: "Active, not recruiting",
    translations: {
      jp: "募集終了",
    },
    registries: {
      jrct: "Not Recruiting",
    },
  },
  {
    value: "Completed",
    label: "Completed",
    translations: {
      jp: "研究終了",
    },
    registries: {
      jrct: "Complete",
    },
  },
  {
    value: "Enrolling by invitation",
    label: "Enrolling by invitation",
    translations: {
      jp: "募集中",
    },
    registries: {
      jrct: "Recruiting",
    },
    hideInRegistries: ["jrct"],
  },
  {
    value: "Not yet recruiting",
    label: "Not yet recruiting",
    translations: {
      jp: "募集前",
    },
    registries: {
      jrct: "Pre-recruitment/Pending",
    },
  },
  {
    value: "Recruiting",
    label: "Recruiting",
    translations: {
      jp: "募集中",
    },
  },
  {
    value: "Suspended",
    label: "Suspended",
    translations: {
      jp: "募集中断",
    },
  },
  {
    value: "Terminated (Halted Prematurely)",
    label: "Terminated (Halted Prematurely)",
    translations: {
      jp: "研究終了",
    },
    registries: {
      jrct: "Complete",
    },
    hideInRegistries: ["jrct"],
  },
  {
    value: "Withdrawn (No Participants Enrolled)",
    label: "Withdrawn (No Participants Enrolled)",
    translations: {
      jp: "募集中断",
    },
    registries: {
      jrct: "Suspended",
    },
    hideInRegistries: ["jrct"],
  },
]

export const ALLOCATION = [
  {
    value: "N/A",
    label: "N/A",
    translations: {
      jp: "単一群",
    },
    registries: {
      jrct: "Single arm study",
      eupas: "None",
    },
  },
  {
    value: "Randomized",
    label: "Randomized",
    translations: {
      jp: "無作為化比較",
    },
    registries: {
      jrct: "Randomized controlled trial",
      eupas: "Randomised clinical trial",
    },
  },
  {
    value: "Non-randomized",
    label: "Non-randomized",
    translations: {
      jp: "非無作為化比較",
    },
    registries: {
      jrct: "Non-randomized controlled trial",
      eupas: "Non-randomised clinical trial",
    },
  },
]

export const INTERVENTIONAL_STUDY_MODEL = [
  {
    value: "Single Group",
    label: "Single Group",
    translations: {
      jp: "単群比較",
    },
    registries: {
      jrct: "Single assignment",
    },
  },
  {
    value: "Parallel",
    label: "Parallel",
    translations: {
      jp: "並行群間比較",
    },
    registries: {
      jrct: "Parallel assignment",
    },
  },
  {
    value: "Crossover",
    label: "Crossover",
    translations: {
      jp: "交差比較",
    },
    registries: {
      jrct: "Crossover assignment",
    },
  },
  {
    value: "Factorial",
    label: "Factorial",
    translations: {
      jp: "要因分析",
    },
    registries: {
      jrct: "Factorial assignment",
    },
  },
  {
    value: "Sequential",
    label: "Sequential",
    translations: {
      jp: "Unselected",
    },
    registries: {
      jrct: "Unselected",
    },
  },
]

export const OBSERVATIONAL_STUDY_MODEL = [
  {
    value: "Cohort",
    label: "Cohort",
  },
  {
    value: "Case-Control",
    label: "Case-Control",
    registries: {
      eupas: "Case-control",
    },
  },
  {
    value: "Case-Only",
    label: "Case-Only",
    registries: {
      eupas: "Case-only",
    },
  },
  {
    value: "Case-Crossover",
    label: "Case-Crossover",
    hideInRegistries: ["eupas"],
  },
  {
    value: "Ecologic or Community",
    label: "Ecologic or Community",
    registries: {
      eupas: "Ecological",
    },
  },
  {
    value: "Family-Based",
    label: "Family-Based",
    hideInRegistries: ["eupas"],
  },
  {
    value: "Cluster design",
    label: "Cluster design",
    hideInRegistries: ["ctg"],
  },
  {
    value: "Cross-sectional",
    label: "Cross-sectional",
    hideInRegistries: ["ctg"],
  },
  {
    value: "Systematic review and meta-analysis",
    label: "Systematic review and meta-analysis",
    hideInRegistries: ["ctg"],
  },
  {
    value: "Other",
    label: "Other",
  },
]

export const PRIMARY_PURPOSE = [
  {
    value: "Treatment",
    label: "Treatment",
    translations: {
      jp: "治療",
    },
  },
  {
    value: "Prevention",
    label: "Prevention",
    translations: {
      jp: "予防",
    },
  },
  {
    value: "Diagnostic",
    label: "Diagnostic",
    translations: {
      jp: "診断",
    },
  },
  {
    value: "Supportive Care",
    label: "Supportive Care",
    translations: {
      jp: "緩和",
    },
  },
  {
    value: "Screening",
    label: "Screening",
    translations: {
      jp: "スクリーニング",
    },
  },
  {
    value: "Health Services Research",
    label: "Health Services Research",
    translations: {
      jp: "ヘルスサービス",
    },
  },
  {
    value: "Basic Science",
    label: "Basic Science",
    translations: {
      jp: "基礎科学",
    },
  },
  {
    value: "Device Feasibility",
    label: "Device Feasibility",
    translations: {
      jp: "その他",
    },
    registries: {
      jrct: "Other",
    },
    hideInRegistries: ["jrct"],
  },
  {
    value: "Other",
    label: "Other",
    translations: {
      jp: "その他",
    },
    registries: {
      jrct: "Other",
    },
  },
]

export const GENDER = [
  {
    value: "Unselected",
    label: "Unselected",
    translations: {
      jp: "未設定",
    },
    registries: {
      jrct: "Not set",
    },
  },
  {
    value: "All",
    label: "All",
    translations: {
      jp: "男性・女性",
    },
    registries: {
      jrct: "Both",
    },
  },
  {
    value: "Male",
    label: "Male",
    translations: {
      jp: "男性",
    },
    registries: {
      jrct: "Male",
    },
  },
  {
    value: "Female",
    label: "Female",
    translations: {
      jp: "女性",
    },
    registries: {
      jrct: "Female",
    },
  },
]

export const NOT_SET_YES_NO = [
  {
    value: "Not set",
    label: "Not set",
    translations: {
      jp: "未設定",
    },
  },
  {
    value: "Yes",
    label: "Yes",
    translations: {
      jp: "あり",
    },
  },
  {
    value: "No",
    label: "No",
    translations: {
      jp: "なし",
    },
  },
]

export const NOT_SET_CAN_BE_NONE = [
  {
    value: "Not set",
    label: "Not set",
    translations: {
      jp: "未設定",
    },
  },
  {
    value: "Can be",
    label: "Can be",
    translations: {
      jp: "あり",
    },
  },
  {
    value: "None",
    label: "None",
    translations: {
      jp: "なし",
    },
  },
]

export const NOT_SET_APPLICABLE_NOT_APPLICABLE = [
  {
    value: "Not set",
    label: "Not set",
    translations: {
      jp: "未設定",
    },
  },
  {
    value: "Applicable",
    label: "Applicable",
    translations: {
      jp: "該当",
    },
  },
  {
    value: "Not applicable",
    label: "Not applicable",
    translations: {
      jp: "非該当",
    },
  },
]

export const NOT_SET_APPLICABLE_NOT_APPLICABLE_ALT = [
  {
    value: "Not set",
    label: "Not set",
    translations: {
      jp: "未設定",
    },
  },
  {
    value: "Applicable",
    label: "Applicable",
    translations: {
      jp: "該当する",
    },
  },
  {
    value: "Not applicable",
    label: "Not applicable",
    translations: {
      jp: "該当しない",
    },
  },
]

export const NOT_SET_APPROVED_NOT_APPROVED = [
  {
    value: "Not set",
    label: "Not set",
    translations: {
      jp: "未設定",
    },
  },
  {
    value: "Approved",
    label: "Approved",
    translations: {
      jp: "承認",
    },
  },
  {
    value: "Not yet approved",
    label: "Not yet approved",
    translations: {
      jp: "未承認",
    },
  },
]

export const DATE_TYPE = [
  {
    value: "Anticipated",
    label: "Anticipated",
    translations: {
      jp: "予定された",
    },
  },
  {
    value: "Actual",
    label: "Actual",
    translations: {
      jp: "実際の",
    },
  },
]

export const STATISTICAL_METHODS = [
  {
    value: "Unselected",
    label: "Unselected",
  },
  {
    value: "ANCOVA",
    label: "ANCOVA",
  },
  {
    value: "ANOVA",
    label: "ANOVA",
  },
  {
    value: "Chi-squared",
    label: "Chi-squared",
  },
  {
    value: "Chi-squared, Corrected",
    label: "Chi-squared, Corrected",
    registries: {
      eudra: "Chi-squared corrected",
      eudract: "Chi-squared corrected",
    },
  },
  {
    value: "Cochran-Mantel-Haenszel",
    label: "Cochran-Mantel-Haenszel",
  },
  {
    value: "Fisher-Exact",
    label: "Fisher-Exact",
    registries: {
      eudra: "Fisher exact",
      eudract: "Fisher exact",
    },
  },
  {
    value: "Kruskal-Wallis",
    label: "Kruskal-Wallis",
    registries: {
      eudra: "Kruskal-wallis",
      eudract: "Kruskal-wallis",
    },
  },
  {
    value: "Log Rank",
    label: "Log Rank",
    registries: {
      eudra: "Logrank",
      eudract: "Logrank",
    },
  },
  {
    value: "Mantel haenszel",
    label: "Mantel haenszel",
    registries: {
      eudra: "Mantel-Haenszel",
      eudract: "Mantel-Haenszel",
    },
  },
  {
    value: "McNemar",
    label: "McNemar",
    registries: {
      eudra: "Mcnemar",
      eudract: "Mcnemar",
    },
  },
  {
    value: "Mixed Models Analysis",
    label: "Mixed Models Analysis",
    registries: {
      eudra: "Mixed models analysis",
      eudract: "Mixed models analysis",
    },
  },
  {
    value: "Regression, Cox",
    label: "Regression, Cox",
  },
  {
    value: "Regression, Linear",
    label: "Regression, Linear",
  },
  {
    value: "Regression, Logistic",
    label: "Regression, Logistic",
  },
  {
    value: "Sign test",
    label: "Sign test",
  },
  {
    value: "t-test, 1 sided",
    label: "t-test, 1 sided",
    registries: {
      eudra: "t-test,1-sided",
      eudract: "t-test,1-sided",
    },
  },
  {
    value: "t-test, 2 sided",
    label: "t-test, 2 sided",
    registries: {
      eudra: "t-test,2-sided",
      eudract: "t-test,2-sided",
    },
  },
  {
    value: "Wilcoxon (Mann-Whitney)",
    label: "Wilcoxon (Mann-Whitney)",
  },
  {
    value: "Other",
    label: "Other",
    registries: {
      eudra: "Other (please specify)",
      eudract: "Other (please specify)",
    },
  },
]

export const ARM_TYPES = [
  {
    value: "Experimental",
    label: "Experimental",
  },
  {
    value: "Active Comparator",
    label: "Active Comparator",
    registries: {
      eudra: "Active comparator",
      eudract: "Active comparator",
    },
  },
  {
    value: "Placebo Comparator",
    label: "Placebo Comparator",
    registries: {
      eudra: "Placebo",
      eudract: "Placebo",
    },
  },
  {
    value: "Sham Comparator",
    label: "Sham Comparator",
    registries: {
      eudra: "Other",
      eudract: "Other",
    },
  },
  {
    value: "No Intervention",
    label: "No Intervention",
    registries: {
      eudra: "No intervention",
      eudract: "No intervention",
    },
  },
  {
    value: "Other",
    label: "Other",
  },
]

export const WITHDRAWN_REASONS = [
  {
    value: "Adverse Event",
    registries: {
      ctg: "Adverse Event",
      eudract: "Adverse Event, non-fatal",
    },
  },
  {
    value: "Death",
    registries: {
      ctg: "Death",
      eudract: "Adverse Event, serious fatal",
    },
  },
  {
    value: "Lack of Efficacy",
    registries: {
      ctg: "Lack of Efficacy",
      eudract: "Lack of Efficacy",
    },
  },
  {
    value: "Lost to Follow-up",
    registries: {
      ctg: "Lost to Follow Up",
      eudract: "Lost to Follow Up",
    },
  },
  {
    value: "Physician Decision",
    registries: {
      ctg: "Physician Decision",
      eudract: "Physician Decision",
    },
  },
  {
    value: "Pregnancy",
    registries: {
      ctg: "Pregnancy",
      eudract: "Pregnancy",
    },
  },
  {
    value: "Protocol Violation",
    registries: {
      ctg: "Protocol Violation",
      eudract: "Protocol Violation",
    },
  },
  {
    value: "Withdrawal by Subject",
    registries: {
      ctg: "Withdrawal by Subject",
      eudract: "Consent Withdrawn by Subject",
    },
  },
  {
    value: "Other",
    registries: {
      ctg: "Other",
      eudract: "Other",
    },
  },
  {
    value: "Transferred to other arm/group",
    registries: {
      ctg: null,
      global: "Transferred to other arm/group",
      eudract: "Transferred to other arm/group",
    },
  },
]

export const STUDY_TOPICS = [
  { value: "Disease/health condition", label: "Disease/health condition" },
  { value: "Herbal medicinal product", label: "Herbal medicinal product" },
  { value: "Human medicinal product", label: "Human medicinal product" },
  { value: "Medical device", label: "Medical device" },
  { value: "Medical procedure", label: "Medical procedure" },
  { value: "Other", label: "Other" },
  { value: "Veterinary medical product", label: "Veterinary medical product" },
]

export const CLINICAL_TRIAL_REGULATORY_SCOPES = [
  {
    value: "Clinical trial not subject to marketing authorisation",
    label: "Clinical trial not subject to marketing authorisation",
  },
  {
    value: "Post-authorisation interventional clinical trial",
    label: "Post-authorisation interventional clinical trial",
  },
  {
    value: "Post-authorisation low-interventional clinical trial",
    label: "Post-authorisation low-interventional clinical trial",
  },
  { value: "Pre-authorisation clinical trial", label: "Pre-authorisation clinical trial" },
]

export const CLINICAL_TRIAL_TYPES = [
  { value: "Cluster randomised trial", label: "Cluster randomised trial" },
  { value: "Large simple trial", label: "Large simple trial" },
  { value: "Low-interventional clinical trial", label: "Low-interventional clinical trial" },
  { value: "Pragmatic clinical trial", label: "Pragmatic clinical trial" },
  { value: "Single-arm trial", label: "Single-arm trial" },
]

export const DATA_COLLECTION_METHODS = [
  { value: "None", label: "None" },
  { value: "Combined primary and secondary data collection", label: "Combined primary and secondary data collection" },
  {
    value: "No individual level data collected for the purpose of the study",
    label: "No individual level data collected for the purpose of the study",
  },
  { value: "Primary data collection", label: "Primary data collection" },
  { value: "Secondary data collection", label: "Secondary data collection" },
]

export const YES_NO_UNKNOWN = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "Unknown",
    label: "Unknown",
  },
]

export const YES_NO_UNSELECTED = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "Unselected",
    label: "Unselected",
  },
]

export const YES_NO_UNKNOWN_NA = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "Unknown",
    label: "Unknown",
  },
  {
    value: "Not applicable",
    label: "Not applicable",
  },
]

export const NONE_YES_NO_NA = [
  { value: 1, label: "None" },
  { value: 2, label: "Yes" },
  { value: 3, label: "No" },
  { value: 4, label: "N/A" },
]

export const SOURCE_OF_FUNDING = [
  { value: 1, label: "EMA" },
  { value: 2, label: "EU institutional research programme" },
  { value: 3, label: "National competent authority (NCAs)" },
  { value: 4, label: "No external funding" },
  { value: 5, label: "Non for-profit organisations (e.g.,charity)" },
  { value: 6, label: "Non-EU institutional research programme" },
  { value: 7, label: "Other public funding (e.g., hospital or university)" },
  { value: 8, label: "Pharmaceutical company and other private sector" },
  { value: 9, label: "Other" },
]

export const PLANNED_ENROLLMENT_START_DATE_TYPE_JRCT = [
  {
    value: "1",
    label: "Publication Date of Implementation Plan",
    translations: {
      jp: "実施計画の公表日",
    },
  },
  {
    value: "2",
    label: "Select a date",
    translations: {
      jp: "次に掲げる日付",
    },
  },
]

export const SHARE_IPD = [
  {
    value: "Yes",
    label: "Yes",
    translations: {
      jp: "有",
    },
  },
  {
    value: "No",
    label: "No",
    translations: {
      jp: "無",
    },
  },
  {
    value: "Undecided",
    label: "Undecided",
    hideInRegistries: ["jrct"],
  },
]

export const DATA_SOURCE_TYPES = [
  { label: "Omics", value: 1 },
  { label: "Administrative data (e.g. claims)", value: 2 },
  { label: "Clinical Trial", value: 3 },
  { label: "Data from digital health wearables", value: 4 },
  { label: "Disease registry", value: 5 },
  { label: "Drug dispensing/prescription data", value: 6 },
  { label: "Drug registry", value: 7 },
  { label: "Drug utilisation data", value: 8 },
  { label: "Electronic healthcare records (HER)", value: 9 },
  { label: "Expanded access program (compassionate use)", value: 10 },
  { label: "Laboratory data", value: 11 },
  { label: "Non-interventional study", value: 12 },
  { label: "Patient surveys", value: 13 },
  { label: "Population registry", value: 14 },
  { label: "Pregnancy registry", value: 15 },
  { label: "Published literature", value: 16 },
  { label: "Social media", value: 17 },
  { label: "Spontaneous reporting system", value: 18 },
  { label: "Other", value: 19 },
]

export const CDM_NAMES = [
  { value: 1, label: "BIFAP" },
  { value: 2, label: "CDISC SDTM" },
  { value: 3, label: "ConcepTION CDM" },
  { value: 4, label: "CTcue Datamodel" },
  { value: 5, label: "EUROCAT" },
  { value: 6, label: "i2b2" },
  { value: 7, label: "NorPreSS" },
  { value: 8, label: "OMOP" },
  { value: 9, label: "PCORnet" },
  { value: 10, label: "PEDSnet" },
  { value: 11, label: "Sentinel" },
  { value: 12, label: "Vaccine Safety Datalink (VSD) Data Dictionary" },
  { value: 13, label: "TrineTX" },
  { value: 14, label: "EUROMEDICAT" },
  { value: 15, label: "Other CDM" },
]
